'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));
var _asyncToGenerator = _interopDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var _set = _interopDefault(require('lodash/fp/set'));
var _update = _interopDefault(require('lodash/fp/update'));
var _isFunction = _interopDefault(require('lodash/fp/isFunction'));
var React = require('react');
var React__default = _interopDefault(React);
var core = require('@startlibs/core');
var utils = require('@startlibs/utils');
var _property = _interopDefault(require('lodash/fp/property'));
var _uniqBy = _interopDefault(require('lodash/fp/uniqBy'));
var _identity = _interopDefault(require('lodash/fp/identity'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var components = require('@startlibs/components');
var polished = require('polished');
var reselect = require('reselect');
var _toConsumableArray = _interopDefault(require('@babel/runtime/helpers/toConsumableArray'));
var _without = _interopDefault(require('lodash/fp/without'));
var form = require('@startlibs/form');
var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var _isRegExp = _interopDefault(require('lodash/fp/isRegExp'));
var _difference = _interopDefault(require('lodash/fp/difference'));
var _union = _interopDefault(require('lodash/fp/union'));
var _flow = _interopDefault(require('lodash/fp/flow'));
var _isBoolean = _interopDefault(require('lodash/fp/isBoolean'));
var _isString = _interopDefault(require('lodash/fp/isString'));
var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var _filter = _interopDefault(require('lodash/fp/filter'));
var _map = _interopDefault(require('lodash/fp/map'));
var _stubFalse = _interopDefault(require('lodash/fp/stubFalse'));
var _isObject = _interopDefault(require('lodash/fp/isObject'));
var _isFinite = _interopDefault(require('lodash/fp/isFinite'));
var _zipObject = _interopDefault(require('lodash/fp/zipObject'));
var _flatten = _interopDefault(require('lodash/fp/flatten'));
var _fromPairs = _interopDefault(require('lodash/fp/fromPairs'));
var _pick = _interopDefault(require('lodash/fp/pick'));
var _toPairs = _interopDefault(require('lodash/fp/toPairs'));
var _negate = _interopDefault(require('lodash/fp/negate'));
var _get = _interopDefault(require('lodash/fp/get'));
var _entries = _interopDefault(require('lodash/fp/entries'));

var errorsInsidePathSelector = function errorsInsidePathSelector() {
  return reselect.createSelector([utils.identityFn(0), utils.identityFn(1)], function (path, entries) {
    return path ? entries.filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          _ = _ref2[0],
          p = _ref2[1];

      return (p + '.').indexOf(path + '.') === 0;
    }) : entries;
  });
};

var parseError = function parseError(value, path) {
  return Array.isArray(value) ? value.map(function (v) {
    return [v, utils.formatPath(path)];
  }) : [[value, utils.formatPath(path)]];
};

var parseMultipleErrors = function parseMultipleErrors(objOrArray) {
  return [].concat.apply([], (Array.isArray(objOrArray) ? objOrArray : Object.entries(objOrArray)).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        path = _ref4[0],
        value = _ref4[1];

    return parseError(value, path);
  }));
};

var ErrorsContext = React__default.createContext({});
var ErrorFilterContext = React__default.createContext(_identity);
var ErrorFilterProvider = ErrorFilterContext.Provider;
var useProvideErrors = function useProvideErrors() {
  var errors = core.useToggle([]);

  var addError = function addError(value, path) {
    return errors.openWith(function (errors) {
      return errors.concat(parseError(value, path));
    });
  };

  var addErrors = function addErrors(newErrors) {
    return errors.openWith(function (errors) {
      return errors.concat(parseMultipleErrors(newErrors));
    });
  };

  var removeError = function removeError(value, path) {
    return errors.openWith(function (errors) {
      return errors.filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            v = _ref6[0],
            p = _ref6[1];

        return !(value === v && (p + '.').indexOf(utils.formatPath(path) + '.') >= 0);
      });
    });
  };

  var removeErrorPath = function removeErrorPath(path) {
    return errors.openWith(function (errors) {
      return errors.filter(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            _ = _ref8[0],
            p = _ref8[1];

        return utils.formatPath(path) !== p;
      });
    });
  };

  var clearErrors = function clearErrors(path) {
    return errors.openWith(function (errors) {
      return path ? errors.filter(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            _ = _ref10[0],
            p = _ref10[1];

        return (p + '.').indexOf(utils.formatPath(path) + '.') < 0;
      }) : [];
    });
  };

  var setErrors = function setErrors(newErrors) {
    return errors.openWith(parseMultipleErrors(newErrors));
  };

  var setError = function setError(errorPath, errorValue) {
    return errors.openWith(parseMultipleErrors([[errorPath, errorValue]]));
  };

  var memoizeErorrsInsidePath = React.useMemo(errorsInsidePathSelector, []);

  var getErrorsInsidePath = function getErrorsInsidePath(path) {
    return memoizeErorrsInsidePath(utils.formatPath(path), errors.get());
  };

  var utils$1 = {
    addErrors: addErrors,
    addError: addError,
    setErrors: setErrors,
    setError: setError,
    clearErrors: clearErrors,
    removeError: removeError,
    willRemoveError: function willRemoveError(value, insidePath) {
      return function () {
        return removeError(value, insidePath);
      };
    },
    removeErrorPath: removeErrorPath,
    getErrorsInsidePath: getErrorsInsidePath,
    hasErrors: function hasErrors(path) {
      return getErrorsInsidePath(path).length > 0;
    },
    hasError: function hasError(path, value) {
      return getErrorsInsidePath(path).find(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 1),
            v = _ref12[0];

        return v === value;
      });
    }
  };
  var paths = React.useMemo(function () {
    return new Set(errors.isOpen.map(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
          _ = _ref14[0],
          path = _ref14[1];

      return path;
    }).filter(function (_) {
      return _;
    }));
  }, [errors.isOpen]);
  var providerValue = React.useMemo(function () {
    return _objectSpread({
      paths: paths,
      errors: errors.isOpen
    }, utils$1);
  }, [errors.isOpen]);
  return [ErrorsContext.Provider, providerValue, utils$1];
};
var useErrors = function useErrors() {
  var _useProvideErrors = useProvideErrors(),
      _useProvideErrors2 = _slicedToArray(_useProvideErrors, 3),
      Provider = _useProvideErrors2[0],
      value = _useProvideErrors2[1],
      utils = _useProvideErrors2[2];

  return [utils, React__default.createElement(Provider, {
    value: value
  }, React__default.createElement(Errors, null))];
};
var useHasError = function useHasError(path) {
  var _useContext = React.useContext(ErrorsContext),
      paths = _useContext.paths;

  return paths.has(utils.formatPath(path));
};
var useErrorsUtils = function useErrorsUtils() {
  return React.useContext(ErrorsContext);
};
var useTransientErrorHelper = function useTransientErrorHelper() {
  var utils = useErrorsUtils();
  var showingErrors = React.useRef([]);

  var clearCurrentErrors = function clearCurrentErrors() {
    showingErrors.current.forEach(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
          path = _ref16[0],
          value = _ref16[1];

      return utils === null || utils === void 0 ? void 0 : utils.removeError(value, path);
    });
    showingErrors.current = [];
  };

  var setErrors = function setErrors(newErrors) {
    clearCurrentErrors();
    utils === null || utils === void 0 ? void 0 : utils.addErrors(newErrors);
    showingErrors.current = newErrors;
  };

  React__default.useEffect(function () {
    return function () {
      clearCurrentErrors();
    };
  }, []);
  return [setErrors, clearCurrentErrors];
};
var Errors = function Errors(_ref17) {
  var path = _ref17.path,
      className = _ref17.className;

  var _useContext2 = React.useContext(ErrorsContext),
      getErrorsInsidePath = _useContext2.getErrorsInsidePath,
      willRemoveError = _useContext2.willRemoveError;

  var filter = React.useContext(ErrorFilterContext);
  var errors = filter(getErrorsInsidePath(path));

  var uniqErrors = _uniqBy(_property(0), errors);

  return React__default.createElement(components.TransitionDiv, {
    block: true
  }, errors.length > 0 && React__default.createElement(Errors.Container, {
    className: className
  }, uniqErrors.map(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 1),
        value = _ref19[0];

    return value && React__default.createElement(Errors.Item, {
      key: value
    }, value, React__default.createElement(Errors.CloseIcon, {
      onClick: willRemoveError(value, path)
    }));
  })));
};
Errors.displayName = 'Errors';
Errors.Container = styled__default.ul.withConfig({
  displayName: "Errors__Container",
  componentId: "sc-1vuw7bx-0"
})(["list-style-type:none;margin:0;padding:0;"]);
Errors.Item = styled__default.li.withConfig({
  displayName: "Errors__Item",
  componentId: "sc-1vuw7bx-1"
})(["background-color:", ";padding:1rem 3.5rem 1rem 1rem;border-radius:8px;border:1px solid ", ";color:", ";position:relative;text-align:left;& ~ &{margin-top:0.5rem;}", ""], function (props) {
  return polished.lighten(0.42, props.theme.colors.alert);
}, function (props) {
  return polished.lighten(0.35, props.theme.colors.alert);
}, utils.getColor('alert'), utils.customTheme('ErrorItem'));
Errors.CloseIcon = styled__default(components.Icon).attrs({
  icon: 'x'
}).withConfig({
  displayName: "Errors__CloseIcon",
  componentId: "sc-1vuw7bx-2"
})(["color:", ";font-weight:600;display:inline-block;background-color:", ";width:21px;height:21px;line-height:21px;text-align:center;border-radius:50%;cursor:pointer;position:absolute;top:10px;right:10px;z-index:2;&:hover{background-color:", ";}"], utils.getColor('alert'), function (props) {
  return polished.lighten(0.35, props.theme.colors.alert);
}, function (props) {
  return polished.lighten(0.32, props.theme.colors.alert);
});

var useDraftConfirmation = function useDraftConfirmation(submit, discard, meta) {
  var loading = core.useToggle();
  var dialog = core.useToggle();
  var draft = core.useRefToggle();
  var promiseResolver = core.useRefState();
  var startlibs = React.useContext(core.StartlibsContext);

  var confirmation = function confirmation() {
    var dialogType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'submit-draft';
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    if (utils.callIfFunction(draft.isOpen)) {
      dialog.openWith(dialogType);
      return new Promise(function (res) {
        return promiseResolver.set(function () {
          return function (r) {
            dialog.close();
            utils.callIfFunction(callback, r);
            res(r);
          };
        });
      });
    } else {
      return Promise.resolve();
    }
  };

  var submitAndResolve =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.open();
              _context.prev = 1;
              _context.next = 4;
              return submit();

            case 4:
              utils.callIfFunction(promiseResolver.get());
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

            case 9:
              _context.prev = 9;
              dialog.close();
              loading.close();
              return _context.finish(9);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 7, 9, 13]]);
    }));

    return function submitAndResolve() {
      return _ref.apply(this, arguments);
    };
  }();

  var discardAndResolve = function discardAndResolve() {
    utils.callIfFunction(discard);
    utils.callIfFunction(promiseResolver.get());
  };

  var Dialog = startlibs.dialogs[dialog.isOpen];

  if (process.env.NODE_ENV !== 'production') {
    if (dialog.isOpen && !Dialog) {
      console.log("Dialog [".concat(dialogType, "] not registered in startlibs.dialogs"));
    }
  }

  var feedback = dialog.isOpen ? React__default.createElement(Dialog, _extends({
    submit: submitAndResolve,
    discard: discardAndResolve,
    isLoading: loading.isOpen,
    cancel: dialog.close
  }, meta)) : null;
  return [feedback, draft, confirmation];
};

var getFormResponse = function getFormResponse(setter) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (_, v) {
    return setter(utils._s.get(path, v));
  };
};
var getFormValues = function getFormValues(setter) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (values) {
    return setter(utils._s.get(path, values));
  };
};
var FormContext = React__default.createContext({});
var ComponentMetaContext = React__default.createContext({});

var _willUseSpreadState = core.willUseSpreadState(),
    _willUseSpreadState2 = _slicedToArray(_willUseSpreadState, 3),
    useProvideValues = _willUseSpreadState2[0],
    useSpreadValue = _willUseSpreadState2[1],
    FormValueContext = _willUseSpreadState2[2];

var _willUseSpreadState3 = core.willUseSpreadState(),
    _willUseSpreadState4 = _slicedToArray(_willUseSpreadState3, 2),
    useProvideMeta = _willUseSpreadState4[0],
    useMeta = _willUseSpreadState4[1];

var useFormValue = useSpreadValue;
var useFormValueRef = function useFormValueRef() {
  var _useContext = React.useContext(FormValueContext),
      _useContext2 = _slicedToArray(_useContext, 2),
      get = _useContext2[0],
      set = _useContext2[1];

  return [get, set];
};
var useFormMeta = useMeta;
var useForm = function useForm(_ref, ref) {
  var action = _ref.action,
      _ref$alwaysSave = _ref.alwaysSave,
      alwaysSave = _ref$alwaysSave === void 0 ? false : _ref$alwaysSave,
      _ref$skipDom = _ref.skipDom,
      skipDom = _ref$skipDom === void 0 ? false : _ref$skipDom,
      _ref$values = _ref.values,
      initialValues = _ref$values === void 0 ? {} : _ref$values,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? function (v) {
    return v;
  } : _ref$transform,
      _ref$preValidation = _ref.preValidation,
      preValidation = _ref$preValidation === void 0 ? function () {
    return false;
  } : _ref$preValidation,
      loadingBeforeValidate = _ref.loadingBeforeValidate,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess,
      _ref$onFailure = _ref.onFailure,
      onFailure = _ref$onFailure === void 0 ? function () {} : _ref$onFailure,
      onChange = _ref.onChange,
      autoComplete = _ref.autoComplete;
  var outerConfig = {
    onSuccess: onSuccess,
    onFailure: onFailure,
    transform: transform,
    preValidation: preValidation,
    alwaysSave: alwaysSave,
    action: action
  };
  var currentInitialValues = core.useRefState(initialValues);
  currentInitialValues.set(initialValues);
  var startlibs = React.useContext(core.StartlibsContext);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasChanged = _useState2[0],
      setHasChangedValue = _useState2[1];

  var hasChangedRef = core.useRefState(false);
  var shouldResubmitForm = core.useToggle(false, function (next, prev) {
    return prev && !next && errorsUtils.removeErrorPath('_shouldResubmitForm');
  });
  var resubmittingForm = core.useRefState(false);
  var loading = core.useToggle();
  var isUnmounted = core.useIsUnmounted();

  var _useProvideErrors = useProvideErrors(),
      _useProvideErrors2 = _slicedToArray(_useProvideErrors, 3),
      ErrorsProvider = _useProvideErrors2[0],
      errorsContext = _useProvideErrors2[1],
      errorsUtils = _useProvideErrors2[2];

  var _useConsumerCatalog = core.useConsumerCatalog(),
      _useConsumerCatalog2 = _slicedToArray(_useConsumerCatalog, 2),
      registeredComponentMetas = _useConsumerCatalog2[0],
      componentMetasManager = _useConsumerCatalog2[1];

  var _useDraftConfirmation = useDraftConfirmation(function () {
    return submitForm(undefined, {
      isConfirming: true
    });
  }),
      _useDraftConfirmation2 = _slicedToArray(_useDraftConfirmation, 3),
      confirmDraftContent = _useDraftConfirmation2[0],
      draftToggle = _useDraftConfirmation2[1],
      draftConfirmation = _useDraftConfirmation2[2];

  var handleValuesChange = function handleValuesChange(prev, next) {
    if (!hasChangedRef.get()) {
      setHasChanged(true);
    }

    utils.callIfFunction(onChange, prev, next, utils$1);
  };

  var setHasChanged = function setHasChanged(v) {
    shouldResubmitForm.close();

    if (v !== hasChangedRef.get()) {
      draftToggle.openWith(v);
      setHasChangedValue(v);
      hasChangedRef.set(v);
    }
  };

  var _useProvideValues = useProvideValues(initialValues, handleValuesChange),
      _useProvideValues2 = _slicedToArray(_useProvideValues, 3),
      ValuesProvider = _useProvideValues2[0],
      valuesManager = _useProvideValues2[1],
      _useProvideValues2$ = _slicedToArray(_useProvideValues2[2], 2),
      getValues = _useProvideValues2$[0],
      _setValues = _useProvideValues2$[1];

  var _useProvideMeta = useProvideMeta({}, function (prev, next) {
    if (prev.submittingImage !== 0 && next.submittingImage === 0) {
      if (resubmittingForm.get()) {
        if (shouldResubmitForm.get()) {
          resubmittingForm.get().confirm();
        } else {
          resubmittingForm.get().cancel();
        }

        resubmittingForm.set(false);
      }
    }
  }),
      _useProvideMeta2 = _slicedToArray(_useProvideMeta, 3),
      MetaProvider = _useProvideMeta2[0],
      metaManager = _useProvideMeta2[1],
      _useProvideMeta2$ = _slicedToArray(_useProvideMeta2[2], 2),
      getMeta = _useProvideMeta2$[0],
      setMeta = _useProvideMeta2$[1];

  var _validate =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var values,
          validation,
          errors,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = _args.length > 0 && _args[0] !== undefined ? _args[0] : getValues();
              validation = _args.length > 1 && _args[1] !== undefined ? _args[1] : preValidation;
              _context.next = 4;
              return utils.callIfFunction(validation, values);

            case 4:
              errors = _context.sent;

              if (errors) {
                errorsUtils.setErrors(errors);
              }

              return _context.abrupt("return", errors);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function validate() {
      return _ref2.apply(this, arguments);
    };
  }();

  var verifyImagesAndSubmitForm = function verifyImagesAndSubmitForm(values) {
    if (values && getMeta('submittedImages')) {
      var valuesWithUploadedImages = getMeta('submittedImages').reduce(function (acc, _ref3) {
        var path = _ref3.path,
            file = _ref3.file,
            image = _ref3.image;

        if (utils._s.get(path, acc) === file) {
          return utils._s.set(path, image, acc);
        } else {
          return acc;
        }
      }, values);
      return submitForm(valuesWithUploadedImages);
    } else {
      return submitForm(values);
    }
  };

  var submitForm =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(optValues) {
      var config,
          values,
          _outerConfig$config,
          onSuccess,
          onFailure,
          transform,
          alwaysSave,
          preValidation,
          action,
          errors,
          request,
          response,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

              if (!loading.get()) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", new Promise(function () {}));

            case 3:
              values = utils.ifUndefined(utils.callIfFunction(optValues, getValues()), getValues());

              if (!getMeta('submittingImage')) {
                _context2.next = 10;
                break;
              }

              shouldResubmitForm.open();
              errorsUtils.setError('_shouldResubmitForm', startlibs.FormUploadingImageError);

              if (!config.isConfirming) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", Promise.reject());

            case 9:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                resubmittingForm.set({
                  confirm: function confirm() {
                    return resolve(verifyImagesAndSubmitForm(values));
                  },
                  cancel: function cancel() {
                    return reject();
                  }
                });
              }));

            case 10:
              _outerConfig$config = _objectSpread({}, outerConfig, config), onSuccess = _outerConfig$config.onSuccess, onFailure = _outerConfig$config.onFailure, transform = _outerConfig$config.transform, alwaysSave = _outerConfig$config.alwaysSave, preValidation = _outerConfig$config.preValidation, action = _outerConfig$config.action;

              if (preValidation && loadingBeforeValidate) {
                loading.open();
              }

              _context2.next = 14;
              return _validate(values, preValidation);

            case 14:
              errors = _context2.sent;

              if (!errors) {
                _context2.next = 18;
                break;
              }

              loading.close();
              throw {
                unvalidated: errors
              };

            case 18:
              request = transform(values);

              if (request) {
                _context2.next = 24;
                break;
              }

              loading.close();
              return _context2.abrupt("return", {
                untransformed: true
              });

            case 24:
              loading.open();

              if (!(!alwaysSave && !hasChangedRef.get() && (!values || values === getValues()))) {
                _context2.next = 30;
                break;
              }

              _context2.next = 28;
              return onSuccess(request);

            case 28:
              if (!isUnmounted()) {
                loading.close();
              }

              return _context2.abrupt("return", {
                unrequested: request
              });

            case 30:
              _context2.prev = 30;
              _context2.next = 33;
              return action(request);

            case 33:
              response = _context2.sent;
              _context2.next = 36;
              return onSuccess(request, response);

            case 36:
              if (!isUnmounted()) {
                setHasChanged(false);
                loading.close();
              }

              return _context2.abrupt("return", {
                request: request,
                response: response
              });

            case 40:
              _context2.prev = 40;
              _context2.t0 = _context2["catch"](30);

              if (_context2.t0[0] && _context2.t0[0].errors) {
                errorsUtils.setErrors(_context2.t0[0].errors);
              }

              _context2.next = 45;
              return onFailure(request, _context2.t0, utils$1);

            case 45:
              if (!isUnmounted()) {
                loading.close();
              }

              throw {
                request: request,
                rejection: _context2.t0
              };

            case 47:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[30, 40]]);
    }));

    return function submitForm(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var willSubmitForm = function willSubmitForm(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    return submitForm();
  };

  var inputs = [loading, hasChanged, errorsContext, initialValues, transform, preValidation, onSuccess, onFailure, alwaysSave, action, shouldResubmitForm];
  var utils$1 = React.useMemo(function () {
    return _objectSpread({
      setValue: function setValue(path, value) {
        var hasChanged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _setValues(_isFunction(value) ? _update(path, value) : _set(path, value), path, hasChanged ? null : {
          ignoreCallback: true
        });
      },
      setValues: function setValues(valuesSetter) {
        var hasChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _setValues(valuesSetter, undefined, hasChanged ? null : {
          ignoreCallback: true
        });
      },
      resetForm: function resetForm() {
        _setValues(utils.ifUndefined(currentInitialValues.get(), {}));

        setHasChanged(false);
      },
      resetField: function resetField(path) {
        var initialValue = utils._s.get(path, currentInitialValues.get());

        if (initialValue !== getValues(path)) {
          _setValues(utils._s.set(path, initialValue));
        }
      },
      getOriginalValues: function getOriginalValues() {
        return currentInitialValues.get();
      },
      getOriginalValue: function getOriginalValue(path) {
        return utils._s.get(path, currentInitialValues.get());
      },
      getValues: getValues,
      getValue: getValues,
      getTransformedValues: function getTransformedValues() {
        return transform(getValues());
      },
      setHasChanged: setHasChanged,
      setMeta: setMeta,
      getMeta: getMeta,
      confirm: draftConfirmation,
      validate: function validate(props, validation) {
        return !_validate(props, validation);
      },
      submitForm: submitForm,
      willSubmitForm: willSubmitForm,
      isLoading: loading.isOpen || shouldResubmitForm.isOpen,
      hasChanged: hasChanged,
      getHasChanged: function getHasChanged() {
        return hasChangedRef.get();
      }
    }, errorsUtils);
  }, inputs);
  React.useImperativeHandle(ref, function () {
    return utils$1;
  }, inputs);
  return [function (children) {
    return React__default.createElement(FormContext.Provider, {
      value: utils$1
    }, React__default.createElement(ComponentMetaContext.Provider, {
      value: componentMetasManager
    }, React__default.createElement(ValuesProvider, {
      value: valuesManager
    }, React__default.createElement(MetaProvider, {
      value: metaManager
    }, React__default.createElement(ErrorsProvider, {
      value: errorsContext
    }, !skipDom ? React__default.createElement("form", {
      autoComplete: autoComplete,
      noValidate: true,
      onSubmit: willSubmitForm
    }, utils.callIfFunction(children, utils$1)) : utils.callIfFunction(children, utils$1))))), confirmDraftContent);
  }, utils$1];
};
var WithForm = React.forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return useForm(rest, ref)[0](children);
});
var Form = function Form(_ref6) {
  var transform = _ref6.transform,
      preValidation = _ref6.preValidation,
      onSuccess = _ref6.onSuccess,
      onFailure = _ref6.onFailure,
      children = _ref6.children;
  var form = React.useContext(FormContext);

  var onSubmit = function onSubmit(e) {
    if (e) e.preventDefault();
    return form.submitForm(undefined, undefined, {
      transform: transform,
      preValidation: preValidation,
      onSuccess: onSuccess,
      onFailure: onFailure
    });
  };

  return typeof children === 'function' ? children(onSubmit) : React__default.createElement("form", {
    noValidate: true,
    onSubmit: onSubmit
  }, children);
};

var withForm = function withForm(Component) {
  return React__default.forwardRef(function (props, ref) {
    return React__default.createElement(WithForm, props, function (form) {
      return React__default.createElement(Component, _extends({
        form: form
      }, props, {
        ref: ref
      }));
    });
  });
};
var withForm2 = function withForm2() {
  return function (Component) {
    return React__default.forwardRef(function (props, ref) {
      return React__default.createElement(WithForm, props, function (form) {
        return React__default.createElement(Component, _extends({
          form: form
        }, props, {
          ref: ref
        }));
      });
    });
  };
};

var PathContext = React__default.createContext([]);
var enhancedInputDisplayName = 'EnhancedInput';

var skipValidation = function skipValidation() {
  return true;
};

var itemToggle = function itemToggle(item) {
  return function () {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return list.indexOf(item) >= 0 ? _without([item], list) : _toConsumableArray(list).concat([item]);
  };
};

var formInput = function formInput(_ref) {
  var undefinedPlaceholder = _ref.undefinedPlaceholder,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? _identity : _ref$isChecked,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? _identity : _ref$transform,
      _ref$validation = _ref.validation,
      validation = _ref$validation === void 0 ? skipValidation : _ref$validation,
      onChange = _ref.onChange,
      fieldValue = _ref.fieldValue,
      propPath = _ref.path;
  var contextPath = React.useContext(PathContext);

  var _useContext = React.useContext(ErrorsContext),
      paths = _useContext.paths;

  var path = utils.ifUndefined(propPath, contextPath);
  var formattedPath = utils.formatPath(path);

  var _useFormValue = useFormValue(formattedPath),
      _useFormValue2 = _slicedToArray(_useFormValue, 2),
      formValue = _useFormValue2[0],
      setFormValue = _useFormValue2[1];

  var setValue = function setValue(value, element) {
    if (!validation(value, path)) {
      return;
    }

    setFormValue(transform(value, {
      path: path,
      prevValue: formValue
    }));
    utils.callIfFunction(onChange, utils.callIfFunction(value, formValue), {
      prevValue: formValue,
      path: path,
      element: element
    });
  };

  var setValueFromEventTarget = function setValueFromEventTarget(e) {
    return setValue(e.currentTarget.value, e.currentTarget);
  };

  var setFromField = function setFromField() {
    return setValue(fieldValue);
  };

  var toggle = function toggle() {
    return setValue(!isChecked(formValue) ? fieldValue || true : !!fieldValue && undefined);
  };

  var toggleItem = function toggleItem() {
    return setValue(itemToggle(fieldValue));
  };

  return [utils.ifUndefined(formValue, undefinedPlaceholder), setValue, {
    hasErrors: paths.has(formattedPath),
    setFromField: setFromField,
    toggle: toggle,
    toggleItem: toggleItem,
    name: formattedPath,
    setValueFromEventTarget: setValueFromEventTarget
  }];
};

var rawInput = function rawInput(_ref2) {
  var value = _ref2.value,
      _ref2$isChecked = _ref2.isChecked,
      isChecked = _ref2$isChecked === void 0 ? _identity : _ref2$isChecked,
      name = _ref2.name,
      setValueProp = _ref2.setValue,
      _ref2$validation = _ref2.validation,
      validation = _ref2$validation === void 0 ? skipValidation : _ref2$validation,
      _ref2$transform = _ref2.transform,
      transform = _ref2$transform === void 0 ? _identity : _ref2$transform,
      onChange = _ref2.onChange,
      fieldValue = _ref2.fieldValue,
      defaultValue = _ref2.defaultValue;

  var _useState = React.useState(utils.ifUndefined(value, defaultValue)),
      _useState2 = _slicedToArray(_useState, 2),
      rawValue = _useState2[0],
      setRawValue = _useState2[1];

  React.useEffect(function () {
    setRawValue(value);
  }, [value]);

  var setValue = function setValue(value, element) {
    if (!validation(value)) {
      return;
    }

    var transformedValue = transform(value);
    setValueProp(transformedValue, element);
    utils.callIfFunction(onChange, transformedValue, rawValue, {
      element: element
    });
  };

  var setValueFromEventTarget = function setValueFromEventTarget(e) {
    return setValue(e.currentTarget.value, e.currentTarget);
  };

  var setFromField = function setFromField() {
    return setValue(fieldValue);
  };

  var toggle = function toggle() {
    return setValue(!isChecked(rawValue));
  };

  var toggleItem = function toggleItem() {
    return setValue(itemToggle(fieldValue));
  };

  return [value, setValue, {
    setFromField: setFromField,
    name: name,
    toggle: toggle,
    toggleItem: toggleItem,
    setValueFromEventTarget: setValueFromEventTarget
  }];
};

var useInput = function useInput(props, raw) {
  var _useState3 = React.useState(raw),
      _useState4 = _slicedToArray(_useState3, 1),
      isRaw = _useState4[0];

  return isRaw ? rawInput(props) : formInput(props);
};
var EnhanceInput = function EnhanceInput(_ref3) {
  var raw = _ref3.raw,
      props = _objectWithoutProperties(_ref3, ["raw"]);

  var _useInput = useInput(props, raw),
      _useInput2 = _slicedToArray(_useInput, 3),
      value = _useInput2[0],
      setValue = _useInput2[1],
      utils = _useInput2[2];

  return props.children(_objectSpread({
    path: props.path,
    value: value,
    setValue: setValue
  }, utils));
};
var enhanceInput = function enhanceInput(InputComponent) {
  return React__default.forwardRef(function (_ref4, ref) {
    var props = _extends({}, _ref4);

    return React__default.createElement(EnhanceInput, props, function (formInput) {
      return React__default.createElement(InputComponent, _extends({}, props, {
        ref: ref,
        formInput: formInput
      }));
    });
  });
};

var Mandatory = styled__default.span.withConfig({
  displayName: "Field__Mandatory",
  componentId: "p9woft-0"
})(["color:#c3282d;margin-left:1px;vertical-align:top;line-height:100%;margin-top:-1px;", ""], function (props) {
  return typeof props.mandatory === 'string' && "color: ".concat(props.mandatory, ";");
});
var Container = styled__default.div.withConfig({
  displayName: "Field__Container",
  componentId: "p9woft-1"
})(["position:relative;margin-bottom:", ";text-align:left;"], function (props) {
  return utils.getMargin(props.theme.Field.margins)(props);
});
var Label = styled__default.label.withConfig({
  displayName: "Field__Label",
  componentId: "p9woft-2"
})(["font-weight:500;display:inline-block;font-size:14px;margin-bottom:.5rem;", " ", ""], function (props) {
  return props.isOnImage && 'color: #fff;';
}, utils.customTheme("FieldLabel"));
var HelpText = styled__default.span.withConfig({
  displayName: "Field__HelpText",
  componentId: "p9woft-3"
})(["color:rgba(0,0,0,0.4);font-weight:400;"]);
var FieldDescription = styled__default.span.withConfig({
  displayName: "Field__FieldDescription",
  componentId: "p9woft-4"
})(["color:rgba(0,0,0,0.4);display:block;font-size:12px;margin:0.25rem 0 0;font-weight:400;"]);
var BellowFieldDescription = styled__default(FieldDescription).withConfig({
  displayName: "Field__BellowFieldDescription",
  componentId: "p9woft-5"
})(["margin:0.5rem 0 0;"]);
var Field = React__default.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      helpText = _ref.helpText,
      descText = _ref.descText,
      bellowDescText = _ref.bellowDescText,
      className = _ref.className,
      labelClick = _ref.labelClick,
      focused = _ref.focused,
      mandatory = _ref.mandatory,
      onImage = _ref.onImage,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["label", "helpText", "descText", "bellowDescText", "className", "labelClick", "focused", "mandatory", "onImage", "children"]);

  return React__default.createElement(Container, _extends({
    ref: ref
  }, rest, {
    className: className
  }), label && React__default.createElement(Label, _extends({}, rest, {
    onClick: labelClick
  }), label, mandatory && React__default.createElement(Mandatory, {
    mandatory: mandatory
  }, "*"), helpText && React__default.createElement(HelpText, null, " ", helpText), descText && React__default.createElement(FieldDescription, null, descText)), children, bellowDescText && React__default.createElement(BellowFieldDescription, null, bellowDescText));
});
Field.Label = Label;
Field.Container = Container;
Field.HelpText = HelpText;
Field.Description = FieldDescription;
Field.displayName = "Field";

var addExtraProp = function addExtraProp(element, extra) {
  var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return React__default.cloneElement(element, override ? _objectSpread({}, element.props, extra) : _objectSpread({}, extra, element.props), element.props.children);
};

var useConfirmDialog = function useConfirmDialog(dialog, args, toggleCallback) {
  return components.useDialog(function (closeDialog) {
    return addExtraProp(utils.callIfFunction(dialog, closeDialog), {
      closeDialog: closeDialog
    });
  }, args, toggleCallback);
};
var useConfirmDialogWithProps = function useConfirmDialogWithProps(dialog, args) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$overrideClose = _ref.overrideClose,
      overrideClose = _ref$overrideClose === void 0 ? true : _ref$overrideClose;

  return components.useDialogWithToggle(function (toggle) {
    return addExtraProp(utils.callIfFunction(dialog, toggle.isOpen, toggle.close), {
      closeDialog: toggle.close
    }, overrideClose);
  }, args);
};
var ConfirmDialog = function ConfirmDialog(_ref2) {
  var _ref2$action = _ref2.action,
      action = _ref2$action === void 0 ? _identity : _ref2$action,
      _onSuccess = _ref2.onSuccess,
      className = _ref2.className,
      closeDialog = _ref2.closeDialog,
      skipCloseIcon = _ref2.skipCloseIcon,
      _ref2$cancelLabel = _ref2.cancelLabel,
      cancelLabel = _ref2$cancelLabel === void 0 ? "Cancelar" : _ref2$cancelLabel,
      _ref2$cancelButton = _ref2.cancelButton,
      cancelButton = _ref2$cancelButton === void 0 ? React__default.createElement(components.Button, null, cancelLabel) : _ref2$cancelButton,
      onFailure = _ref2.onFailure,
      title = _ref2.title,
      keepOnSuccess = _ref2.keepOnSuccess,
      confirm = _ref2.confirm,
      formRef = _ref2.formRef,
      children = _ref2.children,
      preValidation = _ref2.preValidation,
      values = _ref2.values,
      onChange = _ref2.onChange,
      alternativeButton = _ref2.alternativeButton,
      notify = _ref2.notify,
      confirmChanges = _ref2.confirmChanges,
      transform = _ref2.transform,
      isLoading = _ref2.isLoading;
  return React__default.createElement(form.WithForm, {
    alwaysSave: true,
    ref: formRef,
    preValidation: preValidation,
    values: values,
    action: action,
    transform: transform,
    onFailure: onFailure,
    onChange: onChange,
    onSuccess: function onSuccess() {
      for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
      }

      return Promise.resolve(utils.callIfFunction.apply(void 0, [_onSuccess].concat(props))).then(function (v) {
        if (!keepOnSuccess) {
          closeDialog();
        }

        if (notify) {
          components.setNotification(notify);
        }

        return v;
      });
    }
  }, function (form$1) {
    return React__default.createElement(components.Dialog, {
      className: className,
      title: title,
      skipCloseIcon: skipCloseIcon,
      confirmChanges: confirmChanges,
      isLoading: isLoading,
      closeDialog: closeDialog,
      form: form$1,
      footer: React__default.createElement(React__default.Fragment, null, cancelButton && addExtraProp(utils.callIfFunction(cancelButton, closeDialog), {
        onClick: closeDialog
      }, false), utils.callIfFunction(alternativeButton, closeDialog), confirm && addExtraProp(confirm, {
        isLoading: form$1.isLoading,
        type: "submit"
      }))
    }, utils.callIfFunction(children, form$1), React__default.createElement(form.Errors, null));
  });
};
var FormDialog = ConfirmDialog;

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding: 1rem;\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    height: 42px;\n    padding: 0 1rem;\n    @supports (-webkit-touch-callout: none) {\n      font-size: 16px;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var InputLoading = styled__default(components.Loading).withConfig({
  displayName: "TextInput__InputLoading",
  componentId: "yzpeng-0"
})(["bottom:8px;right:0.6rem;left:auto;top:auto;"]);
var Input = styled__default.input.withConfig({
  displayName: "TextInput__Input",
  componentId: "yzpeng-1"
})(["width:100%;font-size:14px;border:1px solid ", ";border-radius:6px;outline:0;outline:none;color:", ";background:white;position:relative;height:3rem;padding:0 0.7rem;overflow:auto;", "::-webkit-input-placeholder{color:rgba(0,0,0,0.3);}::-moz-placeholder{color:rgba(0,0,0,0.3);}:-moz-placeholder{color:rgba(0,0,0,0.3);}:-ms-input-placeholder{color:rgba(0,0,0,0.3);}", "::-ms-clear{display:none;}", " ", " ", ""], utils.getColor('gray210'), utils.getColor('gray60'), utils.media.mobile(_templateObject()), function (props) {
  return !props.hasTextBox && styled.css([":focus{border-color:", ";box-shadow:0px 0px 0px 2px rgba(0,0,0,0.1);}", ""], utils.getColor('gray180'), function (props) {
    return props.hasErrors && styled.css(["border-color:", " !important;"], utils.getColor('alert'));
  });
}, function (props) {
  return props.locked && styled.css(["padding-right:2.25rem;background:rgba(0,0,0,0.075);"]);
}, function (props) {
  return props.isTextArea && styled.css(["resize:none;min-height:", "px;padding:.7rem;display:block;", " ", ""], function (props) {
    return props.regularInputHeight ? 36 : props.minHeight || 60;
  }, function (props) {
    return props.autoResize ? 'overflow:hidden;' : 'overflow:auto;';
  }, utils.media.mobile(_templateObject2(), function (props) {
    return props.regularInputHeight && 'min-height: 42px;';
  }));
}, utils.customTheme('TextInput'));
var InputWithTextBox = styled__default.div.withConfig({
  displayName: "TextInput__InputWithTextBox",
  componentId: "yzpeng-2"
})(["display:flex;border-radius:6px;position:relative;:before{position:absolute;border-radius:6px;top:0;bottom:0;right:0;left:0;z-index:2;pointer-events:none;}", " ", " ", ""], function (props) {
  return props.focused && styled.css(["box-shadow:0px 0px 0px 2px rgba(0,0,0,0.1);:before{content:'';border:1px solid ", ";}"], utils.getColor('gray180'));
}, function (props) {
  return props.hasErrors && styled.css([":before{content:'';border:1px solid ", ";}"], utils.getColor('alert'));
}, function (props) {
  return (props.textBoxBefore || props.textBoxAfter) && styled.css(["input{border-top-left-radius:0;border-bottom-left-radius:0;}"]);
});
var TextBox = styled__default.span.withConfig({
  displayName: "TextInput__TextBox",
  componentId: "yzpeng-3"
})(["display:flex;align-items:center;padding:0 0.7rem;z-index:1;background-color:", ";border:1px solid ", ";cursor:text;white-space:nowrap;"], function (props) {
  return polished.darken(0.075, utils.getColor('gray240')(props));
}, utils.getColor('gray210'));
var TextBoxBefore = styled__default(TextBox).withConfig({
  displayName: "TextInput__TextBoxBefore",
  componentId: "yzpeng-4"
})(["border-top-left-radius:6px;border-bottom-left-radius:6px;margin-right:-1px;"]);
var TextBoxAfter = styled__default(TextBox).withConfig({
  displayName: "TextInput__TextBoxAfter",
  componentId: "yzpeng-5"
})(["border-top-right-radius:6px;border-bottom-right-radius:6px;margin-left:-1px;"]);
var InputIcon = styled__default(components.Icon).withConfig({
  displayName: "TextInput__InputIcon",
  componentId: "yzpeng-6"
})(["position:absolute;outline:none;bottom:0;font-size:21px;line-height:3rem;right:0;width:2rem;pointer-events:none;color:", ";"], utils.getColor('gray150'));

var doAutoResize = function doAutoResize(element) {
  var scrollContainer = utils.getScrollParent(element);
  var lastTop = scrollContainer.scrollTop || scrollContainer.pageYOffset;
  element.style.height = 'auto';
  element.style.height = element.scrollHeight + 'px';

  if (scrollContainer === window) {
    scrollContainer.scroll(scrollContainer.pageXOffset, lastTop);
  } else {
    scrollContainer.scrollTop = lastTop;
  }
};

var useTextInput = function useTextInput(_ref, ref) {
  var onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      autoResize = _ref.autoResize,
      constraint = _ref.constraint,
      pattern = _ref.pattern,
      path = _ref.path,
      rawValue = _ref.rawValue,
      rawSetValue = _ref.rawSetValue,
      rawHasErrors = _ref.rawHasErrors,
      transformOnBlur = _ref.transformOnBlur,
      raw = _ref.raw,
      rest = _objectWithoutProperties(_ref, ["onFocus", "onBlur", "autoResize", "constraint", "pattern", "path", "rawValue", "rawSetValue", "rawHasErrors", "transformOnBlur", "raw"]);

  var _useInput = useInput(_objectSpread({
    path: path,
    value: rawValue,
    setValue: rawSetValue
  }, rest), raw),
      _useInput2 = _slicedToArray(_useInput, 3),
      formValue = _useInput2[0],
      setFormValue = _useInput2[1],
      hasErrors = _useInput2[2].hasErrors;

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var lastSelection = core.useRefState();
  var lastValue = core.useRefState(formValue);

  var handleOnFocus = function handleOnFocus(e) {
    setFocused(true);
    utils.callIfFunction(onFocus, e);
  };

  var handleOnBlur = function handleOnBlur(e) {
    setFocused(false);
    utils.callIfFunction(onBlur, e);

    if (transformOnBlur) {
      setFormValue(transformOnBlur(formValue));
    }
  };

  React.useEffect(function () {
    if (lastSelection.get() === 1 && constraint === 'capitalize') {
      ref.current.setSelectionRange(lastSelection.get(), lastSelection.get());
    }
  });
  React.useEffect(function () {
    if (autoResize) {
      doAutoResize(ref.current);
    }
  }, []);

  var handleChange = function handleChange(e) {
    if (autoResize) {
      doAutoResize(ref.current);
    }

    var target = e.target;

    try {
      lastSelection.set(target.selectionEnd);
    } catch (e) {}

    if (constraint || pattern) {
      setFormValue(validateConstraint(target.value, constraint, formValue, pattern), ref.current);
    } else {
      setFormValue(target.value, ref.current);
    }
  };

  var validateConstraint = function validateConstraint(value, constraint, prevValue, pattern) {
    var newValue = '';

    if (value === lastValue.get() || lastValue.get() && value.length < lastValue.get().length && !pattern) {
      lastValue.set(value);
      return value;
    }

    if (pattern) {
      var _value$match, _value$match$slice;

      newValue = ((_value$match = value.match(pattern)) === null || _value$match === void 0 ? void 0 : (_value$match$slice = _value$match.slice(1)) === null || _value$match$slice === void 0 ? void 0 : _value$match$slice.join("")) || ""; // if (newValue.length < value.length - 1) {
      //   newValue = value
      // }
    } else if (constraint === 'price') {
      value = value.replace('.', ',').replace(/[^0-9,]/g, '');
      var number = parseFloat(value.replace(',', '.'));
      var commas = value.split(',');
      var fixedNumber = number.toFixed(2);
      newValue = !!commas[0] && commas.length === 2 && parseFloat(fixedNumber) === number && fixedNumber.split('.')[1].indexOf(commas[1]) === 0 ? value : utils.digitsToPattern('>3???????#,##', value);
    } else if (constraint === 'capitalize') {
      // v = "R$ "+(parseInt(v.replace(/[^1-9]*([0-9]*)(,?)([0-9]{0,3}).*/,"$1$3") || 0)/100).toFixed(2).replace(".",",");
      newValue = value.replace(/^[a-z]/, function (e) {
        return e.toUpperCase();
      });
    } else if (constraint === 'number' || constraint === 'hour' || constraint === 'hour-int') {
      newValue = value.replace(/\D/g, '');

      if (newValue !== '') {
        newValue = window.parseInt(newValue, 10);

        if (constraint !== 'number') {
          if ((newValue + '').length > 4 || newValue > 2399) {
            newValue = prevValue;
          } else {
            var resultHour = utils.intToHour(newValue, false);
            var val = resultHour.replace(/\D/g, '');
            var result = isNaN(parseInt(val, 10)) ? undefined : parseInt(val, 10);
            newValue = constraint === 'hour-int' ? result : resultHour;
          }
        }
      }
    } else if (constraint === 'cpf') {
      newValue = utils.digitsToPattern('###.###.###-##', value);
    } else if (constraint === 'cnpj') {
      newValue = utils.digitsToPattern('##.###.###/####-##', value);
    } else if (_isFunction(constraint)) {
      newValue = constraint(value);
    } else if (_isRegExp(constraint)) {
      newValue = value.replace(constraint, '');
    } else {
      newValue = utils.digitsToPattern(constraint, value);
    }

    lastValue.set(newValue);
    return newValue;
  };

  return [formValue, {
    onChange: handleChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur
  }, rawHasErrors || hasErrors, focused];
};
var TextInput = styled__default(React.forwardRef(function (_ref2, forwardedRef) {
  var _ref2$showValue = _ref2.showValue,
      showValue = _ref2$showValue === void 0 ? _identity : _ref2$showValue,
      label = _ref2.label,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'text' : _ref2$type,
      helpText = _ref2.helpText,
      descText = _ref2.descText,
      bellowDescText = _ref2.bellowDescText,
      mandatory = _ref2.mandatory,
      isLoading = _ref2.isLoading,
      locked = _ref2.locked,
      textBoxBefore = _ref2.textBoxBefore,
      textBoxAfter = _ref2.textBoxAfter,
      className = _ref2.className,
      _ref2$fieldClassName = _ref2.fieldClassName,
      fieldClassName = _ref2$fieldClassName === void 0 ? '' : _ref2$fieldClassName,
      _ref2$FieldType = _ref2.FieldType,
      FieldType = _ref2$FieldType === void 0 ? Field : _ref2$FieldType,
      rawValue = _ref2.value,
      rawSetValue = _ref2.setValue,
      rawHasErrors = _ref2.hasErrors,
      _ref2$textarea = _ref2.textarea,
      textarea = _ref2$textarea === void 0 ? false : _ref2$textarea,
      _ref2$onImage = _ref2.onImage,
      onImage = _ref2$onImage === void 0 ? false : _ref2$onImage,
      autoFocus = _ref2.autoFocus,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      pattern = _ref2.pattern,
      autoResize = _ref2.autoResize,
      constraint = _ref2.constraint,
      path = _ref2.path,
      raw = _ref2.raw,
      _ref2$tabIndex = _ref2.tabIndex,
      tabIndex = _ref2$tabIndex === void 0 ? 1 : _ref2$tabIndex,
      rest = _objectWithoutProperties(_ref2, ["showValue", "label", "type", "helpText", "descText", "bellowDescText", "mandatory", "isLoading", "locked", "textBoxBefore", "textBoxAfter", "className", "fieldClassName", "FieldType", "value", "setValue", "hasErrors", "textarea", "onImage", "autoFocus", "onFocus", "onBlur", "pattern", "autoResize", "constraint", "path", "raw", "tabIndex"]);

  var ref = core.useEnsureRef(forwardedRef);

  var _useTextInput = useTextInput(_objectSpread({
    path: path,
    onFocus: onFocus,
    onBlur: onBlur,
    autoResize: autoResize,
    constraint: constraint,
    pattern: pattern,
    rawValue: rawValue,
    rawSetValue: rawSetValue,
    rawHasErrors: rawHasErrors,
    raw: raw
  }, rest), ref),
      _useTextInput2 = _slicedToArray(_useTextInput, 4),
      value = _useTextInput2[0],
      events = _useTextInput2[1],
      hasErrors = _useTextInput2[2],
      focused = _useTextInput2[3];

  var inputTag = textarea ? 'textarea' : 'input';

  var focusInput = function focusInput() {
    return ref.current.focus();
  };

  var WithTextBox = function WithTextBox(input) {
    if (textBoxBefore) {
      return React__default.createElement(InputWithTextBox, {
        focused: focused,
        hasErrors: hasErrors,
        onClick: focusInput,
        textBoxBefore: true
      }, React__default.createElement(TextBoxBefore, null, textBoxBefore), input);
    } else if (textBoxAfter) {
      return React__default.createElement(InputWithTextBox, {
        focused: focused,
        hasErrors: hasErrors,
        onClick: focusInput
      }, input, React__default.createElement(TextBoxAfter, null, textBoxAfter));
    } else {
      return input;
    }
  };

  var input = WithTextBox(React__default.createElement(Input, _extends({}, rest, {
    as: inputTag,
    className: !label ? className : undefined,
    isTextArea: textarea,
    "data-hj-whitelist": type !== "password",
    locked: locked,
    autoFocus: !utils.isTouchDevice() && autoFocus,
    hasErrors: hasErrors,
    isOnImage: onImage,
    ref: ref,
    tabIndex: tabIndex,
    type: type,
    value: utils.ifUndefined(showValue(value), ''),
    hasTextBox: textBoxBefore || textBoxAfter,
    autoResize: autoResize,
    rows: 1
  }, events)));
  return !label ? input : React__default.createElement(FieldType, {
    className: fieldClassName + ' ' + className,
    value: value,
    focused: focused,
    mandatory: mandatory,
    isOnImage: onImage,
    descText: descText,
    bellowDescText: bellowDescText,
    helpText: helpText,
    label: label,
    labelClick: focusInput
  }, isLoading && React__default.createElement(InputLoading, {
    absolute: true,
    size: 20
  }), input, locked && React__default.createElement(InputIcon, {
    icon: "lock"
  }));
})).withConfig({
  displayName: "TextInput",
  componentId: "yzpeng-7"
})([""]);
TextInput.Input = Input;
var FloatingFieldType = styled__default(Field).withConfig({
  displayName: "TextInput__FloatingFieldType",
  componentId: "yzpeng-8"
})(["input{height:5rem;box-shadow:0 1px 4px rgba(0,0,0,.2);border-radius:4px;font-size:16px;font-weight:400;padding:16px 1rem 0;}", "{position:absolute;top:1.5rem;left:1rem;font-size:20px;font-weight:normal;transition:all .2s ease;color:rgba(0,0,0,.2);pointer-events:none;z-index:1;", "}"], Field.Label, function (props) {
  return (props.value || props.focused) && "\n        top: 12px;\n        font-size: 14px;\n        color: rgba(0,0,0,.4);\n      ";
});
var FloatLabelTextInput = function FloatLabelTextInput(props) {
  return React__default.createElement(TextInput, _extends({}, props, {
    FieldType: FloatingFieldType
  }));
};

var FileInput = styled__default.input.attrs({
  type: 'file'
}).withConfig({
  displayName: "withFormImageInput__FileInput",
  componentId: "o7trbb-0"
})(["z-index:1;cursor:pointer;opacity:0;position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%;overflow:hidden;::-webkit-file-upload-button{visibility:hidden;}::file-upload-button{visibility:hidden;}"]);
var WithImageInput = function WithImageInput(_ref) {
  var children = _ref.children,
      multiple = _ref.multiple,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? ["image"] : _ref$path,
      preValidation = _ref.preValidation,
      onChangeFile = _ref.onChangeFile,
      onClose = _ref.onClose,
      onClick = _ref.onClick,
      uploadFetcher = _ref.uploadFetcher,
      onSuccess = _ref.onSuccess,
      ajaxError = _ref.ajaxError,
      onTouchEnd = _ref.onTouchEnd,
      rest = _objectWithoutProperties(_ref, ["children", "multiple", "path", "preValidation", "onChangeFile", "onClose", "onClick", "uploadFetcher", "onSuccess", "ajaxError", "onTouchEnd"]);

  var form = React.useContext(FormContext);
  var loading = core.useToggle();

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      tempImage = _useState2[0],
      setTempImage = _useState2[1];

  var getPath = function getPath(str) {
    var fileIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return typeof path === 'function' ? [].concat(path(str, fileIndex)) : str !== 'image' ? [].concat(path).slice(0, -1).concat(str) : path;
  };

  var imagePath = getPath('image');

  var _useFormValue = useFormValue(imagePath),
      _useFormValue2 = _slicedToArray(_useFormValue, 1),
      formImage = _useFormValue2[0];

  var image = tempImage || formImage;

  var validate = function validate(files) {
    var validations = files.map(preValidation).filter(Boolean);

    if (validations.length) {
      validations.forEach(function (v) {
        return form.setError(getPath('image').join('.'), v);
      });
      return files.filter(function (file) {
        return !preValidation(file);
      });
    }

    return files;
  };

  var handleFileEvent = function handleFileEvent(e) {
    e.preventDefault();
    utils.callIfFunction(onClose);
    var files = Array.from((e.nativeEvent.dataTransfer || e.nativeEvent.target).files);

    if (files.length > 0) {
      validate(files.slice(0, multiple ? undefined : 1)).forEach(function (file, i) {
        return handleFile(file, e, i);
      });
    }
  };

  var handleFile = function handleFile(file, eventTarget) {
    var fileIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var getIndexedPath = function getIndexedPath(str) {
      return getPath(str, fileIndex);
    };

    var path = getIndexedPath();
    var oldUploadStatus = form.getMeta(getIndexedPath('uploadStatus'));
    var oldImage = form.getValue(getIndexedPath('image'));
    var oldImageHeight = form.getValue(getIndexedPath('imageHeight'));
    var oldImageWidth = form.getValue(getIndexedPath('imageWidth'));
    var oldFilename = form.getValue(getIndexedPath('fileName'));
    var objectUrl = URL.createObjectURL(file);
    var image = document.createElement('img');

    image.onload = function () {
      var imageWidth = image.naturalWidth,
          imageHeight = image.naturalHeight;
      var newValues = {
        image: file,
        filename: file.name,
        imageWidth: imageWidth,
        imageHeight: imageHeight
      };
      form.setValues(_flow(_set(getIndexedPath('filename'), file.name), _set(getIndexedPath('image'), file), _set(getIndexedPath('imageWidth'), imageWidth), _set(getIndexedPath('imageHeight'), imageHeight)));
      form.setMeta(_flow(_update('submittingImage', function (v) {
        return v ? v + 1 : 1;
      }), _update('uploadingPaths', _union([path.join(".")])), _set(getIndexedPath('uploadStatus'), 'loading')));
      setTempImage(objectUrl);
      utils.callIfFunction(onChangeFile, file);
      loading.open();
      uploadFetcher(file, newValues).then(function (_ref2) {
        var image = _ref2.image,
            uploadStatus = _ref2.uploadStatus;
        loading.close();

        if (form.getValue(getIndexedPath('image')) !== file) {
          form.setMeta(_update(['submittingImage'], function (v) {
            return v - 1;
          }));
          return;
        }

        form.clearErrors();
        form.setValue(getIndexedPath('image'), image, false);
        form.setMeta(_flow(_update('uploadingPaths', _difference(_difference.placeholder, [path.join(".")])), _update(['submittingImage'], function (v) {
          return v - 1;
        }), _update(['submittedImages'], function (v) {
          return (v || []).concat([{
            path: path,
            file: file,
            image: image
          }]);
        }), _set(getIndexedPath('uploadStatus'), uploadStatus)));
        setTempImage(null);
        utils.callIfFunction(onSuccess, {
          image: image,
          uploadStatus: uploadStatus,
          imageWidth: imageWidth,
          imageHeight: imageHeight
        });
      }).catch(function () {
        loading.close();

        if (form.getValue(getIndexedPath('image') !== file)) {
          form.setMeta(_update(['submittingImage'], function (v) {
            return v - 1;
          }));
          return;
        }

        form.setError(getIndexedPath('image').join('.'), ajaxError);
        form.setValues(_flow(_set(getIndexedPath('filename'), oldFilename), _set(getIndexedPath('image'), oldImage), _set(getIndexedPath('imageWidth'), oldImageWidth), _set(getIndexedPath('imageHeight'), oldImageHeight)), false);
        form.setMeta(_flow(_update(['submittingImage'], function (v) {
          return v - 1;
        }), _update(['submittedImages'], function (v) {
          return (v || []).concat([{
            path: path,
            file: file,
            image: image
          }]);
        }), _set(getIndexedPath('uploadStatus'), oldUploadStatus)));
        setTempImage(null);
      });
      if (eventTarget && eventTarget.parentNode && typeof eventTarget.parentNode.click === 'function') eventTarget.parentNode.click();
    };

    image.src = objectUrl;
  };

  var handleClick = function handleClick(e) {
    utils.callIfFunction(onClick, e);
  };

  var handleTouchEnd = function handleTouchEnd(e) {
    utils.callIfFunction(onTouchEnd, e);
  };

  return children(React__default.createElement(FileInput, {
    multiple: multiple,
    onChange: handleFileEvent,
    onClick: handleClick,
    tabIndex: -1,
    onTouchEnd: handleTouchEnd
  }), {
    image: image,
    isLoading: loading.isOpen,
    handleFile: handleFile,
    handleFileEvent: handleFileEvent,
    Input: FileInput
  });
};
var withFormImageInput = function withFormImageInput(preValidation, uploadFetcher) {
  return function (InnerComponent) {
    return React__default.createElement(WithImageInput, {
      preValidation: preValidation,
      uploadFetcher: uploadFetcher
    }, function (FileInput, _ref3) {
      var handleFile = _ref3.handleFile;
      return React__default.createElement(InnerComponent, {
        handleFile: handleFile
      });
    });
  };
};

var HiddenInput = styled__default.input.withConfig({
  displayName: "Checkbox__HiddenInput",
  componentId: "sc-19o1zxv-0"
})(["opacity:0 !important;position:absolute;pointer-events:none;"]);
var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? _identity : _ref$isChecked,
      isList = _ref.isList,
      disabled = _ref.disabled,
      inverted = _ref.inverted,
      path = _ref.path,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      raw = _ref.raw,
      rest = _objectWithoutProperties(_ref, ["className", "children", "isChecked", "isList", "disabled", "inverted", "path", "tabIndex", "raw"]);

  var focused = core.useToggle();

  var _useInput = useInput(_objectSpread({
    path: path,
    isChecked: isChecked
  }, rest), raw),
      _useInput2 = _slicedToArray(_useInput, 3),
      v = _useInput2[0],
      _useInput2$ = _useInput2[2],
      name = _useInput2$.name,
      toggle = _useInput2$.toggle,
      toggleItem = _useInput2$.toggleItem,
      hasErrors = _useInput2$.hasErrors;

  var testInvert = function testInvert(v) {
    return inverted ? !v : v;
  };

  var value = isChecked(testInvert(isList ? (v === null || v === void 0 ? void 0 : v.indexOf(rest.fieldValue)) >= 0 : v));

  var onClick = function onClick(e) {
    if (!e.isDefaultPrevented()) {
      if (isList) {
        toggleItem();
      } else {
        toggle();
      }

      e.preventDefault();
    }
  };

  return React__default.createElement("label", {
    onClick: onClick,
    "data-drag": "false",
    className: className
  }, !utils.isTouchDevice() && React__default.createElement(HiddenInput, {
    onFocus: focused.open,
    onBlur: focused.close,
    disabled: disabled,
    type: "checkbox",
    name: name,
    readOnly: true,
    checked: !!value,
    tabIndex: tabIndex
  }), children && children({
    disabled: disabled,
    checked: !!value,
    hasErrors: hasErrors,
    focused: focused.isOpen
  }));
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n      height: 42px;\n      line-height: 40px;\n      padding-left: 1rem;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n    ", " > * {\n      font-size: 14px;\n    }\n  "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var ComboboxMenu = styled__default(components.ContextListMenu).withConfig({
  displayName: "Combobox__ComboboxMenu",
  componentId: "u2hz6i-0"
})(["z-index:100;background-color:white;border-radius:4px 4px 6px 6px;margin-top:-1px;margin-bottom:0.5rem;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 10px -2px rgba(0,0,0,0.15),0 1px 2px 0px rgba(0,0,0,0.2);border:1px solid #b4b4b4;max-height:25rem;width:auto;", " > *{font-size:13px;}", " ", ""], components.ListItem, utils.media.mobile(_templateObject$1(), components.ListItem), function (props) {
  return props.withoutIcons && styled.css(["", " > *{padding-left:1.25rem;padding-right:1.25rem;}"], components.ListItem);
});
var ComboboxInput = styled__default.div.withConfig({
  displayName: "Combobox__ComboboxInput",
  componentId: "u2hz6i-1"
})(["width:100%;font-size:14px;border:1px solid ", ";border-radius:6px;color:", ";background:white;position:relative;line-height:34px;display:block;height:3rem;padding:0 2.25rem 0 0.7rem;;overflow:auto;outline:0;outline:none;cursor:pointer;user-select:none;", " ", ":focus{border-color:", ";box-shadow:0px 0px 0px 2px rgba(0,0,0,0.1);}", ""], utils.getColor('gray210'), utils.getColor('gray60'), utils.media.mobile(_templateObject2$1()), function (props) {
  return props.comboboxIsOpen && "\n    // border-bottom-left-radius: 0;\n    // border-bottom-right-radius: 0;\n  ";
}, utils.getColor('gray180'), function (props) {
  return props.hasErrors && styled.css(["border-color:", " !important;"], utils.getColor('alert'));
});
var ComboboxDropdownIcon = styled__default(components.Icon).withConfig({
  displayName: "Combobox__ComboboxDropdownIcon",
  componentId: "u2hz6i-2"
})(["position:absolute;top:51%;transform:translateY(-50%);right:1rem;color:", ";"], utils.getColor('gray60'));
var FooterOptionsContainer = styled__default.div.withConfig({
  displayName: "Combobox__FooterOptionsContainer",
  componentId: "u2hz6i-3"
})(["position:sticky;bottom:-0.5rem;background:white;border-top:1px solid rgba(0,0,0,0.1);padding:0.5rem 0;margin:0.5rem 0 -0.5rem;"]);
var ComboboxPlaceholder = styled__default.div.withConfig({
  displayName: "Combobox__ComboboxPlaceholder",
  componentId: "u2hz6i-4"
})(["color:rgba(0,0,0,0.3);"]);
var SEPARATOR = {}; //shouldRecenter?

var Combobox = styled__default(function (_ref) {
  var _ref$getLabel = _ref.getLabel,
      getLabel = _ref$getLabel === void 0 ? _identity : _ref$getLabel,
      getIcon = _ref.getIcon,
      _ref$scrollContainer = _ref.scrollContainer,
      scrollContainer = _ref$scrollContainer === void 0 ? function (el) {
    return el.closest('.dialog-container') || document.body;
  } : _ref$scrollContainer,
      className = _ref.className,
      options = _ref.options,
      autoFocus = _ref.autoFocus,
      mandatory = _ref.mandatory,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      fieldValue = _ref.fieldValue,
      label = _ref.label,
      path = _ref.path,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      fieldClassName = _ref.fieldClassName,
      descText = _ref.descText,
      helpText = _ref.helpText,
      raw = _ref.raw,
      footerOptions = _ref.footerOptions,
      _ref$check = _ref.check,
      check = _ref$check === void 0 ? function (a, b) {
    return a === b;
  } : _ref$check,
      rest = _objectWithoutProperties(_ref, ["getLabel", "getIcon", "scrollContainer", "className", "options", "autoFocus", "mandatory", "placeholder", "disabled", "fieldValue", "label", "path", "tabIndex", "fieldClassName", "descText", "helpText", "raw", "footerOptions", "check"]);

  var selectedElement = React.useRef();
  var fieldRef = React.useRef();
  var skipFocus = core.useRefState(autoFocus);
  var skipHover = core.useRefState();
  var listElement = React.useRef();
  var container = React.useRef();
  var keyState = core.useRefState();
  var contextMenu = core.useToggle();
  var hover = core.useToggle();
  var scrollToVisibility = core.useToggle();

  var _useInput = useInput(_objectSpread({
    fieldValue: fieldValue,
    path: path
  }, rest), raw),
      _useInput2 = _slicedToArray(_useInput, 3),
      formValue = _useInput2[0],
      confirmValue = _useInput2[1],
      hasErrors = _useInput2[2].hasErrors;

  var _useState = React.useState(formValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      _setValue = _useState2[1];

  React.useEffect(function () {
    contextMenu.isOpen && recenterScroll();
  }, [contextMenu.isOpen]);
  React.useEffect(function () {
    selectedElement.current && scrollToVisibility.isOpen && makeOptionVisible();
  }, [hover]);
  React.useEffect(function () {
    var _container$current;

    autoFocus && ((_container$current = container.current) === null || _container$current === void 0 ? void 0 : _container$current.focus());
  }, []);
  React.useEffect(function () {
    confirmValue(value);
  }, [!!contextMenu.isOpen]);
  React.useEffect(function () {
    formValue !== value && _setValue(formValue);
  }, [formValue]);
  var allOptions = options.concat(footerOptions || []).filter(function (v) {
    return v !== SEPARATOR;
  });
  var withPlaceholder = !value && value !== 0 && placeholder;

  var toggleCombobox = function toggleCombobox() {
    if (contextMenu.isOpen) {
      contextMenu.close();
    } else {
      contextMenu.open();
    }

    hover.close();
  };

  var getCurrentHeight = function getCurrentHeight() {
    var _listElement$current$;

    return listElement.current.offsetHeight - (((_listElement$current$ = listElement.current.querySelector(".JS-list-footer")) === null || _listElement$current$ === void 0 ? void 0 : _listElement$current$.offsetHeight) || 0);
  };

  var recenterScroll = function recenterScroll() {
    if (listElement.current.getBoundingClientRect().bottom > window.innerHeight) {
      var currentScrollContainer = scrollContainer(container.current);
      currentScrollContainer.scrollTop = listElement.current.getBoundingClientRect().bottom + currentScrollContainer.scrollTop - window.innerHeight;
    }

    if (selectedElement.current) {
      listElement.current.scrollTop = selectedElement.current.offsetTop + selectedElement.current.offsetHeight / 2 - getCurrentHeight() / 2;
    }
  };

  var makeOptionVisible = function makeOptionVisible() {
    if ((footerOptions === null || footerOptions === void 0 ? void 0 : footerOptions.indexOf(hover.isOpen)) >= 0) {
      return;
    } else if (selectedElement.current.offsetTop < listElement.current.scrollTop) {
      skipHover.set(true);
      listElement.current.scrollTop = selectedElement.current.offsetTop;
    } else if (selectedElement.current.offsetTop + selectedElement.current.offsetHeight > listElement.current.scrollTop + getCurrentHeight()) {
      skipHover.set(true);
      listElement.current.scrollTop = selectedElement.current.offsetTop + selectedElement.current.offsetHeight - getCurrentHeight();
    }
  };

  var handleHover = function handleHover(value, e) {
    if (skipHover.get()) {
      skipHover.set(false);
      return;
    }

    scrollToVisibility.close();
    hover.openWith(value);
  };

  var keyDown = function keyDown(e) {
    if ((e.key === 'Escape' || e.key === 'Tab') && contextMenu.isOpen) {
      e.stopPropagation();
      toggleCombobox();
    }

    if (e.key.length === 1) {
      e.stopPropagation();

      if (!contextMenu.isOpen) {
        contextMenu.open();
      }

      var prevKeyState = keyState.get();
      var repeated = !prevKeyState || e.key === prevKeyState.word[0] && prevKeyState.repeated;
      var word = ((prevKeyState === null || prevKeyState === void 0 ? void 0 : prevKeyState.word) || '') + e.key;
      clearTimeout((prevKeyState === null || prevKeyState === void 0 ? void 0 : prevKeyState.timeout) || -1);
      var timeout = setTimeout(function () {
        return keyState.set(null);
      }, 1000);
      keyState.set({
        repeated: repeated,
        word: word,
        timeout: timeout
      });
      var labels = allOptions.map(function (o) {
        var label = getLabel(o);
        return _isString(label) ? label.slice(0, repeated ? 1 : word.length).toLowerCase() : "";
      });

      var goTo = function goTo(index) {
        scrollToVisibility.open();
        hover.openWith(allOptions[index]);

        _setValue(allOptions[index]);
      };

      var currentIndex = allOptions.indexOf(hover.isOpen !== false ? hover.isOpen : value);
      var direction = repeated ? e.shiftKey ? -1 : 1 : 0;
      var fnName = direction < 0 ? 'lastIndexOf' : 'indexOf';
      var item = repeated ? word.slice(0, 1) : word;
      var fromIndex = (currentIndex || (direction < 0 ? labels.length - 1 : 0)) + direction;
      var next = labels[fnName](item, fromIndex);

      if (next >= 0) {
        goTo(next);
      } else {
        var _next = labels[fnName](item);

        if (_next >= 0) {
          goTo(_next);
        }
      }
    }

    if (['ArrowUp', 'ArrowDown', ' ', 'Enter'].indexOf(e.key) < 0) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    if (contextMenu.isOpen) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        var oldValue = hover.isOpen !== false ? hover.isOpen : value;
        var previousIndex = allOptions.indexOf(oldValue);
        var newIndex = Math.min(Math.max((previousIndex + allOptions.length + (e.key === 'ArrowUp' ? previousIndex < 0 ? 0 : -1 : 1)) % allOptions.length, 0), allOptions.length - 1);
        scrollToVisibility.open();
        hover.openWith(allOptions[newIndex]);

        _setValue(allOptions[newIndex]);
      } else {
        if (hover.isOpen !== false) {
          _setValue(hover.isOpen);
        }

        toggleCombobox();
      }
    } else {
      toggleCombobox();
    }
  };

  var createOption = function createOption(option, i) {
    if (option === SEPARATOR) {
      return React__default.createElement(components.ListSeparator, {
        key: "separator" + i
      });
    }

    var label = getLabel(option);
    return React__default.createElement(Option, {
      key: label + i,
      option: option,
      icon: utils.callIfFunction(getIcon, option),
      checked: hover.isOpen !== false ? option === hover.isOpen : check(option, value),
      label: label,
      setValue: function setValue(v) {
        _setValue(v);

        contextMenu.close();
        skipFocus.set(true);
        container.current.focus();
      },
      setRef: selectedElement,
      onHover: handleHover
    });
  };

  return React__default.createElement(Field, {
    className: fieldClassName,
    mandatory: mandatory,
    descText: descText,
    helpText: helpText,
    label: label,
    labelClick: toggleCombobox,
    ref: fieldRef
  }, React__default.createElement(ComboboxInput, {
    onBlur: function onBlur(e) {
      var _listElement$current;

      if (!((_listElement$current = listElement.current) === null || _listElement$current === void 0 ? void 0 : _listElement$current.contains(e.relatedTarget))) {
        confirmValue(value);
        contextMenu.close();
      }
    },
    onFocus: function onFocus() {
      return skipFocus.get() ? skipFocus.set(false) : contextMenu.open();
    },
    onClick: function onClick() {
      return contextMenu.openWith(function (v) {
        return _isBoolean(v) ? 2 : false;
      });
    },
    ref: container,
    tabIndex: tabIndex,
    onKeyDown: keyDown,
    disabled: disabled,
    withPlaceholder: withPlaceholder,
    hasErrors: hasErrors,
    comboboxIsOpen: contextMenu.isOpen
  }, withPlaceholder ? React__default.createElement(ComboboxPlaceholder, null, placeholder) : getLabel(value), React__default.createElement(ComboboxDropdownIcon, {
    icon: "arrow-down"
  }), !!contextMenu.isOpen && React__default.createElement(ComboboxMenuContainer, {
    ref: listElement,
    options: options,
    footerOptions: footerOptions,
    getIcon: getIcon,
    createOption: createOption
  })));
}).withConfig({
  displayName: "Combobox",
  componentId: "u2hz6i-5"
})(["user-select:none;"]);

var _willUseIsSticky = components.willUseIsSticky(),
    _willUseIsSticky2 = _slicedToArray(_willUseIsSticky, 1),
    WithIsSticky = _willUseIsSticky2[0];

var ComboboxMenuContainer = React__default.forwardRef(function (_ref2, ref) {
  var options = _ref2.options,
      footerOptions = _ref2.footerOptions,
      getIcon = _ref2.getIcon,
      createOption = _ref2.createOption;

  var _usePositioning = components.usePositioning(ref, {
    fill: true
  }),
      _usePositioning2 = _slicedToArray(_usePositioning, 2),
      positionInfo = _usePositioning2[0],
      positionPlaceholder = _usePositioning2[1];

  var slot = 'Popup';
  var slotName = React.useMemo(function () {
    return components.getDialogLayersSize() === 0 ? slot : slot + '-' + (components.getDialogLayersSize() - 1);
  }, []);
  return React__default.createElement(React__default.Fragment, null, positionPlaceholder, React__default.createElement(core.Fill, {
    name: slotName
  }, React__default.createElement(ComboboxMenu, _extends({}, positionInfo, {
    ref: ref,
    withoutIcons: !getIcon
  }), options.map(createOption), footerOptions && React__default.createElement(WithIsSticky, {
    intersection: true
  }, function (sentinel, isSticky) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(FooterOptionsContainer, {
      isSticky: isSticky,
      className: "JS-list-footer"
    }, footerOptions.map(createOption)), sentinel("margin-top:-3px;"));
  }))));
});
var Option = function Option(_ref3) {
  var setValue = _ref3.setValue,
      icon = _ref3.icon,
      option = _ref3.option,
      onHover = _ref3.onHover,
      checked = _ref3.checked,
      label = _ref3.label,
      setRef = _ref3.setRef;
  return React__default.createElement(components.ListItem, {
    hover: checked,
    tabIndex: -1,
    onMouseOver: function onMouseOver(e) {
      return onHover(option, e);
    },
    ref: checked ? setRef : undefined,
    onClick: function onClick(e) {
      e.stopPropagation();
      setValue(option);
    }
  }, React__default.createElement("a", null, icon && React__default.createElement(components.Icon, {
    icon: icon
  }), label));
};

var ComboboxWithCustom = function ComboboxWithCustom(_ref) {
  var options = _ref.options,
      label = _ref.label,
      constraint = _ref.constraint,
      path = _ref.path,
      _ref$customIndex = _ref.customIndex,
      customIndex = _ref$customIndex === void 0 ? options.length - 1 : _ref$customIndex,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      extra = _objectWithoutProperties(_ref, ["options", "label", "constraint", "path", "customIndex", "tabIndex"]);

  var customValue = core.useToggle();

  var _useFormValue = useFormValue(path),
      _useFormValue2 = _slicedToArray(_useFormValue, 2),
      value = _useFormValue2[0],
      setValue = _useFormValue2[1];

  var prevTitle = core.usePrevious(value);
  React.useLayoutEffect(function () {
    if (value === options[customIndex]) {
      customValue.openWith('');
      setValue(prevTitle);
    }
  }, [value]);

  var updateCustomValue = function updateCustomValue(e) {
    if (e.type === 'keydown' && e.keyCode === 27) {
      e.stopPropagation();
      customValue.close();
    } else if (e.type === 'keydown' && e.keyCode === 13 || e.type === 'blur') {
      e.stopPropagation();

      if (customValue.isOpen) {
        setValue(customValue.isOpen);
      }

      customValue.close();
    }
  };

  var titleOptions = !value || options.indexOf(value) >= 0 ? options : options.concat(value);
  return customValue.isOpen !== false ? React__default.createElement(TextInput, _extends({
    label: label,
    tabIndex: tabIndex,
    autoFocus: true,
    value: customValue.isOpen,
    setValue: customValue.openWith,
    maxLength: 70,
    onBlur: updateCustomValue,
    onKeyPress: updateCustomValue,
    onKeyDown: updateCustomValue,
    constraint: constraint,
    raw: true
  }, extra)) : React__default.createElement(Combobox, _extends({
    label: label,
    path: path,
    onChange: setValue,
    options: titleOptions,
    tabIndex: tabIndex
  }, extra));
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    height: 42px;\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ua = navigator.userAgent.toLowerCase();
var isSafari = ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0;
var InputLoading$1 = styled__default(components.Loading).withConfig({
  displayName: "AutoComplete__InputLoading",
  componentId: "g0526o-0"
})(["bottom:8px;right:0.6rem;left:auto;top:10px;"]);
var AutoCompleteInput = styled__default.div.withConfig({
  displayName: "AutoComplete__AutoCompleteInput",
  componentId: "g0526o-1"
})(["width:100%;font-size:14px;border:1px solid ", ";border-radius:2px;color:", ";cursor:text;background:white;position:relative;outline:0;outline:none;min-height:3rem;line-height:34px;padding:0 0.7rem;", " ", " ", " ", ""], utils.getColor('gray210'), utils.getColor('gray60'), function (props) {
  return props.focused && "\n    border-color: ".concat(utils.getColor('gray180'), ";\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.075);\n  ");
}, function (props) {
  return props.hasErrors && styled.css(["border-color:", " !important;"], utils.getColor('alert'));
}, function (props) {
  return props.withDropdown && styled.css(["padding-right:3rem;"]);
}, utils.customTheme('TextInput'));
var AutoCompletePlaceholder = styled__default.span.withConfig({
  displayName: "AutoComplete__AutoCompletePlaceholder",
  componentId: "g0526o-2"
})(["position:absolute;top:0;pointer-events:none;color:rgba(0,0,0,0.4);"]);
var AutoCompleteTextboxDiv = styled__default.div.withConfig({
  displayName: "AutoComplete__AutoCompleteTextboxDiv",
  componentId: "g0526o-3"
})(["display:inline-block;outline:0;outline:none;padding:0 1px;line-height:130%;"]);
var AddedBox = styled__default.span.withConfig({
  displayName: "AutoComplete__AddedBox",
  componentId: "g0526o-4"
})(["background-color:rgb(230,230,230);padding:2px 2rem 4px 0.75rem;border-radius:12px;font-size:13px;position:relative;margin:0.4rem 0.7rem 0 -0.25rem;white-space:nowrap;display:inline-block;cursor:default;line-height:normal;max-width:90%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", ""], isSafari ? "\n    vertical-align: 2px;\n    " : "\n    vertical-align: -7px;\n  ");
var RemoveIcon = styled__default(components.Icon).withConfig({
  displayName: "AutoComplete__RemoveIcon",
  componentId: "g0526o-5"
})(["width:20px;height:20px;border-radius:50%;display:inline-block;position:absolute;top:50%;line-height:20px;transform:translateY(-50%);right:2px;font-size:14px;text-align:center;cursor:pointer;color:", ";:hover{background-color:", ";color:", ";}"], utils.getColor('gray120'), utils.getColor('gray210'), function (props) {
  return polished.darken(0.05, utils.getColor('alert')(props));
});
var AutoCompleteMenu = styled__default(components.ContextMenu).withConfig({
  displayName: "AutoComplete__AutoCompleteMenu",
  componentId: "g0526o-6"
})(["box-shadow:0 2px 3px 1px rgba(0,0,0,0.2),0 0px 0px 1px rgba(0,0,0,0.05);max-height:22rem;overflow:auto;", "{> *{padding:11px;}}"], components.ContextMenu.ListItem);
var AutoCompleteError = styled__default(Errors).withConfig({
  displayName: "AutoComplete__AutoCompleteError",
  componentId: "g0526o-7"
})(["", "{background:transparent;border:none;color:", ";padding:0;margin-top:0.5rem;font-weight:600;", "{display:none;}}"], Errors.Item, utils.getColor('alert'), Errors.CloseIcon);
var DropdownIconContainer = styled__default(components.Icon).withConfig({
  displayName: "AutoComplete__DropdownIconContainer",
  componentId: "g0526o-8"
})(["position:absolute;right:0;bottom:0;width:3rem;height:3rem;bottom:-1px;", " ", "{position:absolute;width:2rem;height:2rem;line-height:2rem;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,0.1);border-radius:50%;text-align:center;cursor:pointer;color:", ";:hover,:active{background:rgba(0,0,0,0.15);}}"], utils.media.mobile(_templateObject$2()), components.Icon, utils.getColor('gray90'));

var focusBeforeLast = function focusBeforeLast(e) {
  if (e.target && e.target !== e.currentTarget) return;
  var el = [].slice.call(e.currentTarget.querySelectorAll('div[contenteditable]')).slice(-1)[0];
  el.focus();

  if (!el.firstChild) {
    var node = document.createTextNode('');
    el.appendChild(node);
  }

  setSelectionRange(el.firstChild, el.textContent.length + 1);
};

var setSelectionRange = function setSelectionRange(input, selectionStart) {
  var range = document.createRange();
  var sel = window.getSelection();
  range.setStart(input, Math.max(selectionStart - 1, 0));
  sel.removeAllRanges();
  sel.addRange(range);
};

var AutoComplete = React__default.forwardRef(function (_ref, outerRef) {
  var path = _ref.path,
      _ref$AutoCompleteLi = _ref.AutoCompleteLi,
      AutoCompleteLi = _ref$AutoCompleteLi === void 0 ? components.Li : _ref$AutoCompleteLi,
      _ref$CompletedBox = _ref.CompletedBox,
      CompletedBox = _ref$CompletedBox === void 0 ? function (_ref2) {
    var label = _ref2.label,
        remove = _ref2.remove,
        value = _ref2.value;
    return React__default.createElement(AddedBox, {
      title: label
    }, label, React__default.createElement(RemoveIcon, {
      icon: "x",
      onClick: remove
    }));
  } : _ref$CompletedBox,
      _ref$EditableInput = _ref.EditableInput,
      EditableInput = _ref$EditableInput === void 0 ? function (props) {
    return React__default.createElement(AutoCompleteTextboxDiv, props);
  } : _ref$EditableInput,
      _ref$getLabel = _ref.getLabel,
      getLabel = _ref$getLabel === void 0 ? function (v) {
    return v;
  } : _ref$getLabel,
      _ref$minQueryLength = _ref.minQueryLength,
      minQueryLength = _ref$minQueryLength === void 0 ? 3 : _ref$minQueryLength,
      _ref$ignoreCase = _ref.ignoreCase,
      ignoreCase = _ref$ignoreCase === void 0 ? true : _ref$ignoreCase,
      autoSelect = _ref.autoSelect,
      autoSelectEquals = _ref.autoSelectEquals,
      _ref$fetchLimit = _ref.fetchLimit,
      fetchLimit = _ref$fetchLimit === void 0 ? 6 : _ref$fetchLimit,
      _ref$deleteOnBackspac = _ref.deleteOnBackspace,
      deleteOnBackspace = _ref$deleteOnBackspac === void 0 ? true : _ref$deleteOnBackspac,
      rawFetchSuggestions = _ref.fetchSuggestions,
      _ref$validation = _ref.validation,
      validation = _ref$validation === void 0 ? function (value) {
    return {
      success: value.trim()
    };
  } : _ref$validation,
      transform = _ref.transform,
      withDropdown = _ref.withDropdown,
      autoFocus = _ref.autoFocus,
      clickOpensWhenEmpty = _ref.clickOpensWhenEmpty,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      _ref$confirmIfNewKeys = _ref.confirmIfNewKeys,
      confirmIfNewKeys = _ref$confirmIfNewKeys === void 0 ? [] : _ref$confirmIfNewKeys,
      _ref$confirmKeys = _ref.confirmKeys,
      confirmKeys = _ref$confirmKeys === void 0 ? ['Enter', ','] : _ref$confirmKeys,
      _ref$confirmIfValueKe = _ref.confirmIfValueKeys,
      confirmIfValueKeys = _ref$confirmIfValueKe === void 0 ? ['Tab'] : _ref$confirmIfValueKe,
      placeholder = _ref.placeholder,
      _ref$getListItem = _ref.getListItem,
      getListItem = _ref$getListItem === void 0 ? getLabel : _ref$getListItem,
      onAddValue = _ref.onAddValue,
      getUniqueKey = _ref.getUniqueKey,
      withoutField = _ref.withoutField,
      fieldClassName = _ref.fieldClassName,
      bellowDescText = _ref.bellowDescText,
      mandatory = _ref.mandatory,
      descText = _ref.descText,
      helpText = _ref.helpText,
      label = _ref.label;
  var autoCompleteBox = core.useToggle();
  var hoverIndex = core.useToggle();
  var isLoading = core.useToggle();

  var _useInput = useInput({
    path: path,
    transform: transform
  }),
      _useInput2 = _slicedToArray(_useInput, 3),
      formValue = _useInput2[0],
      setFormValue = _useInput2[1],
      hasErrors = _useInput2[2].hasErrors;

  var _useProvideErrors = useProvideErrors(),
      _useProvideErrors2 = _slicedToArray(_useProvideErrors, 2),
      ErrorProvider = _useProvideErrors2[0],
      errorUtils = _useProvideErrors2[1];

  var hooksRef = core.useEnsureRef(outerRef);
  var ref = React.useRef();
  var queries = core.useRefState([]);
  var editables = core.useRefState([(formValue || []).length]);
  var listSize = core.useRefState(editables.get()[0]);
  var suggestionsFetchCache = core.useRefState({});
  var suggestionsLabelMapCache = core.useRefState({});
  var lastSuggestionQuery = core.useRefState('');

  var _useState = React.useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      autoCompleteList = _useState2[0],
      setAutoCompleteList = _useState2[1];

  var getValue = function getValue() {
    return formValue || [];
  };

  var shouldFocusInput = core.useToggle();
  var recentlyAdded = core.useRefState();
  React.useEffect(function () {
    if (autoFocus) {
      focusInput();
    }
  }, []);

  var focusInput = function focusInput() {
    return shouldFocusInput.openWith(function (i) {
      return i + 1;
    });
  };

  React.useEffect(function () {
    if (shouldFocusInput.isOpen) focusBeforeLast({
      currentTarget: ref.current,
      target: ref.current
    });
  }, [shouldFocusInput.isOpen]);

  var lastIsEditable = function lastIsEditable() {
    return Math.max.apply(0, editables.get()) === (formValue || ['']).length - 1;
  };

  var editableIsEmpty = function editableIsEmpty() {
    return !lastIsEditable() || lastIsEditable() && !formValue[formValue.length - 1];
  };

  var ignoreCaseIfNeeded = function ignoreCaseIfNeeded(s) {
    return ignoreCase ? (s || '').toLowerCase() : s;
  };

  var refreshSuggestions = function refreshSuggestions() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var justFetch = arguments.length > 1 ? arguments[1] : undefined;
    var dropdownFetch = arguments.length > 2 ? arguments[2] : undefined;

    if ((value.length >= minQueryLength || dropdownFetch) && rawFetchSuggestions) {
      queries.set([value]);

      var removeEditable = function removeEditable(list) {
        return lastIsEditable() ? list.slice(0, -1) : list;
      };

      return isLoading.wait(Promise.resolve(fetchSuggestions(ignoreCaseIfNeeded(value))).then(function (list) {
        var noRepeatedList = list.filter(function (v) {
          return !removeEditable(getValue()).find(function (_) {
            return getLabel(v) === getLabel(_);
          });
        });

        if (justFetch) {
          return noRepeatedList;
        }

        var index = queries.get().indexOf(value);

        if (index >= 0) {
          queries.set(function (q) {
            return q.slice(index + 1);
          });

          if (!autoSelect && !(autoSelectEquals && noRepeatedList.slice(0, 1).find(function (v) {
            return ignoreCaseIfNeeded(getLabel(v)) === ignoreCaseIfNeeded(value);
          }))) {
            hoverIndex.openWith(-1);
          } else {
            hoverIndex.openWith(0);
          }

          autoCompleteBox.open();
          setAutoCompleteList(noRepeatedList);
        }
      }));
    } else {
      hoverIndex.openWith(-1);
      setAutoCompleteList([]);
      return Promise.resolve([]);
    }
  };

  var fetchSuggestions = function fetchSuggestions(s) {
    var prevQuery = lastSuggestionQuery.get();
    lastSuggestionQuery.set(s);

    if (suggestionsFetchCache.get()[s]) {
      return suggestionsFetchCache.get()[s];
    } else {
      var lastFetch = suggestionsFetchCache.get()[ignoreCaseIfNeeded(prevQuery)];

      if (s.indexOf(ignoreCaseIfNeeded(prevQuery)) >= 0 && lastFetch && lastFetch.length < fetchLimit) {
        return suggestionsFetchCache.get()[s] = lastFetch.map(getLabel).filter(function (_) {
          return ignoreCaseIfNeeded(_).indexOf(ignoreCaseIfNeeded(s)) >= 0;
        }).map(function (_) {
          return suggestionsLabelMapCache.get()()[ignoreCaseIfNeeded(_)];
        });
      } else {
        var fetch = Promise.resolve(rawFetchSuggestions(s));
        fetch.then(function (list) {
          suggestionsFetchCache[ignoreCaseIfNeeded(s)] = list;
          list.forEach(function (suggestion) {
            return suggestionsLabelMapCache.get()[ignoreCaseIfNeeded(getLabel(suggestion))] = suggestionsLabelMapCache.get()[ignoreCaseIfNeeded(getLabel(suggestion))] || suggestion;
          });
        });
        return fetch;
      }
    }
  };

  React.useEffect(function () {
    var newValue = formValue || [];

    if (newValue.length !== listSize.get()) {
      editables.set(_flow(_map(function (i) {
        return newValue.indexOf(getValue()[i]);
      }), _filter(function (_) {
        return _ >= 0;
      })));

      if (!editables.get().length) {
        editables.set([newValue.length]);
      }

      focusInput();
    }

    refreshSuggestions(lastIsEditable() ? getValue().slice(-1)[0] : '');

    if (recentlyAdded.get()) {
      recentlyAdded.set(false);
      utils.callIfFunction(onAddValue, formValue, setFormValue);
    }
  }, [formValue]);

  var confirmIfNew = function confirmIfNew(index, newValue) {
    refreshSuggestions(newValue, true).then(function (list) {
      if (!list.length) {
        confirm(index, newValue);
      } else {
        onChange(index, newValue);
      }
    });
  };

  var confirm = function confirm(index, newValue) {
    if (autoCompleteList.length && hoverIndex.isOpen >= 0) {
      addValue(autoCompleteList[hoverIndex.isOpen]);
    } else {
      confirmValue(index, newValue);
    }
  };

  var confirmValue = function confirmValue(index, newValue, fromBlur) {
    if (!newValue) {
      return;
    }

    var suggestedValue = suggestionsLabelMapCache[ignoreCaseIfNeeded(newValue || '').trim()];

    if (suggestedValue) {
      addValue(suggestedValue, fromBlur);
      return;
    }

    var _validation = validation(newValue),
        success = _validation.success,
        errors = _validation.errors;

    if (errors) {
      errorUtils.setErrors({
        errors: errors
      });
    } else {
      addValue(success, fromBlur);
    }
  };

  var onChange = function onChange(index, value) {
    errorUtils.clearErrors();

    var newValue = utils._s.set([index], value, getValue());

    listSize.set(newValue.length);
    setFormValue(newValue);
  };

  var addValue = function addValue(value, fromBlur) {
    var index = Math.max(lastIsEditable() ? getValue().length - 1 : getValue().length, 0);
    editables.set(_flow(_filter(function (_) {
      return _ !== index;
    }), utils._s.concat([index + 1])));
    setFormValue(utils._s.set(index, value, getValue()));
    listSize.set(index);
    recentlyAdded.set(true);

    if (!fromBlur) {
      focusInput();
    }
  };

  var _remove = function remove(index) {
    editables.set(_map(function (_) {
      return _ >= index ? _ - 1 : 1;
    }));

    var newList = utils._s.unset(index, getValue()).filter(function (_) {
      return _ !== undefined;
    });

    listSize.set(newList.length);
    setFormValue(newList);
    focusInput();
  };

  var onBlur = function onBlur(e) {
    autoCompleteBox.close();
    var v = getValue().slice(-1)[0];

    if (lastIsEditable()) {
      var _validation2 = validation(v),
          errors = _validation2.errors;

      var firstIsEqual = autoCompleteList.slice(0, 1).find(function (item) {
        return ignoreCaseIfNeeded(getLabel(item)) === ignoreCaseIfNeeded(v);
      });

      if (autoSelect && (autoCompleteList.length === 1 || firstIsEqual) && errors) {
        addValue(autoCompleteList[0], true);
      } else if (autoSelectEquals && firstIsEqual) {
        addValue(autoCompleteList[0], true);
      } else {
        confirmValue(getValue().length - 1, v, true);
      }
    } else if (autoCompleteList.length) {
      setAutoCompleteList([]);
    }
  };

  React__default.useImperativeHandle(hooksRef, function () {
    return {
      addValue: addValue,
      confirm: confirm,
      remove: _remove
    };
  }, [formValue]);
  var validValue = formValue || [''];
  var uniqueKeyLabel = {};

  var _getUniqueKey = function _getUniqueKey(value) {
    if (getUniqueKey) {
      return getUniqueKey(value);
    }

    var label = getLabel(value);
    var uid = uniqueKeyLabel[label] = (uniqueKeyLabel[label] || 0) + 1;
    return label + uid;
  }; // console.log(formValue)


  var valueWithEditable = lastIsEditable() ? validValue : validValue.concat('');

  var tryOpenSuggestions = function tryOpenSuggestions(e) {
    if (autoCompleteBox.get()) {
      utils.stopPropagation(onBlur)(e);
    } else {
      errorUtils.clearErrors();
      refreshSuggestions(lastIsEditable() ? getValue().slice(-1)[0] : '', false, true);
      focusInput();
    }
  };

  var input = React__default.createElement(React__default.Fragment, null, React__default.createElement(AutoCompleteInput, {
    ref: ref,
    onFocus: autoCompleteList.length ? autoCompleteBox.open : undefined,
    hasErrors: errorUtils.errors.length > 0 || hasErrors,
    onBlur: onBlur,
    onClick: function onClick(e) {
      focusBeforeLast(e);

      if (editableIsEmpty()) {
        refreshSuggestions(undefined, undefined, true);
      }
    },
    focused: autoCompleteBox.isOpen,
    withDropdown: withDropdown
  }, React__default.createElement("span", null, "\u200B"), valueWithEditable.map(function (v, i) {
    return editables.get().indexOf(i) >= 0 ? React__default.createElement(AutoCompleteTextbox, {
      value: v,
      index: i,
      confirmKeys: confirmKeys,
      confirmIfValueKeys: confirmIfValueKeys,
      deleteOnBackspace: deleteOnBackspace,
      EditableInput: EditableInput,
      key: '$$editable$$' + i,
      onChange: onChange,
      remove: _remove,
      confirm: confirm,
      tabIndex: tabIndex,
      confirmIfNew: confirmIfNew,
      confirmIfNewKeys: confirmIfNewKeys
    }) : React__default.createElement(CompletedBox, {
      key: _getUniqueKey(v),
      label: getLabel(v),
      value: v,
      remove: function remove() {
        return _remove(i);
      }
    });
  }), React__default.createElement("span", null, "\u200B"), (!formValue || !formValue.join('')) && placeholder && React__default.createElement(AutoCompletePlaceholder, {
    onClick: function onClick(e) {
      return ref.current.click();
    }
  }, placeholder), withDropdown && !isLoading.isOpen && React__default.createElement(DropdownIconContainer, {
    onClick: tryOpenSuggestions
  }, React__default.createElement(components.Icon, {
    icon: "arrow-down"
  })), autoCompleteBox.isOpen !== false && !errorUtils.errors.length && autoCompleteList.length > 0 && React__default.createElement(AutoCompleteMenu, {
    hoverIndex: hoverIndex.isOpen,
    autoHover: autoSelect,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    onHover: hoverIndex.openWith,
    my: "top left",
    at: "bottom left",
    fill: true
  }, autoCompleteList.map(function (value) {
    return React__default.createElement(AutoCompleteLi, {
      key: _getUniqueKey(value),
      label: getListItem(value),
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      onClick: function onClick() {
        return addValue(value);
      }
    });
  }))), React__default.createElement(ErrorProvider, {
    value: errorUtils
  }, React__default.createElement(AutoCompleteError, null)));
  return withoutField ? input : React__default.createElement(Field, {
    bellowDescText: bellowDescText,
    className: fieldClassName,
    value: formValue,
    mandatory: mandatory,
    descText: descText,
    helpText: helpText,
    label: label,
    labelClick: focusInput
  }, isLoading.isOpen && React__default.createElement(InputLoading$1, {
    absolute: true,
    size: 20
  }), input);
});
AutoComplete.AddedBox = AddedBox;
AutoComplete.RemoveIcon = RemoveIcon;
AutoComplete.AutoCompleteTextboxDiv = AutoCompleteTextboxDiv;

var cleanText = function cleanText(text) {
  var clean = text.replace("\u200B", '').replace(/\n/g, ' ').replace(/\s+/g, ' ');
  return clean.trim() ? clean : '';
};

var AutoCompleteTextbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoCompleteTextbox, _React$Component);

  function AutoCompleteTextbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AutoCompleteTextbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AutoCompleteTextbox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      value: _this.props.value
    };

    _this.deletePrev = function () {
      return _this.props.index > 0 && _this.props.remove(_this.props.index - 1);
    };

    _this.onKeyDown = function (e) {
      var range = window.getSelection().getRangeAt(0);

      if (_this.props.confirmIfNewKeys.indexOf(e.key) >= 0) {
        e.preventDefault();
        var text = range.startContainer.textContent;

        _this.props.confirmIfNew(_this.props.index, cleanText((text.slice(0, range.startOffset) + "\uFFFD" + text.slice(range.startOffset)).replace("\uFFFD", e.key)));
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.stopPropagation();
      } else if (_this.props.confirmKeys.indexOf(e.key) >= 0 || _this.props.confirmIfValueKeys.indexOf(e.key) >= 0) {
        if (_this.props.confirmKeys.indexOf(e.key) >= 0) {
          e.preventDefault();
        }

        if (_this.props.value) {
          e.preventDefault();
          e.stopPropagation();

          _this.props.confirm(_this.props.index, _this.props.value);
        }
      } else if (e.key === 'Backspace' && _this.props.deleteOnBackspace && (range.collapsed && range.startOffset === 0 || e.target.textContent === "\u200B")) {
        e.preventDefault();

        _this.deletePrev();
      }
    };

    _this.onChange = function (evt) {
      _this.props.onChange(_this.props.index, cleanText(evt.target.innerText));
    };

    _this.onPaste = function (ev) {
      ev.preventDefault();
      var text = ev.clipboardData.getData('text');
      document.execCommand('insertText', false, text);
    };

    return _this;
  }

  _createClass(AutoCompleteTextbox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var event = new CustomEvent('portalReposition');
      setTimeout(function () {
        return window.dispatchEvent(event);
      }, 1);

      if (this.el.innerHTML === '<br>' || !this.el.innerHTML) {
        this.el.innerHTML = "\u200B";
      }

      return nextProps.value !== cleanText(this.el.innerText) || !!Object.keys(nextProps).find(function (k) {
        return nextProps[k] !== _this2.props[k];
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (this.props.value.slice(-1) === ' ' && /\S/.test(this.el.textContent.slice(-1))) {
        // does not have blank space as last
        this.el.innerHTML = this.props.value.replace(/\s/, '&nbsp;');
      }

      if (this.props.value !== oldProps.value && document.activeElement === this.el) {
        setSelectionRange(this.el.firstChild || this.el, this.el.textContent.length + 1);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.el.addEventListener("textinput", this.onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.el.removeEventListener("textinput", this.onChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          value = _this$props.value,
          confirmKeys = _this$props.confirmKeys,
          index = _this$props.index,
          EditableInput = _this$props.EditableInput,
          confirmIfNewKeys = _this$props.confirmIfNewKeys,
          confirmIfNew = _this$props.confirmIfNew,
          confirm = _this$props.confirm,
          remove = _this$props.remove,
          rest = _objectWithoutProperties(_this$props, ["value", "confirmKeys", "index", "EditableInput", "confirmIfNewKeys", "confirmIfNew", "confirm", "remove"]);

      var valueOrBlank =
      /*android fix, not needed? value || */
      "\u200B";

      var props = _objectSpread({
        ref: function ref(_ref3) {
          return _this3.el = _ref3;
        },
        contentEditable: true,
        onInput: this.onChange,
        onKeyDown: this.onKeyDown,
        onPaste: this.onPaste,
        value: value,
        index: index,
        dangerouslySetInnerHTML: {
          __html: valueOrBlank.replace(/\s/, '&nbsp;')
        }
      }, rest);

      return typeof EditableInput === 'function' ? EditableInput(props) : React__default.createElement(EditableInput, props);
    }
  }]);

  return AutoCompleteTextbox;
}(React__default.Component);

var FormValue = function FormValue(_ref) {
  var path = _ref.path,
      children = _ref.children,
      inputs = _ref.inputs;

  var _useFormValue = useFormValue(path, inputs || []),
      _useFormValue2 = _slicedToArray(_useFormValue, 2),
      value = _useFormValue2[0],
      setValue = _useFormValue2[1];

  return utils.ifUndefined(utils.callIfFunction(children, value, setValue), _isObject(value) ? null : value, null);
};
var IfFormValue = function IfFormValue(_ref2) {
  var path = _ref2.path,
      children = _ref2.children,
      inputs = _ref2.inputs,
      _ref2$check = _ref2.check,
      check = _ref2$check === void 0 ? _identity : _ref2$check,
      invert = _ref2.invert,
      rest = _objectWithoutProperties(_ref2, ["path", "children", "inputs", "check", "invert"]);

  var _useFormValue3 = useFormValue(path, inputs || []),
      _useFormValue4 = _slicedToArray(_useFormValue3, 2),
      value = _useFormValue4[0],
      setValue = _useFormValue4[1];

  var doInvert = function doInvert(v) {
    return invert ? !v : !!v;
  };

  return React__default.createElement(components.TransitionDiv, rest, doInvert(utils.callIfFunction(check, value)) ? utils.ifUndefined(utils.callIfFunction(children, value, setValue), _isObject(value) ? null : value, null) : null);
};
var FormMeta = function FormMeta(_ref3) {
  var path = _ref3.path,
      children = _ref3.children,
      inputs = _ref3.inputs;

  var _useFormMeta = useFormMeta(path, inputs || []),
      _useFormMeta2 = _slicedToArray(_useFormMeta, 2),
      value = _useFormMeta2[0],
      setValue = _useFormMeta2[1];

  return utils.ifUndefined(utils.callIfFunction(children, value, setValue), value, null);
};

var addRootPath = function addRootPath(errorRootPath, errors, path) {
  var rootPath = [].concat(errorRootPath || [], path);
  return Object.keys(errors).reduce(function (acc, error) {
    acc[rootPath.concat(error).join('.')] = errors[error];
    return acc;
  }, {});
};

var EditableContext = React__default.createContext({});
var ConfirmEditableBoxes = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$itemValidation = _ref.itemValidation,
      itemValidation = _ref$itemValidation === void 0 ? _stubFalse : _ref$itemValidation,
      _ref$listValidation = _ref.listValidation,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? _identity : _ref$transform;
  var submitAll = React.useCallback(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(withLoading) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (withLoading) {
                editableBoxes().forEach(function (_) {
                  return _.loading().open();
                });
              }

              return _context.abrupt("return", Promise.all([submitAllShared(), submitAllStandalone()]).then(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    shared = _ref4[0],
                    standalone = _ref4[1];

                if (withLoading) {
                  editableBoxes().forEach(function (_) {
                    return _.loading().close();
                  });
                }

                return shared ? standalone ? {
                  shared: shared,
                  standalone: standalone
                } : shared : standalone;
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);

  var _useDraftConfirmation = useDraftConfirmation(submitAll),
      _useDraftConfirmation2 = _slicedToArray(_useDraftConfirmation, 3),
      confirmDraftContent = _useDraftConfirmation2[0],
      draftToggle = _useDraftConfirmation2[1],
      draftConfirmation = _useDraftConfirmation2[2];

  React.useEffect(function () {
    return draftToggle.openWith(utils.lazyValue(function () {
      return hasModifiedBoxes();
    }));
  }, []);

  var _useConsumerCatalog = core.useConsumerCatalog(),
      _useConsumerCatalog2 = _slicedToArray(_useConsumerCatalog, 2),
      sharedBoxes = _useConsumerCatalog2[0],
      sharedBoxesManager = _useConsumerCatalog2[1];

  var _useConsumerCatalog3 = core.useConsumerCatalog(),
      _useConsumerCatalog4 = _slicedToArray(_useConsumerCatalog3, 2),
      standaloneBoxes = _useConsumerCatalog4[0],
      standaloneBoxesManager = _useConsumerCatalog4[1];

  var editableBoxes = function editableBoxes(boxes) {
    return boxes || sharedBoxes().concat(standaloneBoxes());
  };

  var hasEditableBoxes = function hasEditableBoxes(boxes) {
    return editableBoxes(boxes).length > 0;
  };

  var provide = React.useMemo(function () {
    return {
      sharedBoxes: sharedBoxesManager,
      standaloneBoxes: standaloneBoxesManager,
      itemValidation: itemValidation,
      transform: transform
    };
  }, []);
  var confirm = React.useCallback(function (cb) {
    var dialogType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'submit-draft';
    return draftConfirmation(dialogType, cb);
  }, [draftConfirmation]);
  var discard = React.useCallback(function (cb) {
    return draftConfirmation('discard-draft', cb);
  }, [draftConfirmation]);

  var modifiedEditablesPath = function modifiedEditablesPath(boxes) {
    return modifiedEditableBoxes(boxes).map(function (_) {
      return _.path;
    });
  };

  var modifiedEditableBoxes = function modifiedEditableBoxes(boxes) {
    return editableBoxes(boxes).filter(function (_) {
      return _.modifiedValue()[1];
    });
  };

  var hasModifiedBoxes = function hasModifiedBoxes(boxes) {
    return modifiedEditableBoxes(boxes).length > 0;
  };

  var submitAllShared = function submitAllShared() {
    if (!sharedBoxes().length) return false;
    var sharedWithForm = sharedBoxes().find(function (_) {
      return _.form;
    });

    if (!sharedWithForm) {
      return false;
    }

    var form = sharedWithForm.props.form;
    var validated = modifiedEditableBoxes(sharedBoxes()).reduce(function (_ref5, box) {
      var success = _ref5.success,
          errors = _ref5.errors;
      var index = box.path;

      var _box$modifiedValue = box.modifiedValue(),
          _box$modifiedValue2 = _slicedToArray(_box$modifiedValue, 2),
          newItem = _box$modifiedValue2[0],
          wasModified = _box$modifiedValue2[1];

      var newErrors = wasModified ? itemValidation(newItem, index) : false;

      if (newErrors) {
        return {
          success: success,
          errors: Object.assign({}, errors, addRootPath(form.meta.errorRootPath, newErrors, index))
        };
      }

      var newProps = utils._s.set(index, transform(newItem, index), success);

      return {
        success: newProps,
        errors: errors
      };
    }, {
      success: form.getOriginalValues(),
      errors: undefined
    });

    if (validated.errors) {
      form.setErrors(validated.errors);
      return Promise.resolve(validated);
    }

    return form.submitForm(validated.success);
  };

  var submitAllStandalone = function submitAllStandalone() {
    if (!standaloneBoxes().length) return false;
    var edited = standaloneBoxes().filter(function (_) {
      return _.form.hasChanged;
    });
    var notValidated = edited.filter(function (_) {
      return !_.form.validate();
    });

    if (notValidated.length) {
      return Promise.reject({
        errors: notValidated
      });
    } else {
      return Promise.all(edited.map(function (_) {
        return _.handleSubmit();
      })).then(function (boxes) {
        var boxesAndResult = boxes.map(function (_, i) {
          return [edited[i], _, i];
        });
        boxesAndResult.filter(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 3),
              edited = _ref7[0],
              result = _ref7[1],
              i = _ref7[2];

          return !result.errors;
        }).forEach(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 1),
              _ = _ref9[0];

          return _.close();
        });
        var failed = boxesAndResult.filter(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 3),
              edited = _ref11[0],
              result = _ref11[1],
              i = _ref11[2];

          return result.errors;
        });

        if (failed.length) {
          return {
            errors: failed
          };
        } else {
          return {
            success: boxes
          };
        }
      });
    }
  };

  var methods = React.useMemo(function () {
    return {
      confirm: confirm,
      discard: discard,
      submitAll: submitAll,
      hasEditableBoxes: hasEditableBoxes,
      editableBoxes: editableBoxes,
      modifiedEditablesPath: modifiedEditablesPath
    };
  }, [draftConfirmation]);
  React.useImperativeHandle(ref, function () {
    return methods;
  }, [methods]);
  return React__default.createElement(React__default.Fragment, null, confirmDraftContent, React__default.createElement(EditableContext.Provider, {
    value: provide
  }, utils.callIfFunction(children, methods)));
});

var FlipDiv = function FlipDiv(_ref12) {
  var useAnimation = _ref12.useAnimation,
      props = _objectWithoutProperties(_ref12, ["useAnimation"]);

  var ref = React.useRef();
  useAnimation(ref);
  return React__default.createElement("div", _extends({}, props, {
    ref: ref
  }));
};

var EditableBoxPresentation = styled__default(React.forwardRef(function (_ref13, ref) {
  var _ref13$view = _ref13.view,
      view = _ref13$view === void 0 ? function (value) {
    return value === undefined || value === null ? '' : String(value);
  } : _ref13$view,
      _ref13$tabIndex = _ref13.tabIndex,
      tabIndex = _ref13$tabIndex === void 0 ? 1 : _ref13$tabIndex,
      onClose = _ref13.onClose,
      editingIsOpen = _ref13.editingIsOpen,
      onOpen = _ref13.onOpen,
      onDelete = _ref13.onDelete,
      onCancel = _ref13.onCancel,
      onSave = _ref13.onSave,
      onMouseDown = _ref13.onMouseDown,
      onTouchStart = _ref13.onTouchStart,
      resetField = _ref13.resetField,
      children = _ref13.children,
      withDelete = _ref13.withDelete,
      withContextMenu = _ref13.withContextMenu,
      edit = _ref13.edit,
      readOnly = _ref13.readOnly,
      disabled = _ref13.disabled,
      isNew = _ref13.isNew,
      className = _ref13.className,
      submitRef = _ref13.submitRef,
      path = _ref13.path;
  var popup = core.usePopupToggle();
  var editing = core.useToggle(editingIsOpen);
  var loading = core.useToggle();
  var form = React.useContext(FormContext);

  var closeBox = function closeBox(params) {
    utils.callIfFunction(onClose, params);
    editing.close();
  };

  React.useEffect(function () {
    return function () {
      return utils.callIfFunction(onClose, true);
    };
  }, []);
  React.useEffect(function () {
    if (editing.isOpen) {
      utils.callIfFunction(onOpen);
    }
  }, [editing.isOpen]);
  React.useImperativeHandle(ref, function () {
    return {
      loading: loading,
      closeBox: closeBox,
      handleCancel: handleCancel,
      getValue: getValue
    };
  });

  var handleDelete = function handleDelete(e) {
    if (e) e.preventDefault();
    onDelete();
  };

  var tryClose = function tryClose(e) {
    if (e.key === 'Escape' && editing.isOpen) {
      e.preventDefault();
      e.stopPropagation();
      handleCancel();
    }
  };

  var handleCancel = function handleCancel() {
    onCancel(closeBox);
  };

  var onSubmit = function onSubmit(e) {
    if (e) e.preventDefault();
    loading.wait(function () {
      return onSave().then(function () {
        return closeBox(true);
      }).catch(function () {});
    });
  };

  var getPath = function getPath(extraPath) {
    return utils._s.toPath(path).concat(utils._s.toPath(extraPath));
  };

  var getValue = function getValue(extraPath, otherProps) {
    return otherProps ? utils._s.get(getPath(extraPath), otherProps) : form.getValue(getPath(extraPath));
  };

  var setValue = function setValue(value, extraPath) {
    return form.setValue(getPath(extraPath), value);
  };

  var flipAnimation = core.useLazyConstant(components.willUseFlipSwitch);
  var disabledClick = readOnly || disabled;

  var openBox = function openBox() {
    editing.open();
  };

  var formattedPath = getPath();
  return React__default.createElement(PathContext.Provider, {
    value: formattedPath
  }, React__default.createElement(FlipDiv, {
    key: editing.isOpen,
    useAnimation: flipAnimation,
    onKeyDown: tryClose,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    className: 'editable-box ' + (!disabledClick ? 'clickable ' : '') + (editing.isOpen ? 'expanded' : 'collapsed') + ' ' + className,
    onClick: editing.isOpen || disabledClick ? undefined : openBox
  }, !editing.isOpen && !disabledClick && !(withDelete || withContextMenu) && React__default.createElement(components.Button, {
    tabIndex: tabIndex,
    className: "edit-button",
    small: true,
    onlyIcon: true,
    icon: "edit"
  }), !editing.isOpen && !disabledClick && (withDelete || withContextMenu) && React__default.createElement(components.Button, {
    tabIndex: tabIndex,
    className: "edit-button arrow-down",
    small: true,
    onlyIcon: true,
    icon: "arrow-down",
    onClick: utils.stopPropagation(popup.toggle)
  }, popup.isOpen && React__default.createElement(components.ContextMenu, null, React__default.createElement(components.Li, {
    label: "Editar",
    icon: "edit-line",
    onClick: openBox
  }), withDelete && React__default.createElement(components.Li, {
    label: "Deletar",
    icon: "remove",
    onClick: handleDelete
  }), withContextMenu)), React__default.createElement("form", {
    onSubmit: onSubmit
  }, React__default.createElement(FormValue, {
    path: formattedPath,
    key: utils.formatPath(formattedPath)
  }, function (value) {
    return components.fixDoubledLastMarginBottom(editing.isOpen ? edit(value, {
      getPath: getPath,
      getValue: getValue,
      path: formattedPath,
      tabIndex: tabIndex,
      setValue: setValue
    }) : view(value, {
      getPath: getPath,
      getValue: getValue,
      path: formattedPath
    }));
  }), React__default.createElement(Errors, {
    path: formattedPath
  }), editing.isOpen && React__default.createElement("div", {
    className: "editable-box-footer"
  }, React__default.createElement("div", null, withDelete && React__default.createElement(components.Button, {
    icon: "remove",
    hover: "alert",
    tabIndex: tabIndex + 2,
    onClick: handleDelete
  }, "Deletar")), React__default.createElement(core.StartlibsConsumer, null, function (_ref14) {
    var labels = _ref14.labels;
    return React__default.createElement("div", null, React__default.createElement(components.Button, {
      tabIndex: tabIndex + 1,
      onClick: handleCancel
    }, labels.EditableBox.cancel), React__default.createElement(components.Button, {
      buttonRef: submitRef,
      isLoading: loading.isOpen,
      highlight: true,
      tabIndex: tabIndex,
      type: "submit"
    }, isNew ? labels.EditableBox.saveNew : labels.EditableBox.save));
  }))), children));
})).withConfig({
  displayName: "EditableBox__EditableBoxPresentation",
  componentId: "x9t1o1-0"
})(["", ""], function (props) {
  return props.disabled && "opacity: 0.7;";
});

var SharedEditableTabBox = function SharedEditableTabBox(_ref15) {
  var path = _ref15.path,
      props = _objectWithoutProperties(_ref15, ["path"]);

  var editableGroup = React.useContext(EditableContext);
  var form = React.useContext(FormContext);
  var isNew = core.useRefState(utils._s.get(path, form.getOriginalValues()) !== form.getValue(path));
  var internalBox = React__default.useRef();

  var loading = function loading() {
    return internalBox.current.loading;
  };

  var selfRef = React.useRef();

  var resetField = function resetField() {
    return form.resetField([].concat(path));
  };

  var onClose = function onClose(skipReset) {
    if (!skipReset) {
      resetField();
    }

    form.clearErrors(utils._s.toPath(path));
    editableGroup.sharedBoxes.unregister(selfRef.current);
    isNew.set(false);
  };

  var onOpen = function onOpen() {
    editableGroup.sharedBoxes.register(selfRef.current);
  };

  var modifiedValue = function modifiedValue() {
    var oldItem = internalBox.current.getValue(undefined, form.getOriginalValues());
    var newItem = internalBox.current.getValue();
    return newItem !== oldItem ? [newItem, true] : [oldItem, false];
  };

  var validate = function validate(props, path) {
    var errors = editableGroup.itemValidation(props, path);

    if (errors) {
      form.setErrors(addRootPath(form.getMeta('errorRootPath'), errors, path));
    }

    return errors;
  };

  var onSave = function onSave() {
    var _modifiedValue = modifiedValue(),
        _modifiedValue2 = _slicedToArray(_modifiedValue, 2),
        newItem = _modifiedValue2[0],
        wasModified = _modifiedValue2[1];

    if (!wasModified) {
      internalBox.current.closeBox();
      return Promise.resolve({});
    }

    var errors = validate(newItem, path);

    if (errors) {
      return Promise.reject({
        errors: errors
      });
    }

    var transform = editableGroup.transform;

    if (isNew.get()) {
      var arrayPath = utils._s.toPath(path);

      var index = arrayPath.slice(-1);

      var newProps = utils._s.update(arrayPath.slice(0, -1), utils._s.insertAt(index, transform(newItem, path)), form.getOriginalValues());

      return form.submitForm(newProps);
    } else {
      var _newProps = utils._s.set(path, transform(newItem, path), form.getOriginalValues());

      return form.submitForm(_newProps);
    }
  };

  var onDelete = function onDelete() {
    if (isNew.get()) {
      onCancel();
      return Promise.resolve({
        success: true
      });
    }

    var original = form.getOriginalValues();

    var newProps = utils._s.unsetOrRemoveAt(path, original);

    if (utils._s.get(utils._s.toPath(path).slice(0, -1), original).length !== utils._s.get(utils._s.toPath(path).slice(0, -1), newProps).length) {
      internalBox.current.loading.open();
      var fetch = form.submitForm(newProps);
      fetch.then(function (_ref16) {
        var errors = _ref16.errors;
        internalBox.current.loading.close();

        if (!errors) {
          form.setValues(utils._s.unsetOrRemoveAt(path));
        }
      });
      return fetch;
    } else {
      internalBox.current.handleCancel();
      return Promise.resolve({
        success: true
      });
    }
  };

  var onCancel = function onCancel(close) {
    var lastKey = Array.isArray(path) ? path.slice(-1)[0] : path;
    var prevKeys = Array.isArray(path) ? path.slice(0, path.length - 1) : [];

    if (isNew.get() && typeof lastKey === 'number') {
      form.setValues(utils._s.unsetOrRemoveAt(path));
    } else {
      form.resetField(path);
      close();
    }
  };

  selfRef.current = {
    loading: loading,
    path: path,
    form: form,
    modifiedValue: modifiedValue
  };
  return React__default.createElement(EditableBoxPresentation, _extends({
    ref: internalBox,
    resetField: resetField,
    onOpen: onOpen,
    onClose: onClose,
    onDelete: onDelete,
    onCancel: onCancel,
    onSave: onSave,
    form: editableGroup.form,
    isNew: isNew.get(),
    path: path
  }, props));
};

var EditableBox = function EditableBox(_ref17) {
  var path = _ref17.path,
      onCancel = _ref17.onCancel,
      onClose = _ref17.onClose,
      isNew = _ref17.isNew,
      props = _objectWithoutProperties(_ref17, ["path", "onCancel", "onClose", "isNew"]);

  var editableGroup = React.useContext(EditableContext);
  var form = React.useContext(FormContext);
  var selfRef = React.useRef();
  var internalBox = React__default.useRef();

  var resetField = function resetField() {
    return path ? form.resetField([].concat(path)) : form.resetForm();
  };

  var _onClose = function _onClose(skipReset) {
    if (!skipReset) {
      resetField();
    }

    form.clearErrors(path);
    editableGroup.standaloneBoxes.unregister(selfRef.current);
    utils.callIfFunction(onClose);
  };

  var modifiedValue = function modifiedValue() {
    var oldItem = internalBox.current.getValue(undefined, form.getOriginalValues());
    var newItem = internalBox.current.getValue();
    return newItem !== oldItem ? [newItem, true] : [oldItem, false];
  };

  var onOpen = function onOpen() {
    editableGroup.standaloneBoxes.register(selfRef.current);
  };

  var onDelete = function onDelete() {
    props.removeItem(props.menuId);
  };

  var _onCancel = function _onCancel(close) {
    if (utils.callIfFunction(onCancel, close) !== false) {
      close();
    }
  };

  var close = function close() {
    return internalBox.current.closeBox();
  };

  var onSave = function onSave() {
    return form.submitForm();
  };

  var handleSubmit = function handleSubmit() {
    return form.handleSubmit();
  };

  var loading = function loading() {
    return internalBox.current.loading;
  };

  selfRef.current = {
    loading: loading,
    path: path,
    form: form,
    modifiedValue: modifiedValue,
    handleSubmit: handleSubmit,
    close: close
  };
  return React__default.createElement(EditableBoxPresentation, _extends({
    ref: internalBox,
    resetField: resetField,
    onOpen: onOpen,
    onClose: _onClose,
    onDelete: onDelete,
    onCancel: _onCancel,
    onSave: onSave,
    form: form,
    path: path,
    isNew: isNew
  }, props));
};
EditableBox.Shared = SharedEditableTabBox;

var HiddenInput$1 = styled__default.input.withConfig({
  displayName: "Radiobox__HiddenInput",
  componentId: "pelyer-0"
})(["opacity:0 !important;position:absolute;pointer-events:none;"]);
var Radiobox = function Radiobox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      isChecked = _ref.isChecked,
      fieldValue = _ref.fieldValue,
      path = _ref.path,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      raw = _ref.raw,
      rest = _objectWithoutProperties(_ref, ["className", "children", "disabled", "isChecked", "fieldValue", "path", "tabIndex", "raw"]);

  var focused = core.useToggle();

  var _useInput = useInput(_objectSpread({
    fieldValue: fieldValue,
    path: path,
    isChecked: isChecked
  }, rest), raw),
      _useInput2 = _slicedToArray(_useInput, 3),
      value = _useInput2[0],
      _useInput2$ = _useInput2[2],
      setFromField = _useInput2$.setFromField,
      name = _useInput2$.name,
      hasErrors = _useInput2$.hasErrors;

  var checked = isChecked ? isChecked(value) : value === fieldValue;
  return React__default.createElement("label", {
    "data-drag": "false",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!disabled) {
        setFromField();
      }
    },
    className: className
  }, !utils.isTouchDevice() && React__default.createElement(HiddenInput$1, {
    onFocus: focused.open,
    onBlur: focused.close,
    disabled: disabled,
    type: "radio",
    checked: checked,
    value: fieldValue,
    readOnly: true,
    name: name,
    tabIndex: tabIndex
  }), children && children({
    disabled: disabled,
    checked: checked,
    hasErrors: hasErrors,
    focused: focused.isOpen
  }));
};

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n      padding: 7px 12px 7px 32px;\n    "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var CheckboxPseudoInput = styled__default.div.withConfig({
  displayName: "SimpleCheckbox__CheckboxPseudoInput",
  componentId: "am8pps-0"
})(["border-radius:4px;content:'';border:1px solid ", ";width:18px;height:18px;background-color:white;position:absolute;left:-2rem;top:50%;transform:translateY(-50%);", " ", "{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-weight:bold;font-size:16px;color:", ";}"], utils.getColor('gray210'), utils.ifProp('focused', styled.css(["box-shadow:0 0 0 2px rgba(0,0,0,0.1);border-color:", ";"], utils.getColor('gray180'))), components.Icon, utils.getColor('gray90'));
var TextLabel = styled__default.span.withConfig({
  displayName: "SimpleCheckbox__TextLabel",
  componentId: "am8pps-1"
})(["font-size:13px;line-height:16px;margin:2px 0;display:block;"]);
var DescText = styled__default.div.withConfig({
  displayName: "SimpleCheckbox__DescText",
  componentId: "am8pps-2"
})(["color:rgba(0,0,0,0.4);display:block;font-size:12px;font-weight:400;"]);
var TextLabelContainer = styled__default.div.withConfig({
  displayName: "SimpleCheckbox__TextLabelContainer",
  componentId: "am8pps-3"
})(["display:flex;align-items:center;position:relative;", "{margin-left:0.25rem;}"], HelpText);
var CheckboxContent = styled__default.div.withConfig({
  displayName: "SimpleCheckbox__CheckboxContent",
  componentId: "am8pps-4"
})(["cursor:pointer;position:relative;padding-left:2rem;", ""], function (props) {
  return props.framed && styled.css(["border:1px solid ", ";border-radius:6px;min-height:3rem;min-width:8rem;background:white;:hover{background:rgb(245,245,245);}:active{background:rgb(235,235,235);}padding:10px 12px 10px 32px;", " ", " ", " ", " ", ""], utils.getColor('gray210'), utils.media.desktop(_templateObject$3()), function (props) {
    return props.hasErrors && styled.css(["border-color:", " !important;"], utils.getColor('alert'));
  }, function (props) {
    return props.checked && props.highlightSelected && styled.css(["border-color:", ";background:", ";:hover{background:", ";}", "{", "{color:", ";}}"], utils.getColor('main'), function (props) {
      return polished.desaturate(0.3, polished.lighten(0.52, utils.getColor("main")(props)));
    }, function (props) {
      return polished.desaturate(0.3, polished.lighten(0.52, utils.getColor("main")(props)));
    }, CheckboxPseudoInput, components.Icon, utils.getColor('main'));
  }, function (props) {
    return props.checked && props.ultraHighlightSelected && styled.css(["border-color:", ";background:", ";color:white;a,a.link{color:white;}:hover{background:", ";}", "{", "{color:", ";}}", "{color:rgba(255,255,255,0.65);}", "{color:rgba(255,255,255,0.65);}"], utils.getColor('main'), utils.getColor('main'), utils.getColor('main'), CheckboxPseudoInput, components.Icon, utils.getColor('main'), HelpText, DescText);
  }, function (props) {
    return props.disabled && styled.css(["background-color:rgba(0,0,0,0.075) !important;color:rgba(0,0,0,0.6);!important;&[disabled]{opacity:0.75 !important;}", "{background:transparent;}"], CheckboxPseudoInput);
  });
});
var SimpleCheckbox = styled__default(function (_ref) {
  var path = _ref.path,
      disabled = _ref.disabled,
      label = _ref.label,
      descText = _ref.descText,
      helpText = _ref.helpText,
      isFirst = _ref.isFirst,
      isLast = _ref.isLast,
      tabIndex = _ref.tabIndex,
      className = _ref.className,
      framedBoxes = _ref.framedBoxes,
      highlightSelected = _ref.highlightSelected,
      ultraHighlightSelected = _ref.ultraHighlightSelected,
      rest = _objectWithoutProperties(_ref, ["path", "disabled", "label", "descText", "helpText", "isFirst", "isLast", "tabIndex", "className", "framedBoxes", "highlightSelected", "ultraHighlightSelected"]);

  return React__default.createElement(Checkbox, _extends({
    className: className,
    path: path,
    tabIndex: tabIndex
  }, rest), function (_ref2) {
    var checked = _ref2.checked,
        hasErrors = _ref2.hasErrors,
        focused = _ref2.focused;
    return React__default.createElement(CheckboxContent, {
      checked: checked,
      framed: framedBoxes,
      highlightSelected: highlightSelected,
      ultraHighlightSelected: ultraHighlightSelected,
      hasErrors: hasErrors,
      disabled: disabled
    }, React__default.createElement(TextLabelContainer, null, React__default.createElement(CheckboxPseudoInput, {
      focused: focused,
      tabIndex: tabIndex
    }, checked && React__default.createElement(components.Icon, {
      icon: "check"
    })), React__default.createElement(TextLabel, null, label), helpText && React__default.createElement(HelpText, null, helpText)), descText && React__default.createElement(DescText, null, descText));
  });
}).withConfig({
  displayName: "SimpleCheckbox",
  componentId: "am8pps-5"
})(["cursor:pointer;position:relative;margin-bottom:1rem;display:block;", ""], utils.ifProp('disabled', styled.css(["pointer-events:none;"])));

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n      padding: 7px 12px 7px 32px;\n    "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var CssCircle = styled__default.div.withConfig({
  displayName: "SimpleRadiobox__CssCircle",
  componentId: "qv83xo-0"
})(["border-radius:50%;content:'';border:1px solid ", ";width:18px;height:18px;background-color:white;position:absolute;left:-2rem;top:50%;transform:translateY(-50%);", " ", ""], utils.getColor('gray210'), utils.ifProp('focused', styled.css(["box-shadow:0 0 0 2px rgba(0,0,0,0.1);border-color:", ";"], utils.getColor('gray180'))), utils.ifProp('checked', styled.css([":before{content:'';width:8px;height:8px;top:50%;transform:translateY(-50%);left:4px;border-radius:50%;position:absolute;background-color:", ";}"], utils.getColor('gray90'))));
var TextLabel$1 = styled__default.span.withConfig({
  displayName: "SimpleRadiobox__TextLabel",
  componentId: "qv83xo-1"
})(["font-size:13px;line-height:16px;margin:2px 0;display:block;"]);
var DescText$1 = styled__default.div.withConfig({
  displayName: "SimpleRadiobox__DescText",
  componentId: "qv83xo-2"
})(["color:rgba(0,0,0,0.4);display:block;font-size:12px;font-weight:400;"]);
var TextLabelContainer$1 = styled__default.div.withConfig({
  displayName: "SimpleRadiobox__TextLabelContainer",
  componentId: "qv83xo-3"
})(["display:flex;align-items:center;position:relative;", "{margin-left:0.25rem;}"], HelpText);
var RadioboxContent = styled__default.div.withConfig({
  displayName: "SimpleRadiobox__RadioboxContent",
  componentId: "qv83xo-4"
})(["cursor:pointer;position:relative;padding-left:2rem;", ""], function (props) {
  return props.framed && styled.css(["border:1px solid ", ";border-radius:6px;min-height:3rem;min-width:8rem;background:white;:hover{background:rgb(245,245,245);}:active{background:rgb(235,235,235);}padding:10px 12px 10px 32px;", " ", " ", " ", " ", ""], utils.getColor('gray210'), utils.media.desktop(_templateObject$4()), function (props) {
    return props.hasErrors && styled.css(["border-color:", " !important;"], utils.getColor('alert'));
  }, function (props) {
    return props.checked && props.highlightSelected && styled.css(["border-color:", ";background:", ";:hover{background:", ";}", "{:before{background-color:", ";}}"], utils.getColor('main'), function (props) {
      return polished.desaturate(0.3, polished.lighten(0.52, utils.getColor("main")(props)));
    }, function (props) {
      return polished.desaturate(0.3, polished.lighten(0.52, utils.getColor("main")(props)));
    }, CssCircle, utils.getColor('main'));
  }, function (props) {
    return props.checked && props.ultraHighlightSelected && styled.css(["border-color:", ";background:", ";color:white;:hover{background:", ";}", "{:before{background-color:", ";}}", "{color:rgba(255,255,255,0.65);}", "{color:rgba(255,255,255,0.65);}"], utils.getColor('main'), utils.getColor('main'), utils.getColor('main'), CssCircle, utils.getColor('main'), HelpText, DescText$1);
  }, function (props) {
    return props.disabled && styled.css(["background-color:rgba(0,0,0,0.075) !important;&[disabled]{opacity:0.75 !important;}", "{background:rgba(255,255,255,0.25);}"], CssCircle);
  });
});
var SimpleRadiobox = styled__default(function (props) {
  return React__default.createElement(Radiobox, props, function (_ref) {
    var disabled = _ref.disabled,
        checked = _ref.checked,
        hasErrors = _ref.hasErrors,
        focused = _ref.focused,
        tabIndex = _ref.tabIndex,
        framedBoxes = _ref.framedBoxes,
        highlightSelected = _ref.highlightSelected,
        ultraHighlightSelected = _ref.ultraHighlightSelected;
    return React__default.createElement(RadioboxContent, {
      checked: checked,
      framed: props.framedBoxes,
      highlightSelected: props.highlightSelected,
      ultraHighlightSelected: props.ultraHighlightSelected,
      hasErrors: hasErrors,
      disabled: disabled
    }, React__default.createElement(TextLabelContainer$1, null, React__default.createElement(CssCircle, {
      checked: checked,
      focused: focused,
      tabIndex: tabIndex
    }), React__default.createElement(TextLabel$1, null, props.label), props.helpText && React__default.createElement(HelpText, null, props.helpText)), props.descText && React__default.createElement(DescText$1, null, props.descText));
  });
}).withConfig({
  displayName: "SimpleRadiobox",
  componentId: "qv83xo-5"
})(["cursor:pointer;position:relative;margin-bottom:1rem;display:block;", ""], utils.ifProp('disabled', styled.css(["pointer-events:none;"])));

var InputboxGroup = styled__default(function (_ref) {
  var path = _ref.path,
      className = _ref.className,
      column = _ref.column,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? column ? components.SplitColumnsContainer : 'div' : _ref$as,
      children = _ref.children,
      label = _ref.label,
      descText = _ref.descText,
      helpText = _ref.helpText,
      mandatory = _ref.mandatory,
      rest = _objectWithoutProperties(_ref, ["path", "className", "column", "as", "children", "label", "descText", "helpText", "mandatory"]);

  var size = React__default.Children.count(children);
  var Wrapper = as;
  var boxes = React__default.createElement(Wrapper, {
    className: className
  }, React__default.Children.toArray(children).filter(function (child) {
    return child.props;
  }).map(function (child, i, arr) {
    return React__default.cloneElement(child, _objectSpread({
      isFirst: i === 0,
      isLast: i === arr.length - 1,
      index: i,
      path: path
    }, rest, child.props));
  }));
  return label ? React__default.createElement(Field, {
    label: label,
    mandatory: mandatory,
    descText: descText,
    helpText: helpText
  }, boxes) : boxes;
}).withConfig({
  displayName: "InputboxGroup",
  componentId: "q49nwm-0"
})(["", " ", " ", " ", ""], function (props) {
  return props.wide && "\n    width: 100%;\n    display: flex;\n    label {\n      flex-grow: 1;\n      flex-basis: 0;\n    }\n  ";
}, function (props) {
  return props.unevenlyWide && "\n    width: 100%;\n    display: flex;\n    label {\n      flex-grow: 1;\n    }\n  ";
}, function (props) {
  return props.horizontal ? "\n    @supports (flex-wrap: wrap) {\n      display: flex;\n      flex-wrap: wrap;\n    }\n    min-height: 3rem;\n    align-items: center;\n    ".concat(SimpleRadiobox, ", ").concat(SimpleCheckbox, " {\n      margin-right: 1.5rem;\n      margin-bottom: 0.5rem;\n      display: inline-block;\n    }\n  ") : "\n    ".concat(SimpleRadiobox, ", ").concat(SimpleCheckbox, " {\n      margin-bottom: 0.5rem;\n      :last-child {\n        margin-bottom: 1rem;\n      }\n    }\n  ");
}, function (props) {
  return props.framedBoxes && styled.css(["", ""], function (props) {
    return props.horizontal && "\n      margin: -4px;\n      width: calc(100% + 8px);\n      ".concat(SimpleRadiobox, ", ").concat(SimpleCheckbox, " {\n          margin: 4px;\n      }\n    ");
  });
});
var RadioboxGroup = InputboxGroup;
var CheckboxGroup = InputboxGroup;

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    line-height: 42px;\n    width: 2.25rem;\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n      width: 2.5rem;\n    "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var DAY = 'day';
var MONTH = 'month';
var YEAR = 'year';
var LEVELS = [DAY, MONTH, YEAR];
var DatePickerContainer = styled__default.div.withConfig({
  displayName: "DatePicker__DatePickerContainer",
  componentId: "sc-1wo8j4d-0"
})(["width:20rem;position:absolute;z-index:10;background-color:white;border-radius:5px;border:1px solid ", ";user-select:none;box-shadow:0 0 4px 0 rgba(0,0,0,0.2);font-size:13px;text-align:center;animation:0.2s datePickerFadeInDown ease-out;display:none;@supports (flex-wrap:wrap){display:block;}input{padding-right:2.25rem;", "}@keyframes datePickerFadeInDown{from{opacity:0;transform:translateY(-10px);pointer-events:none;}to{opacity:1;transform:none;pointer-events:none;}}"], utils.getColor('gray210'), utils.media.mobile(_templateObject$5()));
var CalendarHeader = styled__default.div.withConfig({
  displayName: "DatePicker__CalendarHeader",
  componentId: "sc-1wo8j4d-1"
})(["display:flex;padding:0.5rem;align-items:center;"]);
var CalendarContentContainer = styled__default.div.withConfig({
  displayName: "DatePicker__CalendarContentContainer",
  componentId: "sc-1wo8j4d-2"
})(["padding:0 0.5rem 0.5rem 0.5rem;display:flex;flex-wrap:wrap;justify-content:space-around;"]);
var WeekHeader = styled__default(CalendarContentContainer).withConfig({
  displayName: "DatePicker__WeekHeader",
  componentId: "sc-1wo8j4d-3"
})(["font-size:12px;font-weight:600;cursor:default;span{width:2.5rem;}"]);
var CalendarClickable = styled__default.a.withConfig({
  displayName: "DatePicker__CalendarClickable",
  componentId: "sc-1wo8j4d-4"
})([":hover,:focus{background-color:rgba(0,0,0,0.1);cursor:pointer;}"]);
var TitleButton = styled__default(CalendarClickable).withConfig({
  displayName: "DatePicker__TitleButton",
  componentId: "sc-1wo8j4d-5"
})(["font-size:16px;font-weight:600;flex-grow:1;border-radius:4px;line-height:3rem;"]);
var NavigationButton = styled__default(CalendarClickable).withConfig({
  displayName: "DatePicker__NavigationButton",
  componentId: "sc-1wo8j4d-6"
})(["font-size:21px;width:3rem;text-align:center;border-radius:4px;height:3rem;", "{line-height:3rem;}"], components.Icon);
var CalendarContent = styled__default(CalendarClickable).withConfig({
  displayName: "DatePicker__CalendarContent",
  componentId: "sc-1wo8j4d-7"
})(["line-height:2.25rem;flex-grow:1;display:inline-block;border-radius:5px;margin-top:0.25rem;margin-left:0.25rem;", " ", " ", "   ", "  "], utils.ifProp('isEdge', styled.css(["color:rgba(0,0,0,0.4);"])), utils.ifProp('isSelected', styled.css(["box-shadow:inset 0 0 0 1px ", ";"], utils.getColor('gray210'))), utils.ifProp('isDisabled', "pointer-events: none;\n   opacity: 0.5;"), utils.ifProp('isCurrent', styled.css(["background:", ";color:#FFF;:hover{background-color:", ";}", ""], utils.getColor('main'), function (props) {
  return polished.darken(0.075, utils.getColor('main')(props));
}, utils.ifProp('isSelected', 'box-shadow: none;'))));
var DayItem = styled__default(CalendarContent).withConfig({
  displayName: "DatePicker__DayItem",
  componentId: "sc-1wo8j4d-8"
})(["", " flex-basis:12%;"], function (props) {
  return props.index % 7 === 0 && 'margin-left:0;';
});
var MonthItem = styled__default(CalendarContent).withConfig({
  displayName: "DatePicker__MonthItem",
  componentId: "sc-1wo8j4d-9"
})(["", " flex-basis:30%;"], function (props) {
  return props.index % 3 === 0 && 'margin-left:0;';
});
var YearItem = styled__default(CalendarContent).withConfig({
  displayName: "DatePicker__YearItem",
  componentId: "sc-1wo8j4d-10"
})(["", " flex-basis:30%;"], function (props) {
  return props.index % 3 === 0 && 'margin-left:0;';
});
var DatePickerInputIcon = styled__default(components.Icon).withConfig({
  displayName: "DatePicker__DatePickerInputIcon",
  componentId: "sc-1wo8j4d-11"
})(["position:absolute;outline:none;bottom:0;font-size:21px;line-height:3rem;right:0;width:2rem;cursor:pointer;color:", ";:hover{color:", ";}display:none;@supports (flex-wrap:wrap){display:block;}", " ", ""], utils.getColor('gray150'), utils.getColor('main'), function (props) {
  return props.disabled && 'pointer-events: none;';
}, utils.media.mobile(_templateObject2$2()));
var ClearButton = styled__default(components.Icon).withConfig({
  displayName: "DatePicker__ClearButton",
  componentId: "sc-1wo8j4d-12"
})(["color:", ";font-size:12px;position:absolute;right:40px;bottom:0;transform:translateY(-50%);cursor:pointer;width:1.5rem;line-height:1.5rem;text-align:center;border-radius:50%;background:rgba(0,0,0,0.1);:hover{background:#f7d3d4;color:", ";}"], utils.getColor('gray90'), utils.getColor('alert'));

var KeyMapper = function KeyMapper(level) {
  var upDownSpacing = level === DAY ? 7 : 3;
  return {
    'ArrowLeft': -1,
    'ArrowRight': 1,
    'ArrowUp': -upDownSpacing,
    'ArrowDown': upDownSpacing
  };
};

var getUTCDate = function getUTCDate(year) {
  var month = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var hour = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var min = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var sec = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  return new Date(Date.UTC(year, month, date, hour, min, sec, ms));
};

var getUTCDateBefore = function getUTCDateBefore(year) {
  var month = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var hour = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var min = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var sec = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : -1;
  return new Date(Date.UTC(year, month, date, hour, min, sec, ms));
};

var DatePicker = React.forwardRef(function (_ref, maybeInputRef) {
  var _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'dd/MM/yyyy' : _ref$format,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? new Date(now().setUTCFullYear(now().getUTCFullYear() - 100)) : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? new Date(now().setUTCFullYear(now().getUTCFullYear() + 100)) : _ref$max,
      _ref$weekStartsMonday = _ref.weekStartsMonday,
      weekStartsMonday = _ref$weekStartsMonday === void 0 ? false : _ref$weekStartsMonday,
      label = _ref.label,
      mandatory = _ref.mandatory,
      tabIndex = _ref.tabIndex,
      helpText = _ref.helpText,
      path = _ref.path,
      _ref$timezoneOffset = _ref.timezoneOffset,
      timezoneOffset = _ref$timezoneOffset === void 0 ? 0 : _ref$timezoneOffset,
      placeholder = _ref.placeholder,
      onBlur = _ref.onBlur,
      raw = _ref.raw,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["format", "min", "max", "weekStartsMonday", "label", "mandatory", "tabIndex", "helpText", "path", "timezoneOffset", "placeholder", "onBlur", "raw", "disabled"]);

  var inputRef = core.useEnsureRef(maybeInputRef);

  var _useInput = useInput(_objectSpread({
    path: path
  }, rest), raw),
      _useInput2 = _slicedToArray(_useInput, 3),
      formValue = _useInput2[0],
      setUnoffsetedFormValue = _useInput2[1],
      hasErrors = _useInput2[2].hasErrors;

  var setFormValue = function setFormValue(newV) {
    return setUnoffsetedFormValue(_isFinite(newV) && newV !== -1 ? newV - timezoneOffset * 36e5 : newV);
  };

  var popup = core.usePopupToggle();
  var calendarElement = React.useRef();
  var messages = React.useContext(core.StartlibsContext).dateMessages;
  var time = Number(formValue);
  var offsetedTime = time + timezoneOffset * 36e5;

  var _useState = React.useState(!isNaN(time) ? utils.formatDate(new Date(offsetedTime), format, messages) : ''),
      _useState2 = _slicedToArray(_useState, 2),
      textValue = _useState2[0],
      setRawTextValue = _useState2[1];

  var prevValue = core.usePrevious(textValue);

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasFormatErrors = _useState4[0],
      setHasFormatErrors = _useState4[1];

  React.useEffect(function () {
    if (textValue && prevValue && textValue.length > prevValue.length + 1) {
      setTimeout(function () {
        return inputRef.current.setSelectionRange(inputRef.current.value.length + 1, inputRef.current.value.length + 1);
      }, 1);
    }
  }, [textValue]);

  var setTextValue = function setTextValue(textValue) {
    var value = formValue === -1 || isNaN(value) ? now() : new Date(Number(formValue));
    var date = utils.parseDate(textValue, value, format, messages);

    if (isNaN(date.getTime())) {
      var nextMonth = new Date(value);
      var closestLeapYear = new Date(value);
      nextMonth.setUTCMonth(value.getUTCMonth() + 1);
      closestLeapYear.setUTCFullYear(getClosestNextLeapYear(value.getUTCFullYear()));
      var nextMonthDate = utils.parseDate(textValue, nextMonth, format, messages);
      var closestLeapYearDate = utils.parseDate(textValue, closestLeapYear, format, messages);
      setRawTextValue(textValue);
      setHasFormatErrors(isNaN(nextMonthDate.getTime()) && isNaN(closestLeapYearDate));
    } else if (!inRange({
      min: min,
      max: max
    }, date)) {
      setRawTextValue(textValue);
      setHasFormatErrors(true);
      setFormValue(-1);
    } else {
      setRawTextValue(textValue);
      setHasFormatErrors(false);
      setFormValue(date.getTime());
    }
  };

  var updateText = function updateText(date) {
    setTextValue(utils.formatDate(date, format, messages));
    setHasFormatErrors(false);
  };

  var setValue = function setValue(value) {
    setFormValue(value);
    updateText(new Date(value));
  };

  var confirmValue = function confirmValue() {
    popup.close();

    if (!textValue) {
      setFormValue(undefined);
      setHasFormatErrors(false);
    } else {
      var date = utils.parseDate(textValue, new Date(formValue), format, messages, true);

      if (isNaN(date.getTime())) {
        setHasFormatErrors(true);
        setFormValue(-1);
      } else {
        updateText(date);
      }
    }
  };

  var _onBlur = function _onBlur(e) {
    var currentTarget = e.currentTarget;
    setTimeout(function () {
      if (!currentTarget.contains(document.activeElement)) {
        confirmValue();
      }

      utils.callIfFunction(onBlur);
    }, 1);
  };

  var onKeyDown = function onKeyDown(e) {
    var isConfirm = e.key === 'Enter';

    if (Object.keys(KeyMapper()).indexOf(e.key) >= 0 || isConfirm) {
      if (popup.isOpen) {
        e.preventDefault();
        calendarElement.current.keyDown(e);
      }
    }

    if (e.key === 'Escape') {
      e.stopPropagation();
      popup.close();
      var date = new Date(formValue);
      if (!isNaN(date.getTime())) updateText(date);
    }
  };

  var refocus = function refocus(e) {
    return inputRef.current.focus();
  };

  var onClick = function onClick(e) {
    if (disabled) return;
    e.stopPropagation();
    refocus();
  };

  var iconClick = function iconClick(e) {
    e.stopPropagation();

    if (popup.isOpen) {
      refocus();
      popup.close();
    } else {
      refocus();
    }
  };

  var stopFocusPropagation = function stopFocusPropagation(e) {
    return e.stopPropagation();
  }; // const calendarValue = new Date(!isNaN(time) && formValue !== -1 ? offsetedTime : now())


  var calendarValue = new Date(!isNaN(time) && formValue !== -1 ? offsetedTime : nowTimeZoneAdjusted(timezoneOffset));
  calendarValue.setUTCHours(0, 0, 0);
  return React__default.createElement(Field, {
    helpText: helpText,
    label: label,
    mandatory: mandatory,
    onClick: onClick,
    onFocus: popup.open,
    onBlur: _onBlur
  }, React__default.createElement(TextInput, {
    raw: true,
    disabled: disabled,
    type: utils.getNumberInputType(),
    tabIndex: tabIndex,
    ref: inputRef,
    constraint: utils.formatDateToPattern(format),
    value: textValue,
    setValue: setTextValue,
    placeholder: placeholder,
    hasErrors: hasErrors || hasFormatErrors,
    onKeyDown: onKeyDown
  }), React__default.createElement(DatePickerInputIcon, {
    tabIndex: -1,
    onFocus: stopFocusPropagation,
    disabled: disabled,
    onClick: iconClick,
    icon: "calendar"
  }), popup.isOpen && React__default.createElement(DatePickerCalendar, {
    raw: true,
    min: min,
    max: max,
    weekStartsMonday: weekStartsMonday,
    messages: messages,
    ref: calendarElement,
    updateTransientValue: updateText,
    refocus: refocus,
    onSelectDay: popup.toggle,
    setValue: setValue,
    value: calendarValue.getTime()
  }));
});
var defaultProps = {
  format: 'dd/MM/yyyy',
  min: new Date(now().setUTCFullYear(now().getUTCFullYear() - 100)),
  max: new Date(now().setUTCFullYear(now().getUTCFullYear() + 100)),
  weekStartsMonday: false
};

var RawDatePickerCalendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RawDatePickerCalendar, _React$Component);

  function RawDatePickerCalendar(props) {
    var _this;

    _classCallCheck(this, RawDatePickerCalendar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RawDatePickerCalendar).call(this, props));
    _this.element = void 0;

    _this.setCurrentDatePlus = function (n, type) {
      return function () {
        var date = new Date(_this.state.currentDate.getTime());

        switch (type) {
          case DAY:
            date.setUTCDate(date.getUTCDate() + n);
            break;

          case MONTH:
            date.setUTCMonth(date.getUTCMonth() + n);
            break;

          case YEAR:
            date.setUTCFullYear(date.getUTCFullYear() + n);
            break;
        }

        _this.props.updateTransientValue && _this.props.updateTransientValue(date);

        _this.setState({
          currentDate: date
        });
      };
    };

    _this.up = function () {
      _this.setState({
        level: LEVELS[LEVELS.indexOf(_this.state.level) + 1]
      });
    };

    _this.keyDown = function (e) {
      var _this$state = _this.state,
          level = _this$state.level,
          currentDate = _this$state.currentDate;
      var keyMapper = KeyMapper(level);

      if (keyMapper[e.key]) {
        e.preventDefault();

        _this.setCurrentDatePlus(keyMapper[e.key], level)();
      }

      if (e.key === 'Enter') {
        e.stopPropagation();
        e.preventDefault();

        _this.handleChange(currentDate);
      }
    };

    _this.handleChange = function (date) {
      _this.props.setValue(date.getTime());

      if (_this.state.level === DAY && _this.props.onSelectDay) {
        _this.props.onSelectDay();
      }

      _this.setState({
        level: LEVELS[Math.max(LEVELS.indexOf(_this.state.level) - 1, 0)]
      });
    };

    _this.getView = function () {
      switch (_this.state.level) {
        case DAY:
          return React__default.createElement(Calendar, _extends({}, _this.props, _this.state, {
            handleChange: _this.handleChange,
            changeCurrentDate: _this.setCurrentDatePlus,
            up: _this.up
          }));

        case MONTH:
          return React__default.createElement(Months, _extends({}, _this.props, _this.state, {
            handleChange: _this.handleChange,
            changeCurrentDate: _this.setCurrentDatePlus,
            up: _this.up
          }));

        case YEAR:
          return React__default.createElement(Years, _extends({}, _this.props, _this.state, {
            handleChange: _this.handleChange,
            changeCurrentDate: _this.setCurrentDatePlus
          }));

        default:
          return null;
      }
    };

    _this.setRef = function (e) {
      _this.element = e;
    };

    _this.state = {
      level: DAY,
      currentDate: new Date(props.value || now())
    };
    return _this;
  }

  _createClass(RawDatePickerCalendar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          currentDate: new Date(this.props.value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        ref: this.setRef,
        tabIndex: -1,
        onFocus: this.props.refocus,
        onKeyDown: this.keyDown
      }, this.getView());
    }
  }]);

  return RawDatePickerCalendar;
}(React__default.Component);

RawDatePickerCalendar.defaultProps = defaultProps;
var DatePickerCalendar = enhanceInput(RawDatePickerCalendar);

function now() {
  var dt = new Date();
  dt.setUTCHours(0, 0, 0, 0);
  return dt;
}

function nowTimeZoneAdjusted(timezoneOffset) {
  var timezoneOffsetMilliseconds = timezoneOffset * 3600000; // 3600000 milliseconds in an hour

  var dt = new Date();
  dt.setTime(dt.getTime() + timezoneOffsetMilliseconds);
  dt.setUTCHours(0, 0, 0, 0);
  return dt;
}

function inRange(context, date) {
  return context.min <= date && context.max >= date;
}

var mapDays = function mapDays(currentDate, dayOffset, fn) {
  var month = [];
  var iter = new Date(currentDate);
  iter.setUTCDate(1);
  var startDay = dayOffset + iter.getUTCDate() - iter.getUTCDay();

  if (startDay > 1 && startDay < 10) {
    startDay = startDay - 7;
  }

  iter.setUTCDate(startDay);

  for (var week = 0; week < 6; week++) {
    for (var day = week * 7; day < week * 7 + 7; day++) {
      month.push(fn(iter, startDay + day, day));
      iter.setUTCDate(iter.getUTCDate() + 1);
    }
  }

  return month;
};

var Calendar = function Calendar(_ref2) {
  var messages = _ref2.messages,
      max = _ref2.max,
      min = _ref2.min,
      value = _ref2.value,
      currentDate = _ref2.currentDate,
      weekStartsMonday = _ref2.weekStartsMonday,
      changeCurrentDate = _ref2.changeCurrentDate,
      handleChange = _ref2.handleChange,
      up = _ref2.up;
  var currentMonth = currentDate.getUTCMonth();
  var dayOffset = weekStartsMonday ? 1 : 0;
  var today = now().getTime();

  var handleDateChange = function handleDateChange(e) {
    var date = new Date(currentDate);
    handleChange(new Date(date.setUTCDate(e.currentTarget.getAttribute('data-day'))));
  };

  var previousMonth = getUTCDateBefore(currentDate.getUTCFullYear(), currentDate.getUTCMonth());
  var nextMonth = getUTCDate(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 1);
  return React__default.createElement(DatePickerContainer, null, React__default.createElement(CalendarHeader, null, React__default.createElement(NavigationButton, {
    disabled: !inRange({
      min: min,
      max: max
    }, previousMonth),
    onClick: changeCurrentDate(-1, MONTH)
  }, React__default.createElement(components.Icon, {
    icon: "arrow-left-line"
  })), React__default.createElement(TitleButton, {
    onClick: up
  }, messages('month', currentMonth), " ", currentDate.getUTCFullYear()), React__default.createElement(NavigationButton, {
    disabled: !inRange({
      min: min,
      max: max
    }, nextMonth),
    onClick: changeCurrentDate(1, MONTH)
  }, React__default.createElement(components.Icon, {
    icon: "arrow-right-line"
  }))), React__default.createElement(WeekHeader, null, [0, 1, 2, 3, 4, 5, 6].map(function (day) {
    return React__default.createElement("span", {
      key: day
    }, messages('day', (day + dayOffset) % 7).slice(0, 3));
  })), React__default.createElement(CalendarContentContainer, null, mapDays(currentDate, dayOffset, function (date, day, index) {
    return React__default.createElement(DayItem, {
      index: index,
      key: date.getTime(),
      onClick: handleDateChange,
      "data-day": day,
      isEdge: date.getUTCMonth() !== currentMonth,
      isCurrent: date.getTime() === currentDate.getTime(),
      isSelected: date.getTime() === value,
      isDisabled: !inRange({
        max: max,
        min: min
      }, date),
      isToday: date.getTime() === today
    }, date.getUTCDate());
  })));
};

var Months = function Months(_ref3) {
  var currentDate = _ref3.currentDate,
      messages = _ref3.messages,
      value = _ref3.value,
      changeCurrentDate = _ref3.changeCurrentDate,
      handleChange = _ref3.handleChange,
      up = _ref3.up,
      min = _ref3.min,
      max = _ref3.max;
  var currentMonth = currentDate.getUTCMonth();
  var sameYear = currentDate.getUTCFullYear() === new Date(value).getUTCFullYear();
  var selectedMonth = sameYear ? currentDate.getUTCMonth() : undefined;

  var handleMonthChange = function handleMonthChange(e) {
    var date = new Date(currentDate);
    handleChange(new Date(date.setUTCMonth(e.currentTarget.getAttribute('data-month'))));
  };

  return React__default.createElement(DatePickerContainer, null, React__default.createElement(CalendarHeader, null, React__default.createElement(NavigationButton, {
    disabled: !inRange({
      min: min,
      max: max
    }, getUTCDateBefore(currentDate.getUTCFullYear())),
    onClick: changeCurrentDate(-1, YEAR)
  }, React__default.createElement(components.Icon, {
    icon: "arrow-left-line"
  })), React__default.createElement(TitleButton, {
    onClick: up
  }, currentDate.getUTCFullYear()), React__default.createElement(NavigationButton, {
    disabled: !inRange({
      min: min,
      max: max
    }, getUTCDate(currentDate.getUTCFullYear() + 1)),
    onClick: changeCurrentDate(1, YEAR)
  }, React__default.createElement(components.Icon, {
    icon: "arrow-right-line"
  }))), React__default.createElement(CalendarContentContainer, null, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (month) {
    return React__default.createElement(MonthItem, {
      disabled: !inRange({
        min: min,
        max: max
      }, getUTCDate(currentDate.getUTCFullYear(), month)) && !inRange({
        min: min,
        max: max
      }, getUTCDateBefore(currentDate.getUTCFullYear(), month + 1)),
      onClick: handleMonthChange,
      key: month,
      "data-month": month,
      index: month,
      isCurrent: currentMonth === month,
      isSelected: selectedMonth === month
    }, messages('month', month).slice(0, 3));
  })));
}; // Given the specified context, produces an HTML string
// representing months of the year.


function mapYears(currentDate, fn) {
  var result = [];
  var year = currentDate.getUTCFullYear();

  for (var i = 0; i < 4 * 3; i++) {
    result.push(fn(year - year % 10 - 1 + i, i < 1 || i > 10, i));
  }

  return result;
}

var Years = function Years(_ref4) {
  var value = _ref4.value,
      currentDate = _ref4.currentDate,
      changeCurrentDate = _ref4.changeCurrentDate,
      handleChange = _ref4.handleChange,
      min = _ref4.min,
      max = _ref4.max;
  var currentYear = currentDate.getUTCFullYear();
  var selectedYear = new Date(value).getUTCFullYear();

  var handleYearChange = function handleYearChange(e) {
    var date = new Date(currentDate);
    handleChange(new Date(date.setUTCFullYear(e.currentTarget.getAttribute('data-year'))));
  };

  return React__default.createElement(DatePickerContainer, null, React__default.createElement(CalendarHeader, null, React__default.createElement(NavigationButton, {
    disabled: !inRange({
      min: min,
      max: max
    }, getUTCDateBefore(currentDate.getUTCFullYear())),
    onClick: changeCurrentDate(-10, YEAR)
  }, React__default.createElement(components.Icon, {
    icon: "arrow-left-line"
  })), React__default.createElement(TitleButton, null, currentYear - currentYear % 10, "-", currentYear - currentYear % 10 + 9), React__default.createElement(NavigationButton, {
    disabled: !inRange({
      min: min,
      max: max
    }, getUTCDate(currentDate.getUTCFullYear() + 10)),
    onClick: changeCurrentDate(10, YEAR)
  }, React__default.createElement(components.Icon, {
    icon: "arrow-right-line"
  }))), React__default.createElement(CalendarContentContainer, null, mapYears(currentDate, function (year, outside, i) {
    return React__default.createElement(YearItem, {
      key: year,
      onClick: handleYearChange,
      disabled: !inRange({
        min: min,
        max: max
      }, getUTCDate(year)) && !inRange({
        min: min,
        max: max
      }, getUTCDateBefore(year + 1)),
      "data-year": year,
      index: i,
      isCurrent: year === currentYear,
      isSelected: year === selectedYear,
      isEdge: outside
    }, year);
  })));
};

function getClosestNextLeapYear(year) {
  var y = isNaN(year) ? now().getUTCFullYear() : year;

  while (!(y % 100 === 0 ? y % 400 === 0 : y % 4 === 0)) {
    y++;
  }

  return y;
}

var FORMAT_TOOLS = {
  'bold': ['b', 'strong'],
  'italic': 'i',
  'underline': 'u',
  'strikethrough': 'strike',
  'link': 'a',
  'insertUnorderedList': ['ul', 'li'],
  'insertOrderedList': ['ol', 'li'],
  'outdent': '',
  'indent': 'blockquote',
  'fontSizeUp': 'font',
  'fontSizeDown': 'font'
};
var TAG_TO_STYLE_PROPERTY = {
  'b': 'fontWeight',
  'strong': 'fontWeight',
  'u': 'textDecoration',
  'strike': 'textDecoration',
  'font': 'fontSize',
  'i': 'fontStyle'
};

var _GET_LIMITS_FONT_SIZE_PX = function GET_LIMITS_FONT_SIZE_PX() {
  var s = document.createElement('span');
  s.style.fontSize = 'medium';
  document.body.appendChild(s);
  var fontSize = parseInt(getComputedStyle(s).fontSize);
  document.body.removeChild(s);
  var limits = [fontSize * 3 / 5, fontSize * 3];

  _GET_LIMITS_FONT_SIZE_PX = function GET_LIMITS_FONT_SIZE_PX() {
    return limits;
  };

  return limits;
};

var wrapWith = function wrapWith(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
};

var FIX_STYLE = {
  'fontWeight': function fontWeight(v, el) {
    var intFontWeight = parseInt(window.getComputedStyle(el).fontWeight);
    return intFontWeight <= 400 ? 400 : 600;
  },
  'fontSize': function fontSize(v, el) {
    var _GET_LIMITS_FONT_SIZE = _GET_LIMITS_FONT_SIZE_PX(),
        _GET_LIMITS_FONT_SIZE2 = _slicedToArray(_GET_LIMITS_FONT_SIZE, 2),
        min = _GET_LIMITS_FONT_SIZE2[0],
        max = _GET_LIMITS_FONT_SIZE2[1];

    var intFontSize = parseInt(window.getComputedStyle(el).fontSize);
    return Math.min(max, Math.max(min, intFontSize)) + 'px';
  },
  'textDecoration': function textDecoration(v, el) {
    var values = v.split(' ').filter(function (v) {
      return v === 'underline' || v === 'line-through';
    });

    if (values.indexOf('underline') >= 0) {
      wrapWith(el, document.createElement('u'));
    }

    if (values.indexOf('line-through') >= 0) {
      wrapWith(el, document.createElement('strike'));
    }

    return '';
  }
};
var RichTextContainer = styled__default.div.withConfig({
  displayName: "RichText__RichTextContainer",
  componentId: "x8c1ig-0"
})(["position:relative;width:100%;border:1px solid ", ";border-radius:6px;background:white;", ";", ";", ""], utils.getColor('gray210'), function (props) {
  return props.hasErrors && "border-color: ".concat(utils.getColor(props)('alert'));
}, function (props) {
  return props.showToolbar && "\n    ".concat(ToolsContainer, " {\n      transition: 0.5s;\n      max-height: 7.5rem;\n      transition: 0.6s;\n      pointer-events: auto;\n    }\n  ");
}, function (props) {
  return props.focus && "\n    border-color: ".concat(utils.getColor('gray180'), ";\n    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);\n  ");
});
var RichTextInput = styled__default.div.withConfig({
  displayName: "RichText__RichTextInput",
  componentId: "x8c1ig-1"
})(["width:100%;font-size:14px;outline:0;outline:none;color:", ";background:white;min-height:", "px;outline:0;padding:0.7rem;overflow:auto;border-radius:5px;b,strong{font-weight:600;}&[contenteditable=true]:empty:before{content:attr(placeholder);color:rgba(0,0,0,0.3);}", ""], utils.getColor('gray60'), function (props) {
  return props.minHeight || 78;
}, function (props) {
  return props.disabled && "\n    &[disabled] {\n      background: rgba(0, 0, 0, 0.075) !important;\n      opacity: 0.75 !important;\n    }\n  ";
});
var ToolsContainer = styled__default.div.withConfig({
  displayName: "RichText__ToolsContainer",
  componentId: "x8c1ig-2"
})(["background:", ";padding:0 0.125rem;border-top-left-radius:5px;border-top-right-radius:5px;transition:0.225s;max-height:0;pointer-events:none;overflow:hidden;"], utils.getColor('gray240'));
var ToolButton = styled__default(components.Button).withConfig({
  displayName: "RichText__ToolButton",
  componentId: "x8c1ig-3"
})(["min-height:2rem;min-width:2rem;background:transparent;box-shadow:none;margin:0.25rem 0.125rem;& ~ &{margin-left:0.125rem;}.icon{font-size:23px;color:", ";position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}&:hover,&.activated:hover{background:rgba(0,0,0,0.13);}&.activated{background:rgba(0,0,0,0.1);}&:focus:after{content:none;}"], utils.getColor('gray90'));
var ToolSeparator = styled__default.span.withConfig({
  displayName: "RichText__ToolSeparator",
  componentId: "x8c1ig-4"
})(["border-left:1px solid ", ";margin-left:0.75rem;margin-right:0.5rem;line-height:2rem;vertical-align:-6px;"], utils.getColor('gray180'));
var JS_CLASS = "EDITOR--JS";

var getNextRegularCharIndex = function getNextRegularCharIndex(text, offset, direction) {
  var regex = /[A-Za-z0-9ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏàáâãäåæçèéêëìíîïÐÑÒÓÔÕÖØÙÚÛÜÝÞßðñòóôõöøùúûüýþÿ]/g;
  var cursor = offset;

  while ((text[cursor + direction] || '').match(regex)) {
    cursor += direction;
  }

  return cursor;
};

var addHttp = function addHttp(s) {
  s = s.replace(/^\s/, '');

  if (s.indexOf('http://') === 0 || s.indexOf('https://') === 0) {
    return s;
  } else {
    return 'http://' + s;
  }
};

var getRightMostElement = function getRightMostElement(node) {
  if (node.childNodes.length) {
    return getRightMostElement(node.childNodes[node.childNodes.length - 1]);
  } else {
    return node;
  }
};

var setSelectionRange$1 = function setSelectionRange(input, selectionStart) {
  var selectionEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!input) return;
  var range = document.createRange();
  var sel = window.getSelection();
  range.setStart(input, selectionStart);

  if (selectionEnd) {
    range.setEnd(input, selectionEnd);
  } else {
    range.collapse(true);
  }

  sel.removeAllRanges();
  sel.addRange(range);
};

var cleanEditor = function cleanEditor(editor, acceptedTags) {
  Array.prototype.slice.call(editor.querySelectorAll('.Apple-interchange-newline')).forEach(function (el) {
    return el.remove();
  });
  Array.prototype.slice.call(editor.querySelectorAll('iframe')).forEach(function (el) {
    return el.remove();
  });
  var acceptedStyles = acceptedTags.map(function (t) {
    return TAG_TO_STYLE_PROPERTY[t];
  }).filter(_identity);
  var newSpace = document.createTextNode("\xA0");

  if (window.getSelection().rangeCount) {
    var container = window.getSelection().getRangeAt(0).startContainer;

    if (container.nodeType === 3) {
      container.parentNode.insertBefore(newSpace, container.nextSibling);
    } else {
      container.appendChild(newSpace);
    }

    if (newSpace.previousSibling && newSpace.previousSibling.textContent === "\xA0") {
      newSpace.previousSibling.remove();
    }

    setSelectionRange$1(newSpace, 0);
  }

  var clean = function clean(children) {
    Array.prototype.slice.call(children).forEach(function (el) {
      try {
        if (el.nodeType === 3) return;

        if (!el.tagName) {
          el.remove();
          return;
        }

        var tagName = el.tagName.toLowerCase();
        var style = getComputedStyle(el);
        var rect = el.getBoundingClientRect();
        var isHidden = style.display === 'none' || rect.width === 0 || rect.height === 0;

        if (isHidden && el.children && !el.children.length && tagName !== 'br') {
          el.remove();
        } else if (acceptedTags.indexOf(tagName) >= 0) {
          clean(el.childNodes);
          el.removeAttribute('class');

          if (el.getAttribute('style')) {
            var usedStyles = _toPairs(_pick(acceptedStyles, el.style)).filter(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  k = _ref2[0],
                  v = _ref2[1];

              return v !== "";
            });

            var fixedStyle = _fromPairs(usedStyles.map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  k = _ref4[0],
                  v = _ref4[1];

              return [k, (FIX_STYLE[k] || _identity)(v, el)];
            }));

            el.removeAttribute('style');
            Object.assign(el.style, fixedStyle);
          }
        } else if (tagName === 'a') {
          clean(el.childNodes);
          if (el.textContent !== el.href || el.textContent.length < 5) el.outerHTML = el.innerHTML;
        } else {
          clean(el.childNodes);

          if (el.hasChildNodes()) {
            var newTagName = style.display === 'inline' ? 'span' : 'div';
            var newEl = document.createElement(newTagName);
            Array.prototype.slice.call(el.childNodes).forEach(function (child) {
              return newEl.appendChild(child);
            });
            el.parentNode.replaceChild(newEl, el);
          } else {
            el.remove();
          }
        }
      } catch (e) {
        if (el && el.remove) el.remove();
      }
    });
  };

  clean(editor.childNodes);
};

var insertToken = function insertToken(node, offset) {
  var parent = node.parentNode;
  var token = document.createElement("span");

  if (node.nodeType === Node.TEXT_NODE) {
    var splitted = node.splitText(offset);
    parent.insertBefore(token, splitted);
  } else {
    parent.insertBefore(token, node);
  }

  return token;
};
/*
* pagely reformat
 .replace(/^[a-z]/, function (e) {
      return e.toUpperCase()
    })
* */


var parseAndExecCommand = function parseAndExecCommand(c) {
  if (c === "strikethrough" || c === "underline") {
    document.execCommand('styleWithCSS', false, false);
  } else {
    document.execCommand('styleWithCSS', false, true);
  }

  if (c.indexOf('fontSize') === 0) {
    var direction = c.indexOf('Up') > 0 ? 1 : -1;
    var newValue = Math.min(7, Math.max(1, parseInt(document.queryCommandValue('fontSize') || 3) + direction));
    document.execCommand('fontSize', false, newValue);
  } else {
    var sanitizedCommand = c.indexOf("List") >= 0 && document.queryCommandState(c) ? 'outdent' : c; // FIX CHROME HANGS when list is called and already active

    document.execCommand(sanitizedCommand);
  }
};

var RichText = function RichText(_ref5) {
  var path = _ref5.path,
      inputRef = _ref5.inputRef,
      label = _ref5.label,
      autoHideToolbar = _ref5.autoHideToolbar,
      disabled = _ref5.disabled,
      minHeight = _ref5.minHeight,
      placeholder = _ref5.placeholder,
      className = _ref5.className,
      _ref5$formatTools = _ref5.formatTools,
      formatTools = _ref5$formatTools === void 0 ? ['bold', 'italic', 'underline', 'strikethrough'] : _ref5$formatTools,
      _ref5$reformatText = _ref5.reformatText,
      reformatText = _ref5$reformatText === void 0 ? _identity : _ref5$reformatText,
      mandatory = _ref5.mandatory,
      descText = _ref5.descText,
      helpText = _ref5.helpText,
      linkColor = _ref5.linkColor,
      _ref5$tabIndex = _ref5.tabIndex,
      tabIndex = _ref5$tabIndex === void 0 ? 1 : _ref5$tabIndex;
  var linkPopup = core.usePopupToggle();
  var input = core.useEnsureRef(inputRef);
  var activeLinkNode = React.useRef();
  var container = React.useRef();
  var linkJustCreated = core.useRefState(); // auto-hide needs

  var startSelectionToken = core.useRefState();
  var endSelectionToken = core.useRefState();
  var commands = core.useRefState([]);
  var containerFocused = core.useToggle();
  var needsNormalize = core.useRefState();
  var alreadyCancelled = core.useRefState();

  var _useInput = useInput({
    path: path
  }),
      _useInput2 = _slicedToArray(_useInput, 2),
      formValue = _useInput2[0],
      setFormValue = _useInput2[1];

  var tempValue = core.useConstant(formValue);

  var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      activatedTools = _useState2[0],
      setActivatedTools = _useState2[1];

  var validElements = core.useLazyConstant(function () {
    return ['br', 'div', 'p', 'span'].concat(_flatten(formatTools.map(function (tool) {
      return FORMAT_TOOLS[tool] || [];
    })));
  });
  React.useEffect(function () {
    cleanEditor(input.current, validElements);
  }, []);

  var focus = function focus() {
    return input.current && input.current.focus();
  };

  React.useEffect(function () {
    if (needsNormalize.get()) {
      input.current.normalize();
      needsNormalize.set(false);
    }
  });

  var triggerScrollForPanel = function triggerScrollForPanel(d) {
    requestAnimationFrame(function (time) {
      if (time > d + 250) return;
      window.dispatchEvent(new Event('scroll'));
      triggerScrollForPanel(d);
    });
  };

  var containerFocus = function containerFocus() {
    containerFocused.openWith(2);
    triggerScrollForPanel(Date.now());
  };

  var containerBlur = function containerBlur(e) {
    console.log(e.target, e.currentTarget);

    if (containerFocused.isOpen !== 1) {
      containerFocused.close();
      triggerScrollForPanel(Date.now());
    }
  };

  var onBlur = function onBlur(e) {
    if (input.current.textContent.length === 0) {
      setFormValue('');
    } else {
      setFormValue(input.current.innerHTML);
    }
  };

  var execCommand = function execCommand(e, command) {
    if (command === 'link') {
      var nodeEl;

      if (!isSelectionInsideRichTextEditor()) {
        var anchor = document.createElement('a');
        anchor.innerHTML = '&#8203;';
        input.current.appendChild(anchor);
        nodeEl = anchor;
      } else {
        var range = window.getSelection().getRangeAt(0);
        var selectedNode = range.startContainer;

        if (range.collapsed) {
          var start = getNextRegularCharIndex(selectedNode.textContent, range.startOffset, -1);
          var end = getNextRegularCharIndex(selectedNode.textContent, range.startOffset - 1, 1);

          if (start < range.startOffset && end > range.startOffset - 1) {
            range.setStart(selectedNode, start);
            range.setEnd(selectedNode, end + 1);
          }
        }

        var selectedEl = selectedNode.nodeType === Node.TEXT_NODE ? selectedNode.parentNode : selectedNode;
        var parent = selectedEl.closest('a,.' + JS_CLASS);

        if (parent && parent.matches('a')) {
          nodeEl = parent;
        } else {
          var _anchor = document.createElement('a');

          _anchor.innerHTML = '&#8203;';

          if (range.collapsed) {
            window.getSelection().getRangeAt(0).insertNode(_anchor);
          } else {
            document.execCommand('createLink', false, '_');
            _anchor = window.getSelection().anchorNode;
          }

          var _parent = _anchor.nodeName === 'A' ? _anchor : _anchor.parentElement.matches('a') ? _anchor.parentElement : _anchor.nextSibling;

          _parent.setAttribute('href', ' ');

          nodeEl = _parent;
        }
      }

      openDialog(nodeEl);
    } else {
      if (!isSelectionInsideRichTextEditor()) {
        input.current.focus();
        var last = document.createTreeWalker(input.current, NodeFilter.SHOW_TEXT).lastChild();

        var _range = document.createRange();

        _range.selectNodeContents(last || input.current);

        _range.collapse(false);

        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(_range);
      }

      if (window.getSelection().rangeCount) {
        commands.set(window.getSelection().getRangeAt(0).collapsed ? commands.get().concat(command) : [command]);

        if (window.getSelection().getRangeAt(0).startContainer === input.current) {
          // firefox ctrl+a bug
          startSelectionToken.set(insertToken(input.current.firstChild, 0));
          endSelectionToken.set(insertToken(input.current.lastChild, input.current.lastChild.length));
        } else {
          // ORDER MATTERS HERE splitText creates new text on the right https://developer.mozilla.org/en-US/docs/Web/API/Text/splitText
          endSelectionToken.set(insertToken(window.getSelection().getRangeAt(0).endContainer, window.getSelection().getRangeAt(0).endOffset));
          startSelectionToken.set(insertToken(window.getSelection().getRangeAt(0).startContainer, window.getSelection().getRangeAt(0).startOffset));
        }
      }

      containerFocused.openWith(1);
      focus();
    }
  };

  var execCommandMouseUp = function execCommandMouseUp() {
    if (startSelectionToken.get()) {
      window.getSelection().removeAllRanges();
      var range = document.createRange();
      range.setStart(startSelectionToken.get().nextSibling, 0);
      var end = endSelectionToken.get().nextSibling;
      startSelectionToken.get().remove();
      endSelectionToken.get().remove();
      startSelectionToken.set(null);
      endSelectionToken.set(null);
      range.setEnd(end, 0);
      window.getSelection().addRange(range);
    } else {
      input.current.focus();
    }

    commands.get().forEach(function (c) {
      return parseAndExecCommand(c);
    });
    commands.set(_without(['insertUnorderedList', 'insertOrderedList', 'outdent', 'indent']));
    setFormValue(input.current.innerHTML);
    containerFocused.openWith(2);
    toggleButtonsState();
  };

  var isSelectionInsideRichTextEditor = function isSelectionInsideRichTextEditor() {
    var range = window.getSelection().getRangeAt(0);
    if (!range) return false;
    var el = range.startContainer;
    if (!el) return false;
    var node = el.closest ? el : el.parentNode || document.body;
    return node.closest('.' + JS_CLASS) === input.current;
  };

  var saveRichTextLink = function saveRichTextLink(_ref6) {
    var linkUrl = _ref6.linkUrl,
        linkText = _ref6.linkText;
    var currentActiveLinkNode = activeLinkNode.current;
    currentActiveLinkNode.setAttribute('href', addHttp(linkUrl));
    currentActiveLinkNode.setAttribute('target', '_blank');

    if (currentActiveLinkNode.textContent !== linkText) {
      currentActiveLinkNode.innerText = linkText;
    }

    linkPopup.close();
    setSelectionRange$1(currentActiveLinkNode.lastChild, currentActiveLinkNode.textContent.length, 0);
    focus();
    setFormValue(input.current.innerHTML);
  };

  var cancelRichTextLink = function cancelRichTextLink(e) {
    if (alreadyCancelled.get()) return;
    var currentActiveLinkNode = activeLinkNode.current;
    var span = document.createElement('span');
    if (currentActiveLinkNode.nextSibling) currentActiveLinkNode.parentNode.insertBefore(span, currentActiveLinkNode.nextSibling);else currentActiveLinkNode.parentNode.append(span);
    setSelectionRange$1(span, 0, 0);
    focus();

    if (currentActiveLinkNode.getAttribute('href') === ' ') {
      removeLink(e);
    }

    alreadyCancelled.set(true);
    span.remove();

    if (input.current) {
      input.current.normalize();
    } else {
      needsNormalize.set(true);
    }

    linkPopup.close();
  };

  var handleKeyUp = function handleKeyUp(e) {
    toggleButtonsState();
    commands.set([]);
    setFormValue(reformatText(input.current.innerHTML));
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (linkJustCreated.current && e.which === 8) {
      linkJustCreated.current.outerHTML = linkJustCreated.current.innerHTML;
      input.current.normalize();
      return;
    }

    commands.set([]);
    linkJustCreated.set(null);
    var selectedRange = window.getSelection().getRangeAt(0);
    if (!selectedRange) return;
    var possibleTextNode = selectedRange.startContainer;
    var node = possibleTextNode.nodeType === Node.TEXT_NODE ? possibleTextNode.parentNode : possibleTextNode;
    var parent = node.closest('a,.' + JS_CLASS);

    if ((e.key === 'Enter' || e.which === 32) && parent && parent.matches('.' + JS_CLASS)) {
      var range = document.createRange();
      range.setEnd(selectedRange.startContainer, selectedRange.startOffset);
      range.setStart(selectedRange.startContainer, 0);
      traverseAndAddLink(range);
    }
  };

  var traverseAndAddLink = function traverseAndAddLink(range) {
    var match = range.toString().match(/[\s\t\n\r]([^\s\t\n\r]*)$/);

    if (match) {
      if (/^(https?:\/\/|www\.)/.test(match[1]) && utils.linkRegex.test(match[1])) {
        range.setStart(range.startContainer, match.index + 1);
        range.endContainer.splitText(range.endContainer.textContent.length - 1);
        var newNode = document.createElement('a');
        newNode.href = match[1];
        newNode.appendChild(range.extractContents());
        range.insertNode(newNode);
        window.getSelection().getRangeAt(0).setEndAfter(newNode);
        window.getSelection().getRangeAt(0).setStartAfter(newNode);
        linkJustCreated.set(newNode);
      }
    } else {
      var previous = getPreviousElement(range.startContainer);

      if (previous) {
        range.setStart(previous, 0);
        traverseAndAddLink(range);
      }
    }
  };

  var getPreviousElement = function getPreviousElement(node) {
    if (node.previousSibling) {
      var rightMost = getRightMostElement(node.previousSibling);

      if (rightMost.nodeType === Node.TEXT_NODE) {
        return rightMost;
      } else {
        return getPreviousElement(rightMost);
      }
    } else if (node.parentNode && node !== input.current) {
      return getPreviousElement(node.parentNode);
    } else {
      return null;
    }
  };

  var handlePasteDrop = function handlePasteDrop(e) {
    return setTimeout(function () {
      return pasted();
    }, 1);
  };

  var handleClick = function handleClick(e) {
    toggleButtonsState();
    var el = e.target.closest('a,.' + JS_CLASS);

    if (el && el.matches('a') && el.getAttribute('href')) {
      openDialog(el);
    }
  };

  var openDialog = function openDialog(el) {
    activeLinkNode.current = el;
    alreadyCancelled.set(false);
    linkPopup.openWith({
      linkText: el.textContent,
      linkUrl: (el.getAttribute('href') || '').trim()
    });
  };

  var removeLink = function removeLink(e) {
    if (e) e.preventDefault();
    alreadyCancelled.set(true);
    activeLinkNode.current.outerHTML = activeLinkNode.current.innerHTML === "\u200B" ? '' : activeLinkNode.current.innerHTML;
    linkPopup.close();

    if (input.current) {
      setFormValue(input.current.innerHTML);
      input.current.normalize();
    }
  };

  var pasted = function pasted(e) {
    cleanEditor(input.current, validElements);
  };

  var toggleButtonsState = function toggleButtonsState() {
    return setActivatedTools(_zipObject(formatTools, formatTools.map(function (t) {
      return window.document.queryCommandState(t);
    })));
  };

  var toolButton = function toolButton(tool) {
    return React__default.createElement(ToolButton, {
      key: tool,
      tabIndex: -1,
      onMouseDown: function onMouseDown(e) {
        return execCommand(e, tool);
      },
      onMouseUp: function onMouseUp(e) {
        return execCommandMouseUp();
      },
      className: 'button exec-command rich-text-button only-icon ' + (activatedTools[tool] ? 'activated' : ''),
      type: "button"
    }, React__default.createElement("span", {
      className: 'icon icon-' + tool
    }));
  };

  var richTextElement = React__default.createElement(RichTextContainer, {
    linkColor: linkColor,
    ref: container,
    onClick: utils.stopPropagation(),
    onFocus: containerFocus,
    onBlur: containerBlur,
    focus: containerFocused.isOpen,
    showToolbar: !disabled & !autoHideToolbar || containerFocused.isOpen,
    className: className
  }, React__default.createElement(ToolsContainer, {
    className: "rich-text-tools"
  }, formatTools.map(function (t, i) {
    return t === 'separator' ? React__default.createElement(ToolSeparator, {
      className: "separator",
      key: "separator-" + i
    }) : toolButton(t);
  })), React__default.createElement(RichTextInput, {
    contentEditable: !disabled,
    ref: input,
    onBlur: onBlur,
    onClick: handleClick,
    onKeyUp: handleKeyUp,
    onKeyDown: handleKeyDown,
    onPaste: handlePasteDrop,
    onDrop: handlePasteDrop,
    tabIndex: tabIndex,
    dangerouslySetInnerHTML: {
      __html: tempValue
    },
    disabled: disabled,
    className: JS_CLASS,
    minHeight: minHeight,
    placeholder: placeholder
  }), linkPopup.isOpen && React__default.createElement(EditLinkPopup, {
    input: input,
    activeLinkNode: activeLinkNode,
    cancel: cancelRichTextLink,
    values: linkPopup.isOpen,
    removeLink: removeLink,
    saveLink: saveRichTextLink
  }));
  return label ? React__default.createElement(Field, {
    labelClick: focus,
    descText: descText,
    helpText: helpText,
    label: label,
    mandatory: mandatory
  }, richTextElement) : richTextElement;
};

var EditLinkPopup = function EditLinkPopup(_ref7) {
  var cancel = _ref7.cancel,
      removeLink = _ref7.removeLink,
      activeLinkNode = _ref7.activeLinkNode,
      input = _ref7.input,
      saveLink = _ref7.saveLink,
      values = _ref7.values;
  var linkPopup = React.useRef();
  var formRef = React.useRef();

  var preValidation = function preValidation(formValues) {
    var errors;

    if (!formValues.linkText) {
      errors = {
        'linkText': ['Campos com asterisco (*) são obrigatórios.']
      };
    }

    if (!formValues.linkUrl || formValues.linkUrl === ' ' || !utils.linkRegex.test(formValues.linkUrl.trim())) {
      errors = _objectSpread({}, errors, {
        'linkUrl': ['Adicione um endereço válido.']
      });
    }

    return errors;
  };

  var checkEscOrEnter = function checkEscOrEnter(e) {
    if (e.keyCode === 27) {
      e.stopPropagation().cancel(e);
    } else if (e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      formRef.current.submitForm();
    }
  };

  React.useEffect(function () {
    var currentActiveLinkNode = activeLinkNode.current;
    var currentLinkPopup = linkPopup.current;
    var offsetLeft = currentActiveLinkNode.getClientRects().length > 1 ? input.offsetLeft : currentActiveLinkNode.offsetLeft;
    var left = currentActiveLinkNode.offsetWidth / 2 - currentLinkPopup.offsetWidth / 2 + offsetLeft;
    var top = currentActiveLinkNode.offsetHeight + currentActiveLinkNode.offsetTop;
    Object.assign(currentLinkPopup.style, {
      'position': 'absolute',
      'left': left + 'px',
      'top': top + 'px'
    });
    return cancel;
  }, []);
  return React__default.createElement(WithForm, {
    skipDom: true,
    ref: formRef,
    action: saveLink,
    values: values,
    preValidation: preValidation
  }, function (form) {
    return React__default.createElement("div", {
      onClick: utils.stopPropagation(),
      ref: linkPopup,
      onKeyDown: checkEscOrEnter,
      className: "popup rich-text-link-editor ignore-link",
      contentEditable: false
    }, React__default.createElement(TextInput, {
      autoFocus: !values.linkText,
      mandatory: true,
      path: "linkText",
      label: "Texto de exibi\xE7\xE3o"
    }), React__default.createElement(TextInput, {
      autoFocus: values.linkText,
      mandatory: true,
      path: "linkUrl",
      label: "Endere\xE7o completo"
    }), React__default.createElement("div", {
      className: "popup-footer"
    }, React__default.createElement(components.Button, {
      className: "remove-link",
      icon: "remove",
      onClick: removeLink
    }, "Remover Link"), React__default.createElement(components.Button, {
      onClick: cancel,
      tabIndex: 0
    }, "Cancelar"), React__default.createElement(components.Button, {
      highlight: true,
      onClick: form.willSubmitForm
    }, "Aplicar")), React__default.createElement(Errors, null));
  });
};

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n      padding 1rem;\n    "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var shouldPreventExpand = function shouldPreventExpand(fn) {
  return function (e) {
    return e.target.closest('body,[data-expand="false"],label,input,textarea,button').matches('body,[data-expand="true"]') && fn(e);
  };
};

var ExpandableBoxStyled = styled__default.div.withConfig({
  displayName: "ExpandableBox__ExpandableBoxStyled",
  componentId: "sc-1nsk1wq-0"
})(["padding:1rem;border-radius:8px;background:", ";font-size:14px;outline:none;transition:background 0.25s linear;", " & ~ &{margin-top:0.75rem;}", " &{margin-top:0.75rem;}"], utils.getColor('gray240'), function (props) {
  return props.collapsed ? styled.css(["cursor:pointer;padding-right:3.25rem;:hover{background:", ";}:active{background:", ";}"], function (props) {
    return polished.darken(0.05, utils.getColor("gray240")(props));
  }, function (props) {
    return polished.darken(0.08, utils.getColor("gray240")(props));
  }) : styled.css(["padding 1.5rem;", " ", ""], utils.media.max(340)(_templateObject$6()), function (props) {
    return props.fixMarginBottom && "\n      padding-bottom: 0.5rem !important;\n    ";
  });
}, components.SwitchDiv);
var EditIcon = styled__default(components.Icon).attrs({
  icon: 'edit'
}).withConfig({
  displayName: "ExpandableBox__EditIcon",
  componentId: "sc-1nsk1wq-1"
})(["position:absolute;top:50%;transform:translateY(-50%);right:-24px;color:rgba(0,0,0,0.25);font-size:20px;"]);
var checkErrors = function checkErrors() {
  for (var _len = arguments.length, checks = new Array(_len), _key = 0; _key < _len; _key++) {
    checks[_key] = arguments[_key];
  }

  return function (v, setErrors) {
    var results = checks.map(function (c) {
      return c(v);
    }).filter(Boolean);

    if (!results.length) {
      return true;
    }

    var messages = results.filter(_negate(_isBoolean));

    if (messages.length) {
      setErrors.apply(void 0, _toConsumableArray(messages));
    }

    return false;
  };
};
var timing = utils.animationTiming('0.25s ease-out');
var switchAnimation = utils.oneWayAnimation('opacity: 1;transform:translateY(0);', 'opacity: 0;', 'opacity: 0; transform:translateY(30px);');
var ExpandableBox = function ExpandableBox(_ref) {
  var children = _ref.children,
      info = _ref.info,
      isOpen = _ref.isOpen,
      openWhen = _ref.openWhen,
      path = _ref.path,
      _ref$retargetFilter = _ref.retargetFilter,
      retargetFilter = _ref$retargetFilter === void 0 ? function (el) {
    var _el$tagName;

    return (el === null || el === void 0 ? void 0 : (_el$tagName = el.tagName) === null || _el$tagName === void 0 ? void 0 : _el$tagName.toLowerCase()) === "button";
  } : _ref$retargetFilter,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? function () {
    return true;
  } : _ref$isValid,
      fixMarginBottom = _ref.fixMarginBottom,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? switchAnimation : _ref$animation,
      _ref$animationTiming = _ref.animationTiming,
      animationTiming = _ref$animationTiming === void 0 ? timing : _ref$animationTiming;
  var flipAnimation = core.useLazyConstant(components.willUseFlipSwitch);

  var _useFormValue = form.useFormValue(path),
      _useFormValue2 = _slicedToArray(_useFormValue, 3),
      value = _useFormValue2[0],
      setValue = _useFormValue2[1],
      getValue = _useFormValue2[2];

  var _useTransientErrorHel = useTransientErrorHelper(),
      _useTransientErrorHel2 = _slicedToArray(_useTransientErrorHel, 2),
      _setErrors = _useTransientErrorHel2[0],
      clearErrors = _useTransientErrorHel2[1];

  var setErrors = function setErrors() {
    for (var _len2 = arguments.length, errors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      errors[_key2] = arguments[_key2];
    }

    _setErrors(errors.length ? errors.map(function (k) {
      return _isString(k) ? [k, ''] : k;
    }) : [[path, '']]);

    return true;
  };

  var expand = core.useToggle(isOpen, function (newV, prevV) {
    if (newV === 0 || prevV === 0) {
      return;
    }

    if (newV === false) {
      var result = isValid(getValue(), setErrors);

      if (result === true) {
        clearErrors();
      }

      return result;
    }
  });
  var openWhenResult = utils.callIfFunction(openWhen);
  React.useEffect(function () {
    if (openWhenResult) {
      expand.open();
    }
  }, [openWhenResult]);
  React.useEffect(function () {
    return function () {
      if (expand.get() === 0) {
        expand.close();
      }
    };
  }, [expand.isOpen]);
  var utils$1 = core.useLazyConstant(function () {
    return {
      close: utils.constrainEvent(expand.close),
      setValue: setValue
    };
  });

  var onBlur = function onBlur(e) {
    if (e.currentTarget !== e.relatedTarget && (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget))) {
      if (utils.callIfFunction(retargetFilter, e.relatedTarget)) {
        e.target.focus();
      } else {
        expand.close();
      }
    }
  };

  return React__default.createElement(ExpandableBoxStyled, {
    tabIndex: -1,
    onBlur: onBlur,
    collapsed: !expand.isOpen,
    fixMarginBottom: fixMarginBottom,
    onClick: shouldPreventExpand(expand.open)
  }, React__default.createElement(FlipDiv$1, {
    key: expand.isOpen,
    useAnimation: flipAnimation,
    animation: animation,
    animationTiming: animationTiming
  }, expand.isOpen ? utils.callIfFunction(children, value, utils$1) : React__default.createElement(React__default.Fragment, null, utils.callIfFunction(info, value, utils$1), React__default.createElement(EditIcon, null))));
};

var overflowEffect = function overflowEffect(element) {
  var _element$offsetParent;

  if (!(element === null || element === void 0 ? void 0 : (_element$offsetParent = element.offsetParent) === null || _element$offsetParent === void 0 ? void 0 : _element$offsetParent.parentElement)) {
    return;
  }

  var parentDom = element.offsetParent.parentElement;
  var previousOverflow = parentDom.style.overflow;
  parentDom.style.overflow = 'hidden';
  return function () {
    return parentDom.style.overflow = previousOverflow;
  };
};

var FlipDivStyle = styled__default.div.withConfig({
  displayName: "ExpandableBox__FlipDivStyle",
  componentId: "sc-1nsk1wq-2"
})(["position:relative;"]);

var FlipDiv$1 = function FlipDiv(_ref2) {
  var useAnimation = _ref2.useAnimation,
      animation = _ref2.animation,
      animationTiming = _ref2.animationTiming,
      props = _objectWithoutProperties(_ref2, ["useAnimation", "animation", "animationTiming"]);

  var ref = React.useRef();
  useAnimation(ref, null, null, {
    switchAnimation: animation,
    timing: animationTiming,
    effect: overflowEffect
  });
  return React__default.createElement(FlipDivStyle, _extends({}, props, {
    ref: ref
  }));
};

var IconRadioBoxText = styled__default.div.withConfig({
  displayName: "IconRadioBox__IconRadioBoxText",
  componentId: "ka3uhk-0"
})(["flex-grow:1;padding:0 0.5rem 0.5rem;min-height:2rem;display:flex;justify-content:center;align-items:center;text-align:center;font-size:12px;color:", ";", " ", ""], utils.getColor('gray120'), function (props) {
  return props.checked && styled.css(["color:", ";"], utils.getColor('main'));
}, function (props) {
  return props.highlightedDesc && styled.css(["background:", ";padding:0.25rem 0.5rem;min-height:3rem;", ""], utils.getColor('gray240'), function (props) {
    return props.checked && styled.css(["background:", ";"], function (props) {
      return polished.desaturate(0.3, polished.lighten(0.52, utils.getColor("main")(props)));
    });
  });
});
var IconRadioBoxIconContainer = styled__default.div.withConfig({
  displayName: "IconRadioBox__IconRadioBoxIconContainer",
  componentId: "ka3uhk-1"
})(["display:flex;justify-content:center;align-items:center;text-align:center;"]);
var Wrapper = styled__default.div.withConfig({
  displayName: "IconRadioBox__Wrapper",
  componentId: "ka3uhk-2"
})(["width:100%;display:flex;flex-direction:column;cursor:pointer;border-radius:6px;background-color:white;border:1px solid ", ";overflow:hidden;color:", ";", "{font-size:100px;line-height:50px;line-height:76px;width:100%;}", " input{opacity:0;position:absolute;left:-20000000px;}", " ", ""], utils.getColor('gray210'), utils.getColor('gray150'), components.Icon, function (props) {
  return props.checked && styled.css(["color:", ";border-color:", ";"], utils.getColor('main'), utils.getColor('main'));
}, function (props) {
  return props.focused && "\n    ".concat(IconRadioBoxIconContainer, "::after {\n      content: '';\n      position: absolute;\n      top: -4px;\n      right: -4px;\n      left: -4px;\n      bottom: -4px;\n      border-radius: 10px;\n      border: 3px solid rgba(0, 0, 0, 0.15);\n  }");
}, utils.customTheme("IconRadioBox"));
var IconRadioBox = styled__default(function (_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      highlightedDesc = _ref.highlightedDesc,
      props = _objectWithoutProperties(_ref, ["icon", "label", "highlightedDesc"]);

  return React__default.createElement(Radiobox, props, function (_ref2) {
    var checked = _ref2.checked,
        focused = _ref2.focused,
        hasErrors = _ref2.hasErrors,
        disabled = _ref2.disabled;
    return React__default.createElement(Wrapper, {
      checked: checked,
      focused: focused
    }, React__default.createElement(IconRadioBoxIconContainer, null, React__default.createElement(components.Icon, {
      icon: icon
    })), checked, React__default.createElement(IconRadioBoxText, {
      highlightedDesc: highlightedDesc,
      checked: checked
    }, label));
  });
}).withConfig({
  displayName: "IconRadioBox",
  componentId: "ka3uhk-3"
})(["outline:none;"]);

var ToggleContainer = styled__default.div.withConfig({
  displayName: "ToggleCheckbox__ToggleContainer",
  componentId: "sc-11ob8ah-0"
})([""]);
var Toggle = styled__default.div.withConfig({
  displayName: "ToggleCheckbox__Toggle",
  componentId: "sc-11ob8ah-1"
})(["cursor:pointer;flex-shrink:0;margin-left:1rem;float:right;width:2.25rem;height:1rem;border-radius:1rem;background:", ";display:inline-block;position:relative;transition:0.25s ease;:after{content:'';transition:0.25s ease;width:1.25rem;height:1.25rem;border-radius:50%;display:block;position:absolute;top:50%;transform:translateY(-50%);", "}", ""], function (props) {
  return props.checked ? 'rgba(0, 132, 214, 0.3)' : 'rgba(0,0,0,0.15)';
}, function (props) {
  return props.checked ? styled.css(["left:100%;transform:translate(-100%,-50%);background:", ";"], utils.getColor('main')) : styled.css(["left:0;background:", ";"], utils.getColor('gray150'));
}, utils.customTheme('ToggleCheckbox'));
var ToggleLabel = styled__default.div.withConfig({
  displayName: "ToggleCheckbox__ToggleLabel",
  componentId: "sc-11ob8ah-2"
})(["flex-basis:0;flex-grow:1;display:inline-block;font-size:13px;"]);
var DescText$2 = styled__default.div.withConfig({
  displayName: "ToggleCheckbox__DescText",
  componentId: "sc-11ob8ah-3"
})(["font-weight:400;color:", ";font-size:12px;margin-top:0.25rem;"], utils.getColor('gray120'));
var ToggleCheckbox = styled__default(function (_ref) {
  var path = _ref.path,
      disabled = _ref.disabled,
      label = _ref.label,
      descText = _ref.descText,
      helpText = _ref.helpText,
      tabIndex = _ref.tabIndex,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["path", "disabled", "label", "descText", "helpText", "tabIndex", "className"]);

  return React__default.createElement(Checkbox, _extends({
    className: className,
    path: path,
    tabIndex: tabIndex,
    disabled: disabled
  }, rest), function (_ref2) {
    var disabled = _ref2.disabled,
        checked = _ref2.checked,
        hasErrors = _ref2.hasErrors,
        focused = _ref2.focused;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(ToggleLabel, null, label, helpText && React__default.createElement(HelpText, null, " ", helpText), descText && React__default.createElement(DescText$2, null, descText)), React__default.createElement(Toggle, {
      checked: checked
    }));
  });
}).withConfig({
  displayName: "ToggleCheckbox",
  componentId: "sc-11ob8ah-4"
})(["position:relative;background-color:rgba(0,0,0,0.06);border-radius:6px;padding:0.75rem 1rem;min-height:36px;font-weight:600;font-weight:500;margin-bottom:1rem;cursor:pointer;display:flex;align-items:center;justify-content:space-between;:hover{background-color:rgba(0,0,0,0.08);}:active{background-color:rgba(0,0,0,0.1);}& ~ &{margin-top:-0.5rem;}", " ", ""], function (props) {
  return !props.noFocus && styled.css([":focus-within{background-color:rgba(0,0,0,0.09);:after{content:'';pointer-events:none;position:absolute;top:-3px;right:-3px;left:-3px;bottom:-3px;border-radius:9px;border:2px solid rgba(0,0,0,0.15);}}"]);
}, function (props) {
  return props.disabled && "\n    opacity: 0.8;\n    pointer-events:none;\n  ";
});

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n    min-width: 0;\n    ", "\n  "]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var TabButton = styled__default(components.Button).withConfig({
  displayName: "TabRadiobox__TabButton",
  componentId: "sc-1vu3bcn-0"
})(["width:100%;margin-left:0;padding:9px 1rem;flex-grow:1;background:", ";box-shadow:none;color:", ";border:1px solid ", ";border-left-width:0;height:100%;:hover{background:", ";}", " ", " ", " ", "  ", "  ", ""], function (props) {
  return props.white ? 'white' : utils.getColor('gray240');
}, utils.getColor('gray120'), utils.getColor('gray210'), function (props) {
  return polished.desaturate(0.6, polished.lighten(0.5, utils.getColor("main")(props)));
}, utils.ifProp('checked', styled.css(["&,&:hover{border-color:", ";background-color:", ";border-left-width:1px;color:#fff;cursor:default;}"], utils.getColor('main'), utils.getColor('main'))), function (props) {
  return props.isFirst && "\n    border-left-width: 1px;\n  ";
}, function (props) {
  return props.isFirst !== undefined && !props.isFirst && "\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n    :focus:after{\n      border-bottom-left-radius: 2px;\n      border-top-left-radius: 2px;\n    }\n  ";
}, function (props) {
  return props.isLast !== undefined && !props.isLast && "\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n    :focus:after{\n      border-bottom-right-radius: 2px;\n      border-top-right-radius: 2px;\n      z-index: 2;\n    }\n  ";
}, utils.media.mobile(_templateObject$7(), function (props) {
  return props.icon ? "\n      padding-left: 1.25rem;\n      padding-right: 1rem;\n    " : "\n      padding-left: 0.25rem;\n      padding-right: 0.25rem;\n    ";
}), utils.customTheme('TabButton'));
var InnerButton = styled__default.a.withConfig({
  displayName: "TabRadiobox__InnerButton",
  componentId: "sc-1vu3bcn-1"
})([""]);
var TabRadiobox = styled__default(function (_ref) {
  var isLast = _ref.isLast,
      isFirst = _ref.isFirst,
      label = _ref.label,
      white = _ref.white,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ["isLast", "isFirst", "label", "white", "icon"]);

  return React__default.createElement(Radiobox, props, function (_ref2) {
    var disabled = _ref2.disabled,
        checked = _ref2.checked,
        hasErrors = _ref2.hasErrors,
        focused = _ref2.focused;
    return React__default.createElement(TabButton, {
      innerAs: InnerButton,
      tabIndex: -1,
      focused: focused,
      isFirst: isFirst,
      isLast: isLast,
      checked: checked,
      disabled: disabled,
      white: white,
      icon: icon
    }, label);
  });
}).withConfig({
  displayName: "TabRadiobox",
  componentId: "sc-1vu3bcn-2"
})(["display:inline-block;"]);

var error = 'Error';
var messages = {
  required: error,
  minLength: function minLength(n) {
    return error;
  },
  confirmPassword: error,
  confirmEmails: error,
  emailValidation: error,
  SERVER_ERROR: error
};
var SERVER_ERROR = messages.SERVER_ERROR;
var setErrorMessages = function setErrorMessages(newMessages) {
  return messages = newMessages;
};

var onEmpty = function onEmpty(success, errors) {
  return Object.keys(errors).length ? errors : success;
};

var required = function required(s, k) {
  return !s && messages.required;
};
var minLength = function minLength(n) {
  return function (s, k) {
    return s && s.length < n && messages.minLength(n);
  };
};
var confirmPasswords = function confirmPasswords(passwordKey) {
  return function (confirm, k, props) {
    return (props[passwordKey] || confirm) && props[passwordKey] !== confirm && messages.confirmPassword;
  };
};
var confirmEmails = function confirmEmails(emailKey) {
  return function (confirm, k, props) {
    return (props[emailKey] || confirm) && props[emailKey] !== confirm && messages.confirmEmails;
  };
};
var emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
var emailValidation = function emailValidation(s, k) {
  return !emailRegex.test(s) && messages.emailValidation;
};
var optional = function optional(cb) {
  return function (v) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return v ? cb.apply(void 0, [v].concat(args)) : false;
  };
};
var buildValidation = function buildValidation(validations) {
  var custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  return function (props) {
    return onEmpty(false, _objectSpread({}, _flow(_entries, _map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      return [k, [].concat(v).map(function (fn) {
        return fn(_get(k, props), k, props);
      }).filter(function (_) {
        return _;
      })];
    }), _filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];

      return v.length;
    }), _fromPairs)(validations), utils.callIfFunction(custom, props)));
  };
};
var responseFailure = function responseFailure(fn) {
  return function (_, response, _ref5) {
    var setErrors = _ref5.setErrors;
    var errorSetter = setErrors;
    var r = [].concat(response, _);
    console.log(r);
    var error = fn.apply(void 0, _toConsumableArray(r));

    if (error === true) ; else if (error) {
      errorSetter(error);
    } else {
      errorSetter({
        "": [messages.SERVER_ERROR]
      });
    }
  };
};
var validation = {
  SERVER_ERROR: SERVER_ERROR,
  setErrorMessages: setErrorMessages,
  required: required,
  minLength: minLength,
  confirmPasswords: confirmPasswords,
  confirmEmails: confirmEmails,
  emailValidation: emailValidation,
  optional: optional,
  buildValidation: buildValidation,
  responseFailure: responseFailure
};

exports.AutoComplete = AutoComplete;
exports.AutoCompleteTextbox = AutoCompleteTextbox;
exports.BellowFieldDescription = BellowFieldDescription;
exports.Checkbox = Checkbox;
exports.CheckboxGroup = CheckboxGroup;
exports.Combobox = Combobox;
exports.ComboboxInput = ComboboxInput;
exports.ComboboxMenu = ComboboxMenu;
exports.ComboboxWithCustom = ComboboxWithCustom;
exports.ComponentMetaContext = ComponentMetaContext;
exports.ConfirmDialog = ConfirmDialog;
exports.ConfirmEditableBoxes = ConfirmEditableBoxes;
exports.DatePicker = DatePicker;
exports.EditableBox = EditableBox;
exports.EnhanceInput = EnhanceInput;
exports.ErrorFilterProvider = ErrorFilterProvider;
exports.Errors = Errors;
exports.ErrorsContext = ErrorsContext;
exports.ExpandableBox = ExpandableBox;
exports.Field = Field;
exports.FieldDescription = FieldDescription;
exports.FileInput = FileInput;
exports.FloatLabelTextInput = FloatLabelTextInput;
exports.Form = Form;
exports.FormContext = FormContext;
exports.FormDialog = FormDialog;
exports.FormMeta = FormMeta;
exports.FormValue = FormValue;
exports.HelpText = HelpText;
exports.IconRadioBox = IconRadioBox;
exports.IconRadioBoxIconContainer = IconRadioBoxIconContainer;
exports.IconRadioBoxText = IconRadioBoxText;
exports.IfFormValue = IfFormValue;
exports.InputboxGroup = InputboxGroup;
exports.Option = Option;
exports.PathContext = PathContext;
exports.Radiobox = Radiobox;
exports.RadioboxGroup = RadioboxGroup;
exports.RichText = RichText;
exports.RichTextContainer = RichTextContainer;
exports.RichTextInput = RichTextInput;
exports.SEPARATOR = SEPARATOR;
exports.SimpleCheckbox = SimpleCheckbox;
exports.SimpleRadiobox = SimpleRadiobox;
exports.TabButton = TabButton;
exports.TabRadiobox = TabRadiobox;
exports.TextInput = TextInput;
exports.ToggleCheckbox = ToggleCheckbox;
exports.WithForm = WithForm;
exports.WithImageInput = WithImageInput;
exports.checkErrors = checkErrors;
exports.enhanceInput = enhanceInput;
exports.enhancedInputDisplayName = enhancedInputDisplayName;
exports.getFormResponse = getFormResponse;
exports.getFormValues = getFormValues;
exports.useConfirmDialog = useConfirmDialog;
exports.useConfirmDialogWithProps = useConfirmDialogWithProps;
exports.useErrors = useErrors;
exports.useErrorsUtils = useErrorsUtils;
exports.useForm = useForm;
exports.useFormMeta = useFormMeta;
exports.useFormValue = useFormValue;
exports.useFormValueRef = useFormValueRef;
exports.useHasError = useHasError;
exports.useInput = useInput;
exports.useProvideErrors = useProvideErrors;
exports.useTextInput = useTextInput;
exports.useTransientErrorHelper = useTransientErrorHelper;
exports.validation = validation;
exports.withForm = withForm;
exports.withForm2 = withForm2;
exports.withFormImageInput = withFormImageInput;
